export const urData = {
  locale: {
    home_instavc_build:
      " تنظیموں اور ملازمین کے مابین معنی خیز تعلقات استوار کریں ",
    home_instavc_conference_platform:
      " کانفرنس پلیٹ فارم. n متوازی صارف کے تجربے کے ساتھ ",
    home_instavc_start_conference:
      " آغاز آغاز | کانفرنس میں شامل ہوں | انسٹا کانفرنس ",
    home_instavc_Hippa:
      "HIPAA ELIGIBLE AND PCI DSS, SOC, ISO/EIC 27001, ISO/EIC 27017, ISO/EIC 27018, AND ISO 9001 COMPLIANT.",
    home_instavc_copyrights:
      "© 2018 · instaVC · PeopleLink Unified Communications Pvt. Ltd.",
    home_instavc_terms_agree:
      " آغاز آغاز | کانفرنس میں شامل ہوں | انسٹا کانفرنس ",
    home_instavc_terms: " شرائط و ضوابط ",
    Plz_enter_class_name:"براہ کرم کلاس کا نام درج کریں۔",
    Plz_enter_class_description:"براہ کرم کلاس کی تفصیل درج کریں۔",

    visibility: " مرئیت",
    members: "ممبران",
    create_class: " کلاس بنائیں",
    public_class: "عوامی - صرف کلاس ممبران ہی شامل ہو سکتے ہیں۔",
    private_class: " پرائیویٹ - آپ کے ادارے میں کوئی بھی شامل ہو سکتا ہے۔",
    private: "  نجی",
    filter_by: " کی طرف سے فلٹر:",
    blocked: " مسدود",
    deleted: " حذف کر دیا گیا۔",
    unblock: " غیر مسدود کریں۔",
    make_active: " فعال بنائیں",
    addNewSubject: "  نیا مضمون شامل کریں۔",
    updateSubject: "موضوع کو اپ ڈیٹ کریں۔",
    addNewClass: "نئی کلاس شامل کریں۔",
    assign_teacher: " استاد کو تفویض کریں۔",
    exculde_students: " طلباء کو خارج کریں۔",
    dateOfJoining: "شمولیت کی تاریخ",
    classes: "کلاسز",
    users: "صارفین",
    classList: "کلاسز کی فہرست",
    add_teacher: "ٹیچر کو شامل کریں۔",
    add_student: "طالب علم شامل کریں۔",
    mySessions: "میرے سیشنز",
    reports: "رپورٹس",

    inclass_admin_teacher: "اساتذہ",
    inclass_admin_student: "طلباء",
    inclass_admin_studentName: "طالب علم کا نام",
    inclass_admin_studentID: "طالب علم کی شناخت",
    inclass_teacher_designation: "عہدہ",
    inclass_teacher_department: "شعبہ",
    inclass_student_rollnumber: "رول نمبر",
    inclass_teacher_status: "حالت",
    inclass_admin_user_info: "صارف کی معلومات",
    inclass_admin_professional_info: "پیشہ ورانہ معلومات",
    inclass_student_classname: "کلاس کا نام",

    instavc_login: " لاگ ان کریں ",
    instavc_login_email: " ای میل ",
    instavc_login_password: " پاس ورڈ ",
    instavc_login_button: " لاگ ان کریں ",
    instavc_login_forgotpassword: " پاسورڈ بھول گے؟",
    instavc_login_have_account: " کیا آپ کا اکاؤنٹ نہیں ہے؟",
    instavc_login_signup: " سائن اپ ",
    instavc_signup: " سائن اپ ",
    instavc_signup_firstname: " پہلا نام ",
    instavc_signup_lastname: " آخری نام ",
    instavc_signup_email: " ای میل ",
    instavc_signup_password: " پاس ورڈ ",
    instavc_signup_cpassword: " پاس ورڈ کی تصدیق کریں ",
    instavc_signup_button: " سائن اپ ",
    instavc_signup_already_have_account: " پہلے سے ہی ایک اکاؤنٹ ہے?",
    instavc_signup_login: " لاگ ان کریں ",
    instavc_signup_fname_error: " پہلا نام صرف حرفی ہونا چاہئے ",
    instavc_signup_lname_error: " آخری نام صرف حرفی ہونا چاہئے ",
    instavc_signup_email_error: " ای میل مناسب شکل میں ہونی چاہیے اور ای میل میں چھوٹے حروف ہونے چاہئیں ",
    instavc_signup_password_error:
      " پاس ورڈ آٹھ حروف کا ہونا چاہیے اور ایک بڑا حرف ، ایک چھوٹا حرف ، ایک ہندسہ اور ایک خاص حرف ہونا چاہیے۔",
    instavc_signup_cpassword_error:
      " تصدیق پاس ورڈ مندرجہ بالا پاس ورڈ سے مماثل ہونا چاہئے ",
    instavc_forgotpassword_link:
      "اپنے اکاؤنٹ سے وابستہ ای میل آئی ڈی درج کریں۔ آپ کا پاس ورڈ دوبارہ ترتیب دینے کے لیے ہم آپ کو ایک OTPمیل کریں گے۔",
    instavc_forgotpassword_email: "ای میل ایڈریس درج کریں۔",
    instavc_forgotpassword: " پاسورڈ بھول گے ",
    instavc_forgotpassword_button: " پاسورڈ بھول گے ",
    instavc_confirmpass_heading: " طالب علم بنائیں",
    instavc_confirmpass_verificationcode: " تصدیقی کوڈ درج کریں ",
    instavc_confirmpass_newpassword: " نیا پاس ورڈ درج کریں ",
    instavc_confirmpass_retypepassword: " نیا پاس ورڈ دوبارہ ٹائپ کریں ",
    instavc_confirmpass_button: "استاد بنائیں",
    instavc_forgotpassword_signin: " سائن ان ",
    instavc_forgotpassword_passwordcreated:
      " مبارک ہو! آپ کا نیا پاس ورڈ اپ ڈیٹ کر دیا گیا ہے، اب آپ inClass میں سائن ان کر سکتے ہیں۔",
    instavc_dashboard: " ڈیش بورڈ ",
    instavc_dashboard_schedule: " شیڈول سیشن",
    instavc_dashboard_meetinglist: "ماضی کے سیشنز",
    instavc_dashboard_conferenceplatform:
      " کانفرنس کے پلیٹ فارم جو صارف کے ایک بے مثال تجربے کے ساتھ ہیں ",
    instavc_dashboard_SC_room: " کانفرنس کا آغاز کریں ",
    instavc_dashboard_SC_roomlist: "اپنے طے شدہ سیشن کو منتخب کرکے",
    instavc_dashboard_startconference: " کانفرنس شروع کریں ",
    instavc_dashboard_JC: " کانفرنس میں شامل ہوں ",
    instavc_dashboard_JC_ID: " کانفرنس ID یا شیڈول کے ذریعے ",
    instavc_dashboard_JC_button: " کانفرنس میں شامل ہوں ",
    instavc_dashboard_SC: " کانفرنس کا آغاز کریں ",
    instavc_dashboard_SC_p2p: " اپنی فہرست میں سے ایک کمرہ منتخب کرکے ",
    instavc_dashboard_instaconference: " انسٹا کانفرنس ",
    instavc_dashboard_buynow: " ابھی خریدیں ",
    instavc_dashboard_myprofile: " میری پروفائل ",
    instavc_dashboard_settings: " ترتیبات ",
    instavc_dashboard_myadmin: " میرا ایڈمن ",
    instavc_dashboard_affiliate: " میرا ملحق ",
    instavc_dashboard_logout: " لاگ آوٹ ",
    conference_myrooms: " میرے کمرے ",
    conference_myrooms_host: " ٹیچر کی شناخت",
    conference_myrooms_roomhost: " آپ اس کمرے کے میزبان ہیں۔",
    conference_myrooms_search: " تلاش کریں ...",
    conference_myrooms_hostuser: " میزبان صارف ",
    conference_myrooms_gotopremium: " پریمیم پر جائیں ",
    conference_myrooms_buynow: " ابھی خریدیں ",
    conference_myrooms_renewal: " تجدید ",
    conference_setup: " سیٹ اپ ",
    conference_myrooms_renewnow: " ابھی تجدید کریں ",
    // "conference_myrooms_hosts": " میزبان ",
    conference_myrooms_join: " شامل ہوں ",
    conference_myrooms_setup: " کمرہ سیٹ اپ ",
    conference_myrooms_sethost_email:
      " اپنے آپ کو میزبان کی حیثیت سے متعین کریں ، یا اسے بطور میزبان بنانے کیلئے صارف کا ای میل پتہ درج کریں۔",
    conference_myrooms_selfhost: " اپنے آپ کو میزبان کی حیثیت سے طے کریں ",
    conference_myrooms_otherhost:
      " یا - اگر آپ کسی بھی صارف کو بطور میزبان بنانا چاہتے ہیں تو ، اس کا ای میل ایڈریس درج کریں۔",
    conference_myrooms_email: " ای میل اڈریس ",
    Cancel: " کینسل ",
    conference_myrooms_apply: " درخواست دیں ",
    view_schedule_myrooms: " میرے کمرے ",
    view_schedule_search: " تلاش کریں ...",
    view_schedule_schedule: " شیڈول",
    view_schedule_calender:
      " اس کمرے کے نظام الاوقات کو جانچنے کیلئے کیلنڈر ذیل میں ہے ",
    video_recordings: " ویڈیو ریکارڈنگ ",
    view_recordings_search: " تلاش کریں ",
    view_recordings_month: " اس مہینے ",
    view_recordings_week: " آخری 7 دن ",
    view_recordings_today: " آج ",
    no_recordings: " ابھی تک کوئی ریکارڈنگ نہیں!",
    no_recordings_message: " ابھی یہاں کوئی ویڈیو نہیں ہے۔",
    no_recordings_startmessage:
      " ایک بار ریکارڈنگ شروع کرنے کے بعد آپ اپنے تمام ویڈیوز یہاں دیکھ سکتے ہیں۔",
    stop_recording: " کیا آپ اس ریکارڈنگ کو روکنا چاہتے ہیں؟",
    stop_recording_agree: " متفق ہوں ",
    stop_recording_disagree: " متفق نہیں ",
    conference_in_use: " کانفرنس مستعمل ہے ",
    conference_mode: " کانفرنس موڈ ",
    large_conference_mode: " کانفرنس کا بڑا طریقہ ",
    conference_setup_configuration: " تشکیل ",
    conference_setup_generateid: "کوئی سیشن آئی ڈی نہیں ملا، ایک بنائیں!",
    conference_setup_regenerate: " دوبارہ تخلیق کریں ",
    conference_setup_meetingid: "سیشن کی شناخت",
    conference_setup_camera: " فیس ٹائم ایچ ڈی کیمرہ ",
    conference_setup_defaultmicrophone:
      " پہلے سے طے شدہ - اندرونی مائکروفون (بلٹ ان)",
    conference_setup_microphone: " اندرونی مائکروفون (بلٹ ان)",
    conference_setup_volume: " حجم ",
    conference_setup_videomode: " ویڈیو موڈ ",
    conference_setup_forward: " آگے ",
    conference_setup_mix: " مکس کریں ",
    conference_setup_invite: " مدعو کریں ",
    conference_setup_invitepeople: " لوگوں کو مدعو کریں ",
    conference_setup_invitefriends:
      " اپنے دوستوں اور ساتھی کارکنوں کو تعاون کے لئے مدعو کریں۔",
    conference_setup_invite_directlink: " اپنے کمرے سے براہ راست لنک ",
    conference_setup_invite_sharelink:
      " شرکاء میں شامل ہونے کے لئے لنک شیئر کریں ",
    conference_setup_invite_link:
      "https://connect.instavc.com/conference-guest/eddca0fc7adcdc61a24dabe02597412a36bb96dac7302f3cedb6aac50169d58614eb46b940b556a9/f",
    conference_setup_invitebyemail: " بذریعہ میل دعوت دیں ",
    conference_setup_invite_enteremail:
      " اپنے شرکا کو مدعو کرنے کے لئے ترجیحی ای میل ایڈریس درج کریں ",
    conference_setup_invite_emailid: " ای میل اڈریس ",
    conference_setup_invite_close: " بند کریں ",
    conference_setup_invite_button: " مدعو کریں ",
    conference_setup_advancesettings: " ایڈوانس سیٹنگیں ",
    conference_setup_changeresolution: " قرارداد منتخب کریں ",
    conference_setup_lowbandwidth: " کم بینڈوتھ ",
    conference_setup_poornetwork: " ناقص نیٹ ورک ",
    conference_setup_vga: "VGA - (640x480)",
    conference_setup_vga_graphics:
      " ویڈیو گرافکس اری (وی جی اے) ویڈیو ریزولوشن کیلئے ",
    conference_setup_hd1080: "HD1080p - (1920x1080)",
    conference_setup_fhd:
      " مکمل ہائی ڈیفینیشن (ایف ایچ ڈی) ویڈیو ریزولوشن کے ل ",
    conference_setup_4k: "4K - (3840 x 2160)",
    conference_setup_4k_fhd:
      " مکمل ہائی ڈیفینیشن (ایف ایچ ڈی) ویڈیو ریزولوشن کے ل ",
    conference_setup_sif: "SIF - (320x240)",
    conference_setup_sif_vr: " SIF ویڈیو قرارداد کے ل. ",
    conference_setup_hd720: "HD720p - (1280x720)",
    conference_setup_hd720_vr: " ہائی ڈیفینیشن (ایچ ڈی) ویڈیو ریزولوشن کے ل ",
    conference_setup_2k: "2K - (2048×1080)",
    conference_setup_2k_fhd:
      " مکمل ہائی ڈیفینیشن (ایف ایچ ڈی) ویڈیو ریزولوشن کے ل ",
    conference_setup_broadcastoptions: " براڈکاسٹ اختیارات ",
    conference_setup_enable: " فعال ",
    conference_setup_disable: " غیر فعال کریں ",
    conference_setup_reportquality:
      " صوتی اور ویڈیو کالز کو بہتر بنانے میں مدد کے لئے معیار کے اعدادوشمار کی اطلاع دیں ",
    conference_setup_havetroubleshoot:
      " کیا آپ کانفرنس ٹربلشوٹ کرنا چاہتے ہیں ، پھر لنک کو یہاں کلک کریں ",
    conference_setup_conferencetroubleshoot: " کنفرمنس ٹرالی شوٹر ",
    conference_troubleshoot: " دشواری حل ",
    conference_troubleshoot_faq: " عمومی سوالات ",
    conference_troubleshoot_emailreport: " ای میل کی اطلاع ",
    conference_troubleshoot_gotoconference: " کانفرنس میں جائیں ",
    conference_troubleshoot_os: " آپریٹنگ سسٹم ",
    conference_troubleshoot_version: " ورژن ",
    conference_troubleshoot_browser: " براؤزر ",
    conference_troubleshoot_chromeversion: " کروم ورژن ",
    conference_troubleshoot_privatebrowsing: " نجی براؤزنگ ",
    conference_troubleshoot_displayresolution: " قراردادیں دکھائیں ",
    conference_troubleshoot_aspectratio: " پہلو کا تناسب دکھائیں ",
    conference_troubleshoot_hasspeakers: " سسٹم میں اسپیکر ہیں؟",
    conference_troubleshoot_foundspeaker: " اسپیکر کے آلے ملے ",
    conference_troubleshoot_hasmicrophone: " سسٹم میں مائکروفون ہے؟",
    conference_troubleshoot_foundmicrophone: " مائیکروفون آلات ملا ",
    conference_troubleshoot_haswebcam: " سسٹم میں ویب کیم ہے؟",
    conference_troubleshoot_foundcameras: " ملا کیمرا ڈیوائسز ",
    conference_troubleshoot_webcampermission:
      " ویب سائٹ پر ویب کیم کی اجازت ہے؟",
    conference_troubleshoot_microphonepermission:
      " ویب سائٹ میں مائکروفون کی اجازت ہے؟",
    conference_troubleshoot_getUsermedia:
      " براؤزر اس صفحے پر یوزر میڈیا کی اجازت دیتا ہے؟",
    conference_troubleshoot_changeoutput_audiodevice:
      " کیا آپ آؤٹ پٹ آڈیو ڈیوائسز کو تبدیل کرسکتے ہیں؟",
    conference_troubleshoot_changecamera_resolution:
      " کیا آپ نئی کانفرنس کی درخواست کئے بغیر کیمرا قراردادوں کو تبدیل کرسکتے ہیں؟",
    conference_troubleshoot_supportwebrtc:
      " براؤزر WebRTC کی حمایت کرتا ہے (یا تو 1.0 یا 1.1)؟",
    conference_troubleshoot_supportortc:
      " براؤزر ORTC (WebRTC 1.1) کی حمایت کرتا ہے؟",
    conference_troubleshoot_turnserver: " کیا ٹرن سرور قابل رسائی ہے؟",
    conference_troubleshoot_turn: "turn:139.59.64.172:443",
    conference_troubleshoo_coturn: "turn:coturn.instavc.com:443",
    conference_troubleshoot_replacetracks:
      " کیا آپ ساتھیوں کے ساتھ بات چیت کیے بغیر پٹریوں کی جگہ لے سکتے ہیں؟",
    conference_troubleshoot_record_remoteaudio:
      " کیا آپ کا براؤزر ریموٹ آڈیو ریکارڈ کرسکتا ہے یا WebAudio API میں ریموٹ آڈیو اسٹریم پر کارروائی کرسکتا ہے؟ ",
    conference_troubleshoot_browsersupports_websocketapi:
      " براؤزر WebSocket API کی حمایت کرتے ہیں ",
    conference_troubleshoot_blockwebsocket:
      " آپ کے سسٹم نے ویب ساکٹس کا پروٹوکول مسدود کردیا ہے ، یا ویب ساکٹس سرور قابل رسائی نہیں ہے؟ نہیں ",
    conference_troubleshoot_supportwebaudioapi:
      " براؤزر WebAudio API کی حمایت کرتا ہے؟",
    conference_troubleshoot_supportsctp:
      " براؤزر ایس سی ٹی پی ڈیٹا چینلز کی حمایت کرتا ہے؟",
    conference_troubleshoot_supportsrtp:
      " براؤزر آر ٹی پی ڈیٹا چینلز کی حمایت کرتا ہے؟",
    conference_troubleshoot_support_screencapturing:
      " یہ صفحہ اسکرین کیپچرنگ API کی حمایت کرتا ہے؟",
    conference_troubleshoot_support_multimonitor:
      " کیا براؤزر ملٹی مانیٹر سلیکشن اور کسی مانیٹر کی اسکرین پر قبضہ کرنے کی حمایت کرتا ہے؟",
    conference_troubleshoot_mobiledevice: " کیا یہ موبائل ڈیوائس ہے؟",
    conference_troubleshoot_supportscreencap_canvas:
      " کیا براؤزر کینوس سے اسکرین کی گرفتاری کی حمایت کرتا ہے؟",
    conference_troubleshoot_supportscreencap_video:
      " کیا براؤزر ویڈیو سے اسکرین کی گرفتاری کی حمایت کرتا ہے؟",
    conference_troubleshoot_supportpromisses:
      " کیا براؤزر وعدوں کی حمایت کرتا ہے؟",
    conference_troubleshoot_ipaddress: " IP پتے ظاہر کرنے کے لئے کلک کریں ",
    conference_troubleshoot_stunserver: " کیا اسٹن سرور قابل رسائ ہے؟",
    back: "پیچھے",
    instavc_conference_revoke_fromhost: " میزبان سے منسوخ کریں ",
    instavc_conference_startvideoconf_button: " ویڈیو کانفرنس شروع کریں ",
    instavc_conference_loading: " اپنی اسکرین لوڈ کر رہا ہے ",
    instavc_conference_authenticating:
      " انسٹاکیسی سرور میں تصدیق کر رہا ہے ....",
    instavc_conference_joinconference: " کانفرنس میں شرکت کرنا ",
    instavc_conference_publishyourvideo: " آپ کا ویڈیو شائع کرنا ",
    instavc_conference_publishyouraudio: " آپ کا آڈیو شائع کرنا ",
    instavc_conference_settings: " ترتیبات ",
    instavc_conference_setting: " کانفرنس کی ترتیبات ",
    instavc_conference_setting_source: " ذریعہ ",
    instavc_conference_setting_camera: " کیمرہ ",
    instavc_conference_audioinputs: " آڈیو آدانوں ",
    instavc_conference_setting_apply: " درخواست دیں ",
    instavc_conference_setting_resolution: " نتیجہ ",
    instavc_conference_setting_qr: " کیو آر (بیٹا)",
    instavc_conference_whiteboard: " وائٹ بورڈ ",
    instavc_conference_screenshare: " اسکرین شیئر ",
    instavc_conference_presenter: " پیش کنندہ ",
    instavc_conference_stopshare: " بانٹیں بانٹیں ",
    instavc_conf_install_Screenshare: " اسکرین شیئر انسٹال کریں ",
    instavc_conference_videosync: " ایک ساتھ دیکھیں ",
    instavc_conference_videourl: " ویڈیو یو آر ایل ",
    instavc_conference_enter_videourl: " ویڈیو یو آر ایل درج کریں ",
    instavc_conference_videourl_note:
      " نوٹ: صرف متحرک شرکاء ہی اس ویڈیو کو دیکھ سکتے ہیں ، دیر سے شامل افراد ویڈیو نہیں دیکھ سکتے ہیں ",
    instavc_conf_recordings: " ریکارڈنگ ",
    instavc_conference_sharecontent: " اپنی اسکرین کا اشتراک کریں ",
    instavc_conference_sharecontent_screen:
      " Connect.instavc.com آپ کی سکرین کے مندرجات کا اشتراک کرنا چاہتا ہے۔ آپ جس کا اشتراک کرنا چاہیں اس کا انتخاب کریں ",
    instavc_conference_shareentire_screen: " آپ کی پوری اسکرین ",
    instavc_conference_sharescreen_applicationwindow: " درخواست ونڈو ",
    instavc_conference_sharescreen_chrometab: " کروم ٹیب ",
    instavc_conference_sharescreen_share: " بانٹیں ",
    instavc_conf_sharescreen: " آپ اپنی اسکرین شیئر کر رہے ہیں!",
    instavc_conf_share_otherparticipants:
      " دوسرے شرکاء آپ کی سکرین پر موجود درخواستیں اور دستاویزات دیکھ سکتے ہیں ",
    instavc_stopsharing: " بانٹنا بند کریں ",
    instavc_conference_chat: " چیٹ ",
    instavc_conference_additional_camera: " اضافی کیمرہ ",
    instavc_conference_sharescreen_groupchat: " گروپ چیٹ ",
    instavc_conference_sharescreen_GC: "GC",
    instavc_conference_entermessage: " کچھ بولیں!",
    instavc_conference_adddevice: " آلات شامل کریں ",
    instavc_conference_adddevice_addcamera: " کیمرا شامل کریں ",
    instavc_conference_adddevice_source: " ذریعہ ",
    instavc_conference_adddevice_camera: " کیمرہ ",
    instavc_conference_adddevice_cameraname: " فیس ٹائم ایچ ڈی کیمرہ ",
    instavc_conference_adddevice_close: " بند کریں ",
    instavc_conference_adddevice_publish: " اشاعت ",
    instavc_conference_info: " معلومات ",
    questions: " سوالات ",
    instavc_conference_askquestions: " سوالات پوچھیے ",
    instavc_conference_info_meetingid: "ذاتی سیشن ID",
    instavc_conference_fullscreen: " مکمل اسکرین یا بڑی اسکرین ",
    conference_setup_invitepeoplel: " لوگوں کو مدعو کریں ",
    conference_setup_invite_linktojoin:
      "https://connect.instavc.com/conference-guest/93ac2135d88727ca29061b4b6bf9477bc8f285a8121ff580649512abad353fbc6751a134d56438f7/f",
    conference_setup_invite_byemail: " بذریعہ میل دعوت دیں ",
    instavc_conference_participants: " امیدوار ",
    instavc_conference_participants_search: " تلاش کریں ...",
    instavc_conference_participant: " شریک ",
    instavc_conference_participants_muteall: " سب کو خاموش کریں ",
    instavc_conference_participants_unmuteall: " سب کو خاموش کریں ",
    instavc_conference: " کانفرنس ",
    instavc_conf_more: " مزید ",
    instavc_conference_picturemode: " یہ ویڈیو پکچر ان پکچر موڈ میں چل رہا ہے ",
    instavc_conference_mediastreams_stats: " میڈیا اسٹریم کے اعدادوشمار ",
    instavc_conference_mediastreams_audio: " آڈیو ",
    instavc_conference_mediastreams_audio_send: " بھیجیں ",
    instavc_conference_mediastreams_audio_codec: " کوڈیک ",
    instavc_conference_mediastreams_audio_rates: " قیمتیں (کے بی پی ایس)",
    instavc_conference_mediastreams_audio_lost: " کھو دیا ",
    instavc_conference_mediastreams_audio_fraction: " کسر ",
    instavc_conference_mediastreams_video: " ویڈیو ",
    instavc_conference_mediastreams_video_send: " بھیجیں ",
    instavc_conference_mediastreams_video_codec: " کوڈیک ",
    instavc_conference_mediastreams_video_rates: " قیمتیں (کے بی پی ایس)",
    instavc_conference_mediastreams_video_lost: " کھو دیا ",
    instavc_conference_mediastreams_video_fraction: " کسر ",
    instavc_conference_resolution: " قرارداد ",
    instavc_conference_framerate: " فریم کی شرح ",
    instavc_conference_nack: " نیک ",
    instavc_conference_pli: " پی ایل آئی ",
    instavc_conference_bw: " دستیاب BW ",
    instavc_conference_audiomuted: " آڈیو خاموش ",
    instavc_conference_microphonemuted: " آپ کا مائکروفون خاموش ہوگیا ",
    join_conference_join_meetinginvitation: "سیشن کے دعوت نامے میں شامل ہوں۔",
    join_conference_search: " تلاش کریں ...",
    "join_conference_meeting details":
      " ملاقات کا نام  n مدعو کردہ: inv n دعوت نامہ ",
    join_conference_join: " شامل ہوں ",
    join_conference_nomeetings: "کوئی سیشن نہیں۔",
    join_conference_noupcomingmeetings:
      "افوہ! آپ کے پاس ابھی تک کوئی آنے والے سیشن نہیں ہیں!",
    insta_conference_mycontacts: " میرے رابطے ",
    insta_conference_search: " تلاش کریں ...",
    insta_conference_typemessage: " ایک پیغام ٹائپ کریں ",
    insta_conference_addcontact: " رابطہ شامل کریں ",
    insta_conference_enteremail: " میل آئی ڈی درج کریں ",
    insta_conference_add: " شامل کریں ",
    insta_conference_nouserfound:
      " اس ای میل پتے کے ساتھ ایسا کوئی صارف نہیں ملا ",
    instavc_conf_callnot_allowed:
      " جب آپ پہلے سے ہی کال میں ہوتے ہیں تو آپ دوسرے صارفین کو کال نہیں کرسکتے ہیں ",
    insta_conference_pendingapproval: " زیر التواء منظوری ",
    insta_conference_outgoingvideocall: " سبکدوش ہونے والا ویڈیو کال ",
    insta_conference_calling: " کالنگ ....",
    insta_conference_incomingvideocall: " آنے والی ویڈیو کال ",
    insta_conference_calldecline: " رد ",
    insta_conference_callaccept: " قبول کریں ",
    insta_conference_instavcalert: " Connect.instavc.com اجازت دینا چاہتا ہے ",
    insta_conference_usemicrophone: " اپنا مائکروفون استعمال کریں ",
    insta_conference_usecamera: " اپنا کیمرا استعمال کریں ",
    insta_conference_blockdevices: " بلاک کریں ",
    insta_conference_allowdevices: " اجازت دیں ",
    instavc_schedulemeeting_createmeeting: "نیا سیشن بنائیں / ترمیم کریں۔",
    instavc_schedulewebinar_createmeeting: " نیا ویبینار / ترمیم بنائیں ",
    instavc_schedulemeeting_meetingname: "اپنے سیشن کو ایک نام دیں۔",
    instavc_schedulemeeting_selectnames_tomeeting:
      "اپنے سیشن کے لیے ایک کمرہ منتخب کریں۔",
    instavc_schedulemeeting_setduration: " دورانیہ طے کریں ",
    instavc_schedulemeeting_15min: "15 منٹ ",
    instavc_schedulemeeting_30min: "30 منٹ ",
    instavc_schedulemeeting_60min: "60 منٹ ",
    instavc_schedulemeeting_setcustom: " کسٹم مقرر کریں ",
    instavc_schedulemeeting_customduration: " کسٹم دورانیہ ",
    instavc_schedulemeeting_minutes: " منٹ ",
    instavc_schedulemeeting_setconfpassword:
      " اپنے کانفرنس کا پاس ورڈ ترتیب دیں ",
    instavc_schedulemeeting_typepassword: "اپنے سیشن کے لیے پاس ورڈ ٹائپ کریں۔",
    instavc_schedulemeeting_conferencecolor:
      " اپنی کانفرنس کے آئیکن کو رنگ دیں ",
    instavc_schedulemeeting_invitepeople: "لوگوں کو اس سیشن میں مدعو کریں۔",
    instavc_schedulemeeting_search: " تلاش کریں ...",
    instavc_schedulemeeting_SM: "SM",
    instvc_SM_message:
      " مجاز صارف کے لائسنس والے صارفین کی تعداد نے لائسنس کی حد سے تجاوز کیا ہے۔ اگر آپ زیادہ سے زیادہ لوگوں کو مدعو کرنا چاہتے ہیں تو آپ کر سکتے ہیں ",
    instavc_SM_message_href: " پریمیم پر جائیں ",
    instavc_schedulemeeting_notify:
      "منتخب لوگوں کو اس سیشن کے بارے میں مطلع کریں۔",
    instavc_schedulemeeting_addreminder: " یاد دہانیاں شامل کریں ",
    instavc_schedulemeeting_add: " شامل کریں ",
    instavc_schedulemeeting_addmeetingreminder: "سیشن یاد دہانی شامل کریں۔",
    instavc_schedulemeeting_adddatetime: " تاریخ چنندہ ، وقت چننے والا ",
    instavc_schedulemeeting_apply: " درخواست دیں ",
    instavc_schedulemeeting_name: "براہ کرم سیشن کا نام درج کریں۔ ",
    instavc_schedulemeeting_selectroom: " براہ کرم کمرہ منتخب کریں ",
    instavc_schedulemeeting_selectduration: " براہ کرم مدت منتخب کریں ",
    instavc_recuring_schedule: " بار بار چلنے والا نظام الاوقات ",
    instavc_schedulemeeting_nothinginreminders: " یاد دہانیوں میں کچھ نہیں ",
    instavc_schedulemeeting_createbutton: " بنانا ",
    instavc_schedulemeeting_createdsuccessfully:
      " نظام الاوقات کامیابی کے ساتھ تشکیل دیا گیا ",
    instavc_meetinglist_calender: " کیلنڈر ",
    instavc_meetinglist_selecteddates: " آپ کی منتخب کردہ تاریخیں ",
    instavc_meetinglist_schedulecreted: " شیڈول بنائے گئے ",
    instavc_meetinglist_pastschedule: " ماضی کا نظام الاوقات ",
    instavc_meetinglist: "سیشن کی فہرست",
    instavc_meetinglist_meetingdetils:
      "سیشن کا نام، سیشن کا وقت، ترتیب دیا گیا۔",
    instavc_meetinglist_search: " تلاش کریں ...",
    instavc_meetinglist_deleterecuring:
      " بار بار چلنے والا نظام الاوقات حذف کریں ",
    instavc_meetinglist_alow_deleterecuring:
      " کیا آپ صرف حالیہ شیڈول یا تکرار کے تمام نظام الاوقات کو حذف کرنا چاہیں گے؟",
    instavc_meetinglist_schedule_series:
      " سیریز کے دیگر تمام نظام الاوقات باقی رہیں گے:",
    instavc_meetinglist_schedule_seriesdelete:
      " سیریز کے تمام شیڈول حذف کردیئے جائیں گے:",
    instavc_meetinglist_allrecuringsch: " تمام بار بار چلنے والی فہرستیں ",
    instavc_meetinglist_cancelchanges: " تبدیلیاں منسوخ کریں ",
    instavc_meetinglist_noschedules: " کوئی شیڈول نہیں ہے ",
    instavc_ml_schedulemessage:
      "ابھی تک کوئی سیشن شیڈول نہیں بنایا گیا ہے! نیچے دیئے گئے بٹن پر کلک کرکے اپنا شیڈول بنائیں۔",
    instavc_create_schedule: " نظام الاوقات بنائیں ",
    instavc_meetinglist_currentschedule: " موجودہ نظام الاوقات ",
    instavc_meetinglist_join: " شامل ہوں ",
    instavc_meetinglist_buynow: " ابھی خریدیں ",
    instavc_dashboard_chooseplan: " ایک منصوبہ منتخب کریں ",
    instavc_package_smbplan: " ایس ایم بی کے منصوبے ",
    instavc_package_smbplan_host: "(میزبان مبنی لائسنس)",
    instavc_package_smbplandescription:
      " ایک کمرے میں ایک وقت میں صرف 1 میزبان ہوسکتے ہیں۔ ایک خریدار میزبان اکاؤنٹ کو ترتیب یا تبدیل کرسکتا ہے ، جو کمرے کو کنٹرول کرسکتا ہے۔ کال کے دوران میزبان رسوں کو شیئر نہیں کیا جاسکتا۔ دوسرے تمام صارفین اس وقت تک بات چیت نہیں کرسکتے ہیں جب تک کہ میزبان کانفرنس میں شامل نہ ہوں۔",
    instavc_package_basic: " بنیادی ",
    instavc_package_hostuser_smb: "1 میزبان اور ",
    instavc_package_hostuser_smb_users: " صارفین ",
    instavc_package_currency: "$",
    instavc_package_permonth: "/ مہینہ ",
    instavc_package_bill_smb: " سالانہ بل ",
    instavc_package_include_smb: " اس پیکیج کے ساتھ شامل ہیں ",
    instavc_package_specifictions_Whiteboard: " وائٹ بورڈ ",
    instavc_package_specifictions_Screen: " اسکرین شیئر ",
    instavc_package_specifictions_nChat: " چیٹ ",
    instavc_package_specifictions_Recording: " ریکارڈنگ ",
    instavc_package_specifictions_PresenterMode: " پیش کنندہ موڈ ",
    instavc_package_buynowbutton: " ابھی خریدیں ",
    instavc_package_fullfeatures_smb: " مکمل خصوصیات ",
    instavc_package_billinginfo: " بلنگ کی معلومات ",
    instavc_package_billinginfo_name: " نام ",
    instavc_package_billinginfo_orginazation: " تنظیم ",
    instavc_package_biilinginfo_gstin: " جی ایس ٹی این ",
    Save: " محفوظ کریں ",
    instavc_package_billinginfo_edit: " ترمیم ",
    instavc_package_billingdetails: " بل کی تفصیلات ",
    instavc_package_billingdetails_firstname: " پہلا نام ",
    instavc_package_billingdetails_lastname: " آخری نام ",
    instavc_package_billingdetails_address: " پتہ ",
    instavc_package_billingdetails_zip: " زپ کوڈ ",
    instavc_package_shippinginfo: " سامان بھیجنے کی معلومات ",
    instavc_package_shippinginfo_edit: " ترمیم ",
    instavc_package_shippingdetails: " شپنگ کی تفصیلات ",
    instavc_package_shippingdetails_firstname: " پہلا نام ",
    instavc_package_shippingdetails_lastname: " آخری نام ",
    instavc_package_shippingdetails_address: " پتہ ",
    instavc_package_shippingdetails_zip: " زپ کوڈ ",
    instavc_package_cartsummary: " ٹوکری کا خلاصہ ",
    instavc_package_hostbase: " میزبان بیسڈ لائسنس (لائسنس کا نام)",
    instavc_package_smbplan_basic: " ایس ایم بی پلان - بنیادی ",
    instavc_package_plandetails: "$ 144.02\n\n1 سال کا بل ہے\n$ 13 فی مہینہ ",
    instavc_package_term: " انتہا ",
    instavc_package_1year: "1 سال ",
    instavc_package_2years: "2 سال ",
    instavc_package_3years: "3 سال ",
    instavc_package_4years: "4 سال ",
    instavc_package_5years: "5 سال ",
    instavc_package_subtotal: " کل ",
    instavc_package_taxes: " ٹیکس اور فیس (جی ایس ٹی + 18٪)",
    instavc_package_launchoffer: " لانچافر ",
    instavc_package_promo: " پرومو کامیابی کے ساتھ نافذ ہوا ",
    instavc_package_remove: " دور ",
    instavc_package_havepromocode: " پرومو کوڈ ہے؟ یہاں درخواست دیں ",
    instavc_package_entercouponcode: " براہ کرم درست کوپن کوڈ درج کریں ",
    instavc_package_total: " کل ",
    instavc_package_offerdisclaimer: " آفر ڈس کلیمر دیکھیں ",
    instavc_package_paynow: " اب ادا ",
    instavc_package_payment_instavclicense:
      " پیپل لنک یونیفائیڈ کمیونی کیشن  n انسدادکا لائسنس کی ادائیگی ",
    instavc_package_phone: " فون ",
    instavc_package_entervalid_contactnumber:
      " براہ کرم درست رابطہ نمبر درج کریں ",
    instavc_package_email: " ای میل ",
    instavc_package_enteremail:
      " براہ کرم ایک درست ای میل آئی ڈی درج کریں۔ مثال: you@example.com ",
    instavc_package_paybycard: " کارڈ کے ذریعہ ادائیگی کریں ",
    instavc_package_securedbyrazorpay: " ریزر پے کے ذریعہ محفوظ ",
    instavc_package_card: " کارڈ ",
    instavc_package_enterotp:
      " محفوظ شدہ کارڈ تک رسائی حاصل کرنے کیلئے x n xxxxxxxxxxx پر بھیجا گیا OTP درج کریں ",
    instavc_package_resendotp: " او ٹی پی کو دوبارہ بھیجیں ",
    instavc_package_skipsavedcards: " محفوظ کارڈز چھوڑ دیں ",
    instavc_package_enter_otp: " براہ کرم OTP درج کریں ",
    instavc_package_skipthesavedcards: " محفوظ شدہ کارڈز چھوڑ دیں ",
    instavc_package_cardnumber: " کارڈ نمبر ",
    instavc_package_entervalid_cardnumber:
      " براہ کرم ایک درست کارڈ نمبر درج کریں ",
    instavc_package_expiry: " میعاد ختم ہونا ",
    instavc_package_cardholdername: " کارڈ ہولڈر کا نام ",
    instavc_package_cvv: "CVV",
    instavc_package_3digitcode:
      " آپ کا کارڈ کے پچھلے حصے میں یہ ایک 3 ہندسوں کا کوڈ ہے ",
    instavc_package_pay: " ابھی ادا کریں ",
    instavc_package_remembercard: " کارڈ یاد رکھیں ",
    instavc_package_medium: " میڈیم ",
    instavc_package_hostuser_medium: "1 میزبان اور 50 صارفین ",
    instavc_package_month_medium: "$ 15 / مہینہ ",
    instavc_package_bill_medium: " بلنگ سالانہ + جی ایس ٹی 18٪",
    instavc_package_include_medium: " اس پیکیج کے ساتھ شامل ہیں ",
    instavc_package_specifictions_medium:
      " وائٹ بورڈ  n اسکرین شیئر  n چیٹ  n ریکارڈنگ  n پریسنٹر موڈ ",
    instavc_package_buynow_medium: " ابھی خریدیں ",
    instavc_package_fullfeatures_medium: " مکمل خصوصیات ",
    instavc_package_advanced: " اعلی درجے کی ",
    instavc_package_hostuser_advanced: "1 میزبان اور 100 صارف ",
    instavc_package_month_advanced: "$16/ مہینہ ",
    instavc_package_bill_advanced: " بلنگ سالانہ + جی ایس ٹی 18٪",
    instavc_package_include_advanced: " اس پیکیج کے ساتھ شامل ہیں ",
    instavc_package_specifictions_advanced:
      " وائٹ بورڈ  n اسکرین شیئر  n چیٹ  n ریکارڈنگ  n پریسنٹر موڈ ",
    instavc_package_buynow_advanced: " ابھی خریدیں ",
    instavc_package_fullfeatures_advanced: " مکمل خصوصیات ",
    instavc_package_virtualmcu: " ورچوئل ایم سی یو لائسنس ",
    instavc_package_virtualmcu_room: "(کمرے پر مبنی لائسنس)",
    instavc_package_vmcudetails:
      " ایک کمرے میں ایک وقت میں صرف 1 میزبان ہوسکتے ہیں۔ ایک خریدار میزبان اکاؤنٹ کو ترتیب یا تبدیل کرسکتا ہے ، جو کمرے کو کنٹرول کرسکتا ہے۔ کال کے دوران میزبان رسوں کو شیئر نہیں کیا جاسکتا۔ دوسرے تمام صارفین اس وقت تک بات چیت نہیں کرسکتے ہیں جب تک کہ میزبان کانفرنس میں شامل نہ ہوں۔",
    instavc_package_instavc: " انسٹا وی سی ",
    instavc_package_silver: " سلور ",
    instavc_package_userrooms_silver_users: " صارفین ",
    instavc_package_userrooms_silver_rooms: " کمرے ",
    instavc_package_month_silver: "$281/ مہینہ ",
    instavc_package_bill_silver: " بلنگ سالانہ + جی ایس ٹی 18٪",
    instavc_package_include_silver: " اس پیکیج کے ساتھ شامل ہیں ",
    instavc_package_specifictions_silver:
      " وائٹ بورڈ  n اسکرین شیئر  n چیٹ  n ریکارڈنگ  n پریسنٹر موڈ ",
    instavc_package_buynow_silver: " ابھی خریدیں ",
    instavc_package_fullfeatures_silver: " مکمل خصوصیات ",
    instavc_package_gold: " سونا ",
    instavc_package_userrooms_gold: "200 صارف - 30 کمرے ",
    instavc_package_month_gold: "$467/ مہینہ ",
    instavc_package_bill_gold: " بلنگ سالانہ + جی ایس ٹی 18٪",
    instavc_package_include_gold: " اس پیکیج کے ساتھ شامل ہیں ",
    instavc_package_specifictions_gold:
      " وائٹ بورڈ  n اسکرین شیئر  n چیٹ  n ریکارڈنگ  n پریسنٹر موڈ ",
    instavc_package_buynow_gold: " ابھی خریدیں ",
    instavc_package_fullfeatures_gold: " مکمل خصوصیات ",
    instavc_package_platinum: " پلاٹینم ",
    instavc_package_userrooms_platinum: "500 صارفین - 50 کمرے ",
    instavc_package_month_platinum: "$ 933/ مہینہ ",
    instavc_package_bill_platinum: " بلنگ سالانہ + جی ایس ٹی 18٪",
    instavc_package_include_platinum: " اس پیکیج کے ساتھ شامل ہیں ",
    instavc_package_specifictions_platinum:
      " وائٹ بورڈ  n اسکرین شیئر  n چیٹ  n ریکارڈنگ  n پریسنٹر موڈ ",
    instavc_package_buynow_platinum: " ابھی خریدیں ",
    instavc_package_fullfeatures_platinum: " مکمل خصوصیات ",
    instavc_package_legacybaselicense: " میراث کی بنیاد پر لائسنس ",
    instavc_package_licensebased_ports: " بندرگاہوں کی تعداد پر مبنی لائسنس ",
    instavc_package_hardwareendpoint:
      " ہارڈ ویئر کے اختتام نقطہ کے ساتھ انسٹا سی سی ",
    instavc_package_webrtcconf_legacysupport:
      " میراثی تعاون کے ساتھ WebRTC کانفرنس کرنا ",
    instavc_package_sip: "SIP / BFCP مدد کریں ",
    instavc_package_chh323: "ChH323 / H.239 مدد کریں ",
    instavc_package_contactus: " ہم سے رابطہ کریں ",
    instavc_myprofile_dashboard: " ڈیش بورڈ ",
    instavc_myprofile_settings: " ترتیبات ",
    instavc_myprofile: " میری پروفائل ",
    instavc_myprofile_personaldetail: " ذاتی معلومات ",
    instavc_myprofile_personaldetails_name: " نام ",
    instavc_myprofile_personaldetails_email: " ای میل ",
    instavc_myprofile_personaldetails_phoneno: " فون نمبر ",
    instavc_myprofile_personaldetails_address: " پتہ ",
    instavc_myprofile_personaldetails_city: " شہر ",
    instavc_myprofile_edit: " ترمیم ",
    instavc_myprofile_personaldetails: " ذاتی معلومات ",
    instavc_myprofile_firstname: " پہلا نام ",
    instavc_myprofile_lastname: " آخری نام ",
    instavc_myprofile_email: " ای میل ",
    instavc_myprofile_phoneno: " فون نمبر ",
    instavc_myprofile_professionaldetails: " پیشہ ورانہ تفصیلات ",
    instavc_myprofile_position: " پوزیشن ",
    instavc_myprofile_professionaldetails_email: " ای میل ",
    instavc_myprofile_professionaldetails_phoneno: " فون نمبر ",
    instavc_myprofile_professionaldetails_address: " پتہ ",
    instavc_myprofile_professionaldetails_branch: " شاخ ",
    instavc_myprofile_professionaldetails_edit: " ترمیم ",
    instavc_myprofile_officialdetails: " سرکاری تفصیلات ",
    instavc_myprofile_officialdetails_position: " پوزیشن ",
    instavc_myprofile_officialdetails_email: " ای میل ",
    instavc_myprofile_officialdetails_phoneno: " فون نمبر ",
    instavc_myprofile_officialdetails_branch: " شاخ ",
    instavc_myprofile_officialdetails_address: " پتہ ",
    instavc_myprofile_contactinfo: " معلومات سے رابطہ کریں ",
    instavc_myprofile_contactinformation: " رابطے کی معلومات ",
    instavc_myprofile_add: " شامل کریں ",
    instavc_myprofile_contactinformation_address: " پتہ ",
    instavc_myprofile_contactinformation_city: " شہر / قصبہ ",
    instavc_myprofile_contactinformation_zip: " زپ کوڈ ",
    instavc_myprofile_contactinformation_landmark: " تاریخی نشان ",
    instavc_myprofile_address: " پتہ ",
    instavc_myprofile_landmark: " تاریخی نشان ",
    instavc_myprofile_delete: " انتباہ ",
    instavc_myprofile_deletealert: " کیا آپ واقعی اسے حذف کرنا چاہتے ہیں؟",
    instavc_myprofile_disagree: " ناکارہ بنائیں ",
    instavc_myprofile_agree: " متفق ",
    instavc_myprofile_websitelinks: " ویب سائٹ لنک ",
    instavc_myprofile_website_add: " شامل کریں ",
    instavc_myprofile_website: " ویب سائٹ ",
    instavc_myprofile_websiteexample: "https://www.google.com",
    instavc_myprofile_sociallinks: " سماجی روابط ",
    instavc_myprofile_sociallinks_add: " شامل کریں ",
    instavc_myprofile_sociallink: " سماجی روابط ",
    instavc_myprofile_sociallinks_example: "https://www.facebook.com/xxx",
    instavc_myprofile_basicinfo: " بنیادی معلومات ",
    instavc_myprofile_basicinfo_add: " شامل کریں ",
    instavc_myprofile_basicinfo_dob: " ڈی او بی ",
    instavc_myprofile_basicinfo_gender: " صنف ",
    instavc_myprofile_basicinformation: " بنیادی معلومات ",
    instavc_myprofile_basicinformation_dob: " پیدائش کی تاریخ ",
    instavc_myprofile_basicinformation_gender: " صنف ",
    instavc_myprofile_basicinformation_deletealert:
      " انتباہ  n کیا آپ واقعی اسے حذف کرنا چاہتے ہیں؟",
    instavc_myprofile_basicinformation_disagree: " ناکارہ بنائیں ",
    instavc_myprofile_basicinformation_agree: " متفق ",
    instavc_myprofile_uploadnewavatar: " نیا اوتار اپ لوڈ کریں ",
    instavc_myprofile_cropimage: " تصویر کو فصل کریں ",
    instavc_myprofile_locale: " مقام ",
    instavc_myprofile_localesettings: " مقام کی ترتیبات ",
    instavc_myprofile_preferredlanguage: " پسندیدہ زبان:",
    instavc_myprofile_language: " انگریزی ",
    instavc_settings: " ترتیبات ",
    instavc_settings_changepassword: " پاس ورڈ تبدیل کریں ",
    instavc_settings_changepass: " پاس ورڈ تبدیل کریں ",
    instavc_settings_currentpassword: " موجودہ خفیہ لفظ",
    instavc_settings_newpassword: "نیا پاس ورڈ",
    conf_password: "پپاس ورڈ کی تصدیق کریں۔",
    instavc_settings_enter_currentpassword:
      " براہ کرم موجودہ پاس ورڈ درج کریں ",
    instavc_settings_enter_newpassword: " براہ کرم نیا پاس ورڈ درج کریں ",
    enter_confpassword: "براہ کرم پاس ورڈ کی تصدیق کریں۔",
    newpassword_confpassword_should_same:
      "نیا پاس ورڈ اور کنفرم پاس ورڈ ایک جیسا ہونا چاہیے۔",
    curnt_psw_and_new_psw_should_not_same:
      "موجودہ پاس ورڈ اور نیا پاس ورڈ ایک جیسا نہیں ہونا چاہیے۔",
    instavc_settings_help: " مدد ",
    instavc_settings_affiliate: " ملحق بنیں ",
    instavc_settings_support: " سپورٹ سینٹر ",
    instavc_settings_newticket: " نیا ٹکٹ کھولیں ",
    instavc_settings_ticketstatus: " ٹکٹ کی حیثیت چیک کریں ",
    instavc_settings_troubleshoot: " دشواری حل ",
    instavc_legacy_dailout: " ڈائل آؤٹ ",
    instavc_legacy_stats: " اعدادوشمار ",
    instavc_legacy_dail_in_detail: " ڈائل ان تفصیلات ",
    instavc_legacy_h323_endpoint: " H.323 اینڈ پوائنٹ ",
    instavc_legacy_sip_endpoint: " ایس آئی پی آخر نقطہ ",
    instavc_admin_users: " صارفین ",
    instavc_admin_assessments: "تشخیصات",
    instavc_admin_username: " ٹیچر کا نام",
    instavc_admin_user_accountstatus: " اکاؤنٹ کی حیثیت ",
    instavc_admin_user_confirmed: " تصدیق ہوگئی ",
    instavc_admin_user_unconfirmed: " 	غیر تصدیق شدہ ",
    instavc_admin_user_resetall: " تمام ری سیٹ کرو ",
    instavc_admin_user_sync: " ہم آہنگی ",
    instavc_admin_user_status: " حالت ",
    instavc_admin_user_phonenumber: " فون نمبر ",
    instavc_admin_user_created: " بنائی گئی ",
    instavc_admin_user_all: " سب ",
    instavc_admin_groups: " گروہ ",
    instavc_admin_addmore: " مزید شامل کریں ",
    instavc_admin_group_peoplelink: " کوئینز ، گولیو ، پیپل لنک ",
    instavc_admin_select_plan: " منصوبہ منتخب کریں ",
    instavc_admin_lastmodified: " آخری ترمیم ",
    instavc_admin_email_verified: " ای میل کی توثیق ",
    instavc_admin_verified: " تصدیق شدہ ",
    instavc_admin_Unverified: " غیر تصدیق شدہ ",
    instavc_admin_licenses: " لائسنس ",
    instavc_admin_addlicense: " لائسنس شامل کریں ",
    instavc_admin_defaultroom: " طے شدہ کمرہ ",
    instavc_admin_hostlicense: " میزبان بیسڈ لائسنس ",
    instavc_admin_roomlicense: " کمرے پر مبنی لائسنس ",
    instavc_admin_virtualmcu: " ورچوئل ایم سی یو پر مبنی لائسنس ",
    instavc_admin_enterprise: " انٹرپرائز لائسنس ",
    instavc_mcuserver: " ایم سی یو سرور ",
    instavc_mculink: "https://awsmcu.instavc.com",
    instavc_admin_expirydate: " خاتمے کی تاریخ ",
    instavc_admin_settings: " ایڈمن سیٹنگ ",
    instavc_default_offer: " پہلے سے طے شدہ پیش کش ",
    instavc_enter_coupon_code: " کوپن کوڈ درج کریں ",
    instavc_current_partshare: " موجودہ پارٹنر شیئر ",
    instavc_share_value: " شیئر ویلیو ",
    instavc_affliate_share: " موجودہ ملحق حصہ ",
    instavc_enter_share: " شیئر ویلیو (٪) درج کریں",
    instavc_roomname: " کمرے کا نام ",
    instavc_room_ten: " دس ",
    instavc_room_twenty: " بیس ",
    instavc_room_thirty: " تیس ",
    instavc_room_hostbased: " میزبان کی بنیاد پر ",
    instavc_virtualmcu: " ورچوئل ایم سی یو ",
    instavc_rooms_enterprises: " انٹرپرائز ",
    instavc_roomid: " کمرہ کی شناخت ",
    instavc_roomtype: " عمر",
    instavc_room_options: " کمرے کے اختیارات ",
    instavc_commercialtype: "مضامین",
    instavc_free: " مفت ",
    instavc_poc: " پی او سی ",
    instavc_commercial: " کمرشل ",
    instavc_createdAt: " ایٹ تیار کیا گیا ",
    instavc_useraccess: " صارف تک رسائی ",
    instavc_peoplelinkroom: " پیپل لنک روم ",
    instavc_inputlimit: " ان پٹ کی حد ",
    instavc_participant_limit: " شرکاء کی حد ",
    instavc_adduser: " صارف شامل کریں ",
    instavc_searchbyname: " نام سے تلاش کریں ",
    instavc_manage_plans: " منصوبے / مصنوعات کا انتظام کریں ",
    instavc_new_plans: " نیا منصوبہ / مصنوع ",
    instavc_allplan_list: " تمام منصوبوں کی فہرست ",
    instavc_sortby: " کے ذریعہ ترتیب دیں ",
    instavc_active: " فعال ",
    instavc_inactive: " غیر فعال ",
    instavc_create_plan: " نیا منصوبہ بنائیں ",
    instavc_plan_name: " منصوبے کا نام ",
    instavc_enteramount: " رقم درج کریں (کم سے کم: INR 100)",
    instavc_select_product: " پروڈکٹ کو منتخب کریں ",
    instavc_host_room: "1 میزبان / کمرہ ",
    instavc_multiroom: " ملٹی میزبان / کمرہ ",
    instavc_legacyrooms: " لیگیسی روم ",
    instavc_number_hosts: " میزبانوں کی تعداد ",
    instavc_number_participants: " شرکاء کی تعداد ",
    instavc_number_room: " کمروں کی تعداد ",
    instavc_subscriptiom_period: " خریداری کی مدت ",
    instavc_sub_yearly: " سالانہ ",
    instavc_sub_monthly: " ماہانہ ",
    instavc_sub_weekly: " ہفتہ وار ",
    instavc_setinterval: " وقفہ طے کریں ",
    instavc_type: " ٹائپ ",
    instavc_subscription: " سب سکریپشن ",
    instavc_onetime: " ایک بار ",
    instavc_description: " تفصیل ",
    instavc_planid: " پلانآئڈی ",
    instavc_orders: " احکامات ",
    instavc_orderid: " آرڈر کی شناخت ",
    instavc_none: " کوئی نہیں ",
    instavc_customer: " صارف ",
    instavc_build_anually: " سالانہ بنائیں ",
    instavc_recurring_billing: " بار بار چلنے والا بلنگ ",
    instavc_next_due: " اگلی وجہ پر ",
    instavc_invoice_details: " انوائسز تفصیل ",
    instavc_recurring_payment: " بار بار آنے والی ادائیگی ",
    instavc_todays_sale: " آج کی فروخت ",
    instavc_total_order: " کل احکامات ",
    instavc_total_rooms: " کل کمرے ",
    instavc_current_conference: " موجودہ کانفرنسیں ",
    instavc_current_user: " موجودہ صارف ",
    instavc_live_broadcast: " براہ راست نشریات ",
    instavc_loading_chart: " لوڈنگ چارٹ ",
    instavc_view: " دیکھیں ",
    instavc_coupon_info: " کوپن کی معلومات ",
    instavc_new_coupon: " نیا کوپن ",
    instavc_create_coupon: " نیا کوپن بنائیں ",
    instavc_coupon_code: " کوپن کوڈ ",
    instavc_company_code: " کمپنی کوڈ ",
    instavc_select_plan: " منصوبے منتخب کریں ",
    instavc_discount: " چھوٹ ",
    instavc_activestatus: " ایکٹو اسٹیٹس ",
    instavc_usage: " استعمال ",
    instavc_activeusage: " چالو ",
    instavc_singleuse: " ایک ہی استعمال ",
    instavc_multiuse: " ملٹی استعمال ",
    instavc_first_page: " پہلا صفحہ ",
    instavc_previosu_page: " سابقہ ​​صفحہ ",
    instavc_next_page: " اگلا صفحہ ",
    instavc_last_page: " اخری صفحہ ",
    instavc_plan: " منصوبہ بنائیں ",
    instavc_request_withdrawal: " واپسی کی درخواست کریں ",
    instavc_withdraw: " واپس لے لو ",
    instavc_account: " کھاتہ ",
    instavc_verification: " تصدیق ",
    instavc_withdraw_history: " تاریخ واپس لے لو ",
    instavc_add_bank: " انخلا کے ل a ایک بینک اکاؤنٹ شامل کریں ",
    instavc_bank_description:
      " ہم آپ کی مالی معلومات کو خفیہ رکھتے ہوئے آپ کے بینک اکاؤنٹ کی حفاظت کرتے ہیں۔ جب بھی ہمیں اس اکاؤنٹ سے واپسی کے لئے کوئی درخواست موصول ہوگی ہم آپ کو اس کی حیثیت سے ای میل کریں گے۔ واپسی کی ناکامیوں اور واپسی کی رقم سے بچنے کے ل this ، اس اکاؤنٹ کا نام آپ کے بینک اکاؤنٹ میں موجود نام کے ساتھ ملنا چاہئے۔ آپ کے بینک کی پالیسیوں اور چھٹیوں کے نظام الاوقات کے حساب سے منتقلی کو مکمل کرنے میں کچھ وقت لگ سکتا ہے۔",
    instavc_bank_accountnumber: " بینک اکاؤنٹ نمبر ",
    instavc_enter_accountnumber: " اپنا اکاؤنٹ نمبر درج کریں ",
    instavc_account_name: " کھاتہ دار کا نام ",
    instavc_per_bank_account: " بینک اکاؤنٹ کے مطابق ",
    instavc_ifsc: " آئی ایف ایس سی کوڈ ",
    instavc_bankname: " بینک کا نام ",
    instavc_branchname: " بینک برانچ کا نام ",
    instavc_confirmdetails: " تفصیلات کی تصدیق کریں ",
    instavc_pandetails: " براہ کرم اپنے پین کے مطابق نیچے تفصیلات فراہم کریں ",
    instavc_enter_pan: " پین کے مطابق اپنا نام درج کریں ",
    instavc_fathername: " باپ کا نام ",
    instavc_enter_fathername: " والد کا نام درج کریں ",
    instavc_pannumber: " پین نمبر ",
    instavc_panexampe: "Ex: BNZPM2501G",
    instavc_upload_pan_copy: " پین کاپی اپ لوڈ کریں ",
    instavc_save_details: " تفصیلات محفوظ کریں ",
    instavc_sales: " فروخت ",
    instavc_transactionid: " ٹرانزیکشن کی شناخت ",
    instavc_date: " تاریخ ",
    instavc_amount: " رقم ",
    instavc_setaccount_withdraw: " انخلا سے قبل اکاؤنٹ کی تفصیلات مرتب کریں ",
    instavc_first_withdraw:
      " اگر آپ پہلی بار صارف واپسی کے لئے درخواست کررہے ہیں تو ، آپ کو اگلے ٹیبز میں پین کارڈ کی تفصیلات کا استعمال کرتے ہوئے اپنے اکاؤنٹ کی تفصیلات کو پُر کرنے اور اپنے اکاؤنٹ کی تصدیق کرنے کی ضرورت ہے۔ تصدیق کے بعد ، آپ اپنے دستیاب بیلنس سے دستبرداری کے لئے درخواست کرنے کے لئے آگے بڑھ سکتے ہیں۔",
    instavc_accountdetails: " اکاؤنٹ کی تفصیلات بھریں ",
    instavc_available_balance: " دستیاب بیلنس ",
    instavc_amount_withdraw: " واپس لینے کے لئے رقم ",
    instavc_enteramount_withdraw:
      " جو رقم آپ واپس لینا چاہتے ہو اسے داخل کریں ",
    instavc_select_payment_mode: " ادائیگی کا طریقہ منتخب کریں ",
    instavc_paypal_payment: " پے پال ادائیگی ",
    instavc_bank_transaction: " بینک ٹرانزیکشن ",
    instavc_paypalfee: " پے پال فیس ",
    instavc_totalamount_withdraw: " واپس لینے کے لئے کل رقم ",
    instavc_sendrequest: " درخواست بھیجیں ",
    instavc_no_request_withdraw:
      " ابھی واپسی کے لئے کوئی درخواستیں نہیں اٹھائ گئیں!",
    instavc_start_process_withdraw:
      " آپ نیچے سے دستبرداری کے لئے کارروائی شروع کرسکتے ہیں۔",
    instavc_request_withdraw_now: " ابھی دستبرداری کی درخواست کریں ",
    instavc_current_commission: " موجودہ کمیشن ",
    instavc_from: " سے ",
    instavc_to: " کو ",
    instavc_today: " آج ",
    instavc_last7days: " آخری 7 دن ",
    instavc_lastmonth: " اس مہینے ",
    instavc_paid_customers: " ادا کردہ صارفین ",
    instavc_share_referral_link: " اپنے ریفرل لنک دوستوں کے ساتھ شیئر کریں ",
    instavc_copylink: " لنک کاپی کریں ",
    instavc_minimum_payout: " کم سے کم ادائیگی ",
    instavc_referral_signup: " ریفرل سائن اپ ",
    instavc_referral_clicks: " حوالہ دار کلکس ",
    instavc_paid: " ادا کیا ",
    instavc_unpaid: " بلا معاوضہ ",
    instavc_totalearned: " کل کمایا ",
    instavc_myreferral: " میرے حوالہ جات ",
    instavc_viewall: " سب دیکھیں ",
    instavc_mysales: " میری فروخت ",
    instavc_sms_mfa: "SMS MFA حالت ",
    instavc_facebook: " فیس بک ",
    instavc_twitter: " ٹویٹر ",
    instavc_linkedin: " لنکڈ ",
    instavc_referred_users: " حوالہ دینے والے صارفین ",
    instavc_created_date: " تشکیل کی تاریخ ",
    instavc_myearnings: " میری آمدنی ",
    instavc_earnings: " آمدنی ",
    instavc_commission_share: " کمیشن شیئر کریں ",
    instavc_commission_percentage: " کمیشن فیصد ",
    instavc_coupon_offers: " کوپن / آفر ",
    instavc_my_referral_account: " میرا حوالہ دہندہ ",
    instavc_req_withdraw: " درخواست واپس لیں ",
    instavc_authenticating: " InstaVC سرور کی توثیق کر رہا ہے…",
    instavc_join_access_media: " شامل ہوئے .. میڈیا ڈیوائسز تک رسائی ...",
    instavc_publish_success: " کامیاب شائع کریں ",
    instavc_recieves: "Receives",
    instavc_host_screenshare:
      " آپ کو اسکرین / دستاویز کے اشتراک کے لئے ہوسٹ بننے کی ضرورت ہے یا ",
    instavc_request_sharescreen:
      " اسکرین / دستاویز کا اشتراک کیلئے رسائی کی درخواست کریں ",
    instavc_note: " نوٹ ",
    instavc_filesize: " فائل کا سائز 10MB سے زیادہ نہیں ہونا چاہئے ",
    instavc_become_host:
      " میزبان بننے کے لئے ویڈیو پر ڈاؤٹڈ اوور فلو مینو آئیکنز پر کلک کریں ",
    instavc_clicklink:
      " پاپ اپ میں ، میزبان بنیں پر کلک کریں اور میزبان کا پاس ورڈ داخل کریں اور میزبان بٹن پر کلک کریں ",
    instavc_doc_share: " دستاویز بانٹیں ",
    instavc_search_host: " میزبان کا انتظار ہے ",
    instavc_wait_for_host:
      "براہ کرم میزبان کے اس سیشن کے شروع ہونے کا انتظار کریں۔ ",
    instavc_open_black_dialog: " سیاہ مکالمہ کھولیں ",
    instavc_open_white_dialog: " سفید مکالمہ کھولیں ",
    instavc_dail_detail: " ڈائل - میں - تفصیلات ",
    instavc_request_access: " رسائی کی درخواست کریں ",
    instavc_inordder_enable: " تاکہ قابل بنائے ",
    instavc_host_permission: " آپ کو میزبان سے رسائی کی اجازت درکار ہے ",
    instavc_please_wait: " برائے مہربانی انتظار کریں ",
    instavc_host_to_permit: "(میزبان) کی اجازت ",
    instavc_alternate_content: " متبادل مواد ",
    instavc_meeting_room: "کا سیشن روم",
    instavc_host_left_conference: " کانفرنس چھوڑ دیا!",
    instavc_conf_end: " کانفرنس خود بخود ختم ہوجائے گی ",
    instavc_seconds: " سیکنڈ ",
    instavc_waiting_msg:
      "انتظار کرنے کا شکریہ. میزبان کے شامل ہونے پر ہم سیشن شروع کریں گے۔",
    instavc_let_hostname:
      " کیا آپ میزبان کو بتانا چاہتے ہیں کہ آپ انتظار کر رہے ہیں؟",
    instavc_exitconf: " ایگزٹ کانفرنس ",
    instavc_host_left: " میزبان بائیں ...",
    instavc_end_host_msg:
      "میزبان نے یہ سیشن ختم کر دیا ہے۔ شرکت کے لیے آپ کا شکریہ۔",
    instavc_close_conf: " آپ گھر واپس جا سکتے ہیں (یا) درخواست بند کردیں۔",
    instavc_gohome: " گھر جاو ",
    instavc_hand_raised: " ہاتھ اٹھایا ",
    instavc_ask: " پوچھیں ",
    instavc_protocal: " پروٹوکول ",
    instavc_bitrate: " بٹریٹ ",
    instavc_confirm_details: " اپنی تفصیلات کی تصدیق کریں ",
    instavc_enter_info_conf:
      " براہ کرم کانفرنس شروع کرنے سے پہلے اپنی معلومات درج کریں۔",
    instavc_have_acc: " اگر آپ کے پاس پہلے سے ہی ایک اکاؤنٹ ہے؟",
    instavc_host_access: " میزبان رسائی ",
    instavc_host_pass: " میزبان پاس ورڈ درج کریں ",
    instavc_becomehost: " میزبان بنو ",
    instavc_permit_screenshare: " اسکرین شیئر کی اجازت دیں ",
    instavc_allow_access: " وائٹ بورڈ تک رسائی کی اجازت دیں ",
    instavc_request_permission: " کو اضافی اجازت کی درخواست کی ہے ",
    instavc_deny: " انکار کریں ",
    // "instavc_planid" : " پلان آئڈ ",
    instavc_customeremail: " کسٹمر ای میل ",
    instavc_orderlink: "Order Link",
    instavc_customerid: " گاہک کی شناخت ",
    instavc_selectpackage: " پیکیج منتخب کریں ",
    instavc_host_package: " میزبان بیسڈ پیکیج ",
    instavc_virtualbase_mcu: " ورچوئل ایم سی یو پر مبنی ",
    instavc_plans_product: " منصوبے / مصنوعات ",
    instavc_nodata: " اعداد و شمار دستیاب نہیں ",
    instavc_nodata_msg:
      " افوہ! ابھی آپ کو دکھانے کے لئے کوئی ڈیٹا دستیاب نہیں ہے۔",
    instavc_basicplan: " بنیادی منصوبہ ",
    instavc_host_participants: "1 شریک 30 افراد کے ساتھ ",
    instavc_link: " لنک ",
    instavc_cancel_order: " آرڈر منسوخ کر دیں ",
    instavc_per: " فی ",
    instavc_user_email: " صارف کا ای میل ",
    instavc_owner: " مالک ",
    instavc_user: " صارف ",
    instavc_default_users: " پہلے سے طے شدہ پیش کش ",
    instavc_system_settings: " سسٹم کی ترتیبات ",
    instavc_expires: " میعاد ختم ہوجاتی ہے ",
    instavc_start_VC: " ویڈیو کانفرنس شروع کریں ",
    instavc_start_AC: " آڈیو کانفرنس کا آغاز کریں ",
    instavc_date_error:
      " شروعاتی تاریخ اور وقت موجودہ وقت سے زیادہ ہونا چاہئے ",
    instavc_browser_update: " براؤزر اپ ڈیٹ کی ضرورت ہے ",
    instavc_browser_note:
      " ہم نے دیکھا کہ آپ براؤزر کے نام کا پرانا ورژن استعمال کر رہے ہیں جو اب غیر تعاون یافتہ ہے۔",
    instavc_browser_msg:
      " Instavc.com کو براؤزر کے نام یا کسی دوسرے جدید براؤزر کا تازہ ترین ورژن درکار ہوتا ہے۔",
    instavc_browser_upgrade:
      " ایک بہتر تجربہ کے لئے براہ کرم ان براؤزرز کے کسی تازہ ترین ورژن میں اپ گریڈ کریں۔",
    instavc_googlechrome: " گوگل کروم ",
    instavc_gc_version74: " ورژن 74",
    instavc_mfirefox: " موزیلا فائر فاکس ",
    instavc_mff_version: " ورژن 66",
    instavc_opera: " اوپیرا ",
    instavc_opera_version: " ورژن 60.0+",
    instavc_microsoftedge: " مائیکروسافٹ ایج ",
    instavc_ms_version: " ورژن 44+",
    instavc_safari: " ایپل سفاری ",
    instavc_safari_version: " ورژن 12.1",
    instavc_contact_msg:
      " پہلے سے اپ گریڈ کیا گیا ہے ، لیکن پھر بھی مسئلہ ہے؟ ہم سے رابطہ کریں ",
    instavc_camera_busy: " کیمرے مصروف ہونے لگتا ہے!",
    instavc_close_camera:
      " براہ کرم تمام اطلاق کو بند کریں اور دوبارہ کوشش کریں۔",
    instavc_resolution: " قرارداد کی حمایت نہیں!",
    instavc_camera_notsupport: " آپ کا کیمرا اس قرارداد کی حمایت نہیں کرتا ہے۔",
    instavc_camera_reconfig:
      " اپنی ترتیبات کو کم ریزولوشن کے ساتھ تشکیل دیں اور دوبارہ کوشش کریں۔",
    instavc_change_resolution: " قرارداد بدلیں ",
    instavc_confirmation: " تصدیق ",
    instavc_yes: " جی ہاں ",
    instavc_delete_room: " کیا آپ واقعی کمرہ حذف کرنا چاہتے ہیں؟",
    instavc_delete_license: " کیا آپ واقعی لائسنس کو حذف کرنا چاہتے ہیں؟",
    instavc_help: " ہم آپ کی مدد کے لئے حاضر ہیں ",
    instavc_browse_questions: " اکثر پوچھے گئے سوالات کے ذریعے براؤز کریں۔",
    instavc_os: " آپریٹنگ سسٹم ",
    instavc_macos: " میک OS X ورژن:",
    instavc_chrome_version: " کروم ورژن:",
    instavc_private_browsing: " نجی براؤزنگ؟",
    instavc_faq_no: " نہیں ",
    instavc_display_resolution: " انسٹا وائس ڈسپلے ریزولوشن ",
    instavc_aspect_ratio: " پہلو کا تناسب دکھائیں ",
    instavc_sys_hasspeakers: " سسٹم میں اسپیکر ہیں؟",
    instavc_found_speakers: " اسپیکر کے اوزار ملا: 2",
    instavc_speakers1: " اسپیکر 1",
    instavc_speakers2: " اسپیکر 2",
    instavc_sys_have_microphone: " سسٹم میں مائکروفون ہے؟",
    instavc_found_microphone: " مائیکروفون آلات ملا: 2",
    instavc_microphone1: " مائکروفون 1",
    instavc_microphone2: " مائکروفون 2",
    instavc_has_webcam: " سسٹم میں ویب کیم ہے؟",
    instavc_found_speakers1: " اسپیکر کے آلے ملا: 1",
    instavc_camera1: " کیمرہ 1",
    instavc_webcam_permission: " ویب سائٹ پر ویب کیم کی اجازت ہے؟",
    instavc_microphone_permission: " ویب سائٹ میں مائکروفون کی اجازت ہے؟",
    instavc_browser_allows: " براؤزر اس صفحے پر یوزر میڈیا کی اجازت دیتا ہے؟",
    instavc_change_output_device:
      " کیا آپ آؤٹ پٹ آڈیو ڈیوائسز کو تبدیل کرسکتے ہیں؟",
    instavc_change_camera_resolutions:
      " کیا آپ نئی getUserMedia درخواست کے بغیر کیمرا کی قراردادیں تبدیل کرسکتے ہیں؟",
    instavc_browser_support_webrtc:
      " براؤزر WebRTC کی حمایت کرتا ہے (یا تو 1.0 یا 1.1)؟",
    instavc_browser_support_ortc: " براؤزر ORTC (WebRTC 1.1) کی حمایت کرتا ہے؟",
    instavc_initial_setup:
      " براہ کرم انتظار کریں جب آپ کے ابتدائی سیٹ اپ پر کارروائی ہو رہی ہے!",
    instavc_close_browser:
      " اس وقت اپنے براؤزر کو بند نہ کریں یا بیک بٹن کا استعمال نہ کریں۔",
    instavc_whoops: " افوہ!",
    instavc_nonet_msg:
      " انٹرنیٹ کنکشن نہیں ملا۔ براہ کرم اپنا کنکشن چیک کریں یا دوبارہ کوشش کریں۔",
    instavc_nosearch: " تلاش کے کوئی نتائج نہیں ملے ",
    instavc_noserchmsg: " ہمیں آپ کی تلاش سے مماثل کوئی آئٹم نہیں مل سکتا ہے۔",
    instavc_nosearch_filter:
      " اپنی تلاش کو ایڈجسٹ کرنے کی کوشش کریں یا آپ جو ڈھونڈ رہے ہیں اسے تلاش کرنے کے لئے فلٹر کریں۔",
    instavc_gotohoem_page: " ہوم پیج پر جائیں ",
    instavc_pageloading: " صفحہ لوڈ ہو رہا ہے ... براہ کرم انتظار کریں!",
    instavc_process: " پروسیسنگ…",
    instavc_session_timeout: " دورانیہ ختم ہو گیا ",
    instavc_session_inactivity:
      " غیر فعال ہونے کی وجہ سے آپ کے سیشن کا وقت ختم ہو رہا ہے۔",
    instavc_session_msg: " براہ کرم سائن ان رہنے کا انتخاب کریں۔",
    instavc_session_reconnect: " دوبارہ رابطہ کریں ",
    instavc_site_notreached: "اس سائٹ تک نہیں پہنچا جاسکتا!",
    instavc_site_webaddress: " یقینی بنائیں کہ آپ کو صحیح ویب پتہ ملا ہے ",
    instavc_check_internet: " اپنے نیٹ ورک کی جانچ کریں ",
    instavc_search_url: " دوسرے براؤزر میں یو آر ایل تلاش کریں ",
    instavc_goto: " کے پاس جاؤ ",
    instavc_request_for_access: " رسائی کی درخواست ",
    instavc_start_collabrate: " وائٹ بورڈ میں تعاون شروع کرنا ",
    instavc_large_conference_mode:
      ' اس کی " بڑی کانفرنس " وضع, جب تک میزبان آپ کو اجازت نہیں دیتا ہے تب تک آپ دوسروں سے بات نہیں کرسکتے اور نہ دیکھ سکتے ہیں ',
    instavc_allow_participants:
      'اس کی " بڑی کانفرنس " وضع, آپ کو دستی طور پر شرکاء کو بولنے کی اجازت دینا ہوگی ',
    instavc_buy_premium: " ان خصوصیات کو غیر مقفل کرنے کے لئے پریمیم خریدیں ",
    instavc_alert_tryagain: " کچھ غلط ہو گیا ، براہ کرم دوبارہ کوشش کریں ",
    instavc_enter_name: " اپنا نام درج کریں ",
    instavc_confirm: " تصدیق کریں ",
    instavc_ok: " ٹھیک ہے ",
    instavc_askquestion: " ایک سوال پوچھنا...",
    instavc_recieve: " وصول کریں ",
    instavc_delay: "Delay(Ms)",
    instavc_audio_opus: " آڈیو / افس ",
    instavc_video_vp8: " ویڈیو / وی پی 8",
    instavc_browser_not_support_incall:
      " آپ کا براؤزر کال کے دوران قرارداد کی تبدیلی کی حمایت نہیں کرتا ہے۔",
    instavc_failed_toPublish: " ویڈیو شائع کرنے میں ناکام ",
    instavc_publish_fail: " شائع کرنا ناکام ",
    instavc_video_cant_publish:
      " صارف کی حد تک رسائ کی وجہ سے ویڈیو شائع نہیں کیا جاسکتا ",
    instavc_failed_joinConference: " کانفرنس میں شامل ہونے میں ناکام ",
    instavc_mute_audio:
      " اگر ریموٹ آڈیو خاموش ہوجائے تو آپ گونگا / انمٹ نہیں کرسکتے ہیں ",
    instavc_remote_audio_muted: " ریموٹ آڈیو خاموش ہوگیا!",
    instavc_enter_conferenceid: " اپنی کانفرنس ID درج کریں ",
    instavc_share_screen: " سکرین کا اشتراک کریں ",
    instavc_sharing_your_screen: " اپنی اسکرین کا اشتراک کر رہا ہے…",
    instavc_stop: " رکو ",
    instavc_back: " پیچھے ",
    instavc_choose_plan: " نیچے دی گئی فہرست میں سے اپنا لائحہ عمل منتخب کریں ",
    instavc_have_promotionalcode: " پروموشنل کوڈ / پارٹنر کوڈ ہے؟",
    instavc_contact_pricing: " قیمتوں کا تعین کے لئے ہم سے رابطہ کریں ",
    instavc_payment_failed: " ادائیگی ناکام ہوگئی ",
    instavc_payment_error:
      " بدقسمتی سے آپ کی ادائیگی سے نمٹنے کے دوران ایک خرابی پیش آگئی.",
    instavc_contact_support:
      " اگر کسی مدد کی ضرورت ہو تو برائے مہربانی ہماری سپورٹ ٹیم سے رابطہ کریں۔",
    instavc_tryagain: " دوبارہ کوشش کریں ",
    instavc_payment_success: " ادائیگی کامیاب ",
    instavc_thanks_for_payment: " آپ کی ادائیگی کے لئے آپ کا شکریہ!",
    instavc_payment_processed:
      " آپ کی ادائیگی پر کامیابی کے ساتھ عملدرآمد کیا گیا ہے۔ خودکار ادائیگی کی رسید ",
    instavc_mail_sent:
      " جلد ہی آپ کے رجسٹرڈ ای میل ایڈریس پر بھیج دیا جائے گا ",
    instavc_goto_homepage: " ہوم پیج پر واپس جائیں ",
    instavc_want_toend_call: " کال ختم کرنا چاہتے ہیں؟",
    instavc_exit_window:
      " اس ونڈو کو بند کرنا آپ کی کال سے خارج ہوجائے گا۔ کیا آپ واقعی یہ کال ختم کرنا چاہتے ہیں؟",
    instavc_create_room: " کمرہ بنائیں ",
    instavc_userlimit: " صارف کی حد ",
    instavc_edit_room: " کمرہ میں ترمیم کریں ",
    instavc_update: " اپ ڈیٹ ",
    instavc_manage_license: " لائسنس کا انتظام کریں ",
    instavc_package: " پیکیج ",
    instavc_no_of_rooms: " کمروں کی تعداد ",
    instavc_no_of_users: " صارفین کی تعداد ",
    instavc_purchasedOn: " پر خریدا گیا ",
    instavc_expiredon: " میعاد ختم ہوگئی ",
    instavc_or: " یا ",
    instavc_otherhost_email:
      " اگر آپ کسی بھی صارف کو بطور میزبان بنانا چاہتے ہیں تو ، اس کا ای میل ایڈریس درج کریں۔",
    instavc_set_host_password: " میزبان پاس ورڈ سیٹ کریں ",
    instavc_host_password: " میزبان پاس ورڈ ",
    instavc_access_room: " اس کمرے میں اور کون پہنچ سکتا ہے؟",
    instavc_select_user_host:
      " کسی بھی صارف کو اسے میزبان بنانے کے لئے منتخب کریں۔",
    instavc_prologin: " انسٹا سی سی پرو لاگ ان ",
    instavc_start: " شروع کریں ",
    instavc_enter_website: " براہ کرم ویب سائٹ کا نام درج کریں ",
    instavc_enter_valid_email: " براہ کرم درست ای میل درج کریں ",
    instavc_enter_valid_phone: " براہ کرم درست فون نمبر درج کریں ",
    instavc_field_required: " اس کو پر کرنا ضروری ہے ",
    instavc_invitedby: " مدعو کیا گیا ",
    instavc_storage: " ذخیرہ ",

    affiliate_approve: " منظورشدہ ",
    affiliate_pending: " زیر التواء ",
    affiliate_rejected: " مسترد ",
    affiliate_user_status: " صارف کی حیثیت ",
    commission_other: " دوسرے کمیشن ",
    add_commission: " کمیشن شامل کریں ",
    delete_commission: " کیا آپ کمیشن کو حذف کرنا چاہتے ہیں؟ ",
    update_commission: "کمیشن کو اپ ڈیٹ کریںs",
    name: " نام ",
    offer_value: " قیمت پیش کرتے ہیں ",
    add: " شامل کریں ",
    update: " اپ ڈیٹ ",
    license_within: "آپ کے لائسنس کی میعاد ختم ہونے والی ہے۔",
    affiliates: " وابستہ افراد ",
    status: " حالت ",
    status_change_message: " کیا آپ اسٹیٹس کو تبدیل کرنا چاہیں گے؟",
    approve: " منظور کریں ",
    reject: " مسترد کریں ",
    commissions: " کمیشن ",
    withdraw_data: " ڈیٹا واپس لیں ",
    withdraw_amount: " رقم واپس لے لو ",
    payment_method: " ادائیگی کا طریقہ ",
    payment_fee: " ادائیگی کی فیس ",
    total_amount_withdraw: " واپسی کے لئے کل رقم ",
    total_earnings: " کل کمائی ",
    pending_amount: " زیر التواء رقم ",
    paid_amount: " ادا شدہ رقم ",
    unpaid_amount: " بلا معاوضہ رقم ",
    requested_withdraw: " رقم واپس کرنے کی درخواست کی ",
    english: " انگریزی ",
    french: " فرانسیسی ",
    portuguese: " پرتگالی ",
    hindi: "ہندی",
    gujarati: "گجراتی",
    kannada: "کناڈا",
    marathi: "مراٹھی",
    tamil: "تمل",
    telugu: "تلگو",
    urdu: "اردو",
    spanish: "ہسپانوی",
    malyalam: "میلیم",
    italian: "اطالوی",
    bangla: "بنگلہ",
    create: "Create",
    repeat: " دہرائیں ",
    daily: " روزانہ ",
    repeat_every: " ہر دہرائیں ",
    repeat_on: " دہرائیں ",
    repeat_by: " دہرائیں بذریعہ ",
    ends: " ختم ہوتا ہے ",
    after: " کے بعد ",
    on: " پر ",
    summary: " خلاصہ ",
    repeats: " دہراتا ہے ",
    withdraws: " واپسی ",
    every: " ہر کوئی ",
    days: " دن ",
    weeks: " ہفتوں ",
    months: " مہینہ ",
    onday: " اس دن ",
    years: " سال ",
    times: " اوقات ",
    until: " جب تک ",
    past_meeting_list: "گزشتہ سیشن کی فہرست",
    organised_by: " منظم کردہ ",
    delete: " حذف کریں ",
    join: " شامل ہوں ",
    enter_password: " پاس ورڈ درج کریں ",
    submit: " جمع کرائیں ",
    enter_passwordmessage: " براہ کرم پاس ورڈ درج کریں ",
    delete_message: " کیا آپ حذف کرنا چاہتے ہیں؟ ",
    meeting_permanent: "مستقل سیشن؟",
    day: " دن ",
    password_message: " پاس ورڈ غلط ہے ",
    timezone: " ٹائم زون ",
    by: " بذریعہ ",
    weekdays: ["سن", "مان", "ٹیو", "وڈ", "ٹی یو یو", "ایف آر آئی", "سی اے ٹی"],
    allweek: ["اتوار", "پیر", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"],
    day_month: " مہینے کا دن ",
    day_week: " ہفتے کے دن ",
    week: " ہفتہ ",
    month: " مہینہ ",
    year: " سال ",
    enterpassword:
      " براہ کرم اپنا نیا پاس ورڈ درج کریں اور پاس ورڈ کی تصدیق کریں ",
    passwordmessage: " پاس ورڈ اور تصدیق پاس ورڈ دونوں ایک جیسے ہونا چاہئے ",
    passwordupdate:
      "پاس ورڈ کامیابی سے اپ ڈیٹ ہو گیا ، براہ کرم اپنے نئے پاس ورڈ سے لاگ ان کریں۔",
    numeric: ["پہلا", "دوسرا", "تیسرا", "چوتھا", "پانچواں"],
    verify_email: " اپنے ای میل کی تصدیق کریں ",
    confirm_code: " تصدیقی کوڈ ",
    verify_msg: " برائے کرم کوڈ کیلئے موبائل چیک کریں۔",
    verify: " تصدیق کریں ",
    not_recieved: " موصول نہیں؟",
    resend_otp: " او ٹی پی کو دوبارہ بھیجیں ",
    start_browsing: " براؤزنگ شروع کریں ",
    become_affiliate: " ملحق بنیں ",
    affiliate: " ملحق ",
    instavc_allow_DocumentAccess: " دستاویز شیئر کی اجازت دیں ",
    instavc_allow_Notes: " اجازت نامہ ",
    //common - CameraResolution
    camera_not_access:
      " مندرجہ ذیل وجوہات میں سے ایک کی وجہ سے کیمرا قابل رسائی نہیں ہے۔",
    camera_not_access_reason1:
      " ہوسکتا ہے کہ ریزولوشن کی ترتیبات اس ڈسپلے کے ساتھ مطابقت نہ رکھ سکیں۔ اپنی ترتیب کو کم ریزولوشن کے ساتھ تشکیل دیں اور دوبارہ کوشش کریں۔",
    camera_not_access_reason2:
      " آپ کا کیمرا مختلف ایپلیکیشن کے ذریعہ استعمال ہورہا ہے ، براہ کرم تمام ایپلی کیشنز کو بند کردیں اور لنک پر کلک کرکے دوبارہ کوشش کریں۔",

    //Containers
    //content - components - assignQuestionnaire
    asgnQue_Assign_Question: " سوالنامہ تفویض کریں ",
    update_questionnaire: "سوالنامہ کو اپ ڈیٹ کریں۔",
    duration_error: "براہ کرم 24 گھنٹے (1440 منٹ) سے نیچے درست دورانیہ درج کریں",
    asgnQue_assigned_question: " تفویض کردہ سوالنامہ ",
    //assignQuestList
    quslsit_assig_que_list: " تفویض کردہ سوالنامے کی فہرست ",
    quslsit_question_lists: " سوالنامہ فہرستیں ",
    quslsit_add_new_question: " نیا سوالنامہ شامل کریں ",
    quslsit_no_question_assign: " ابھی تک کوئی سوالنامہ تفویض نہیں کیا گیا ہے!",
    quslsit_assign_new_ques:
      " مندرجہ بالا سوالنامہ تفویض کریں بٹن پر کلک کرنے کے لئے ایک نیا سوالیہ نشان تفویض کریں ",
    //model-assign-Questionnaire
    select_questionnaire: " سوالنامہ منتخب کریں ",
    duration: " دورانیہ ",
    time_limit: " وقت کی حد ",
    show_results: " نتائج دکھاو ",
    save: " محفوظ کریں ",
    //viewAssigned
    content_group: " مواد گروپ ",
    list_assigned_ques: " تفویض کردہ سوالوں کی فہرست:",
    mins: " منٹ ",
    marks: " نشانات ",
    //AssignedQuestions
    asgQues_5_Marks: "(5 نمبر)",
    asgQues_answers: " جوابات ",
    asgQues_no_questions: " کوئی سوال نہیں!",
    //content - components - contentGrade
    //GradeSetting
    grdSet_GPA_calculation: " فیصد سے GPA کا حساب کتاب ",
    grdSet_GPA_cal_msg:
      " فیصد 100 for کے لئے ہے جو 100 پوائنٹس کے سوا کچھ نہیں ہے۔ لہذا فی صد میں 25 پوائنٹس جی پی اے سسٹم میں 1 پوائنٹ کے مترادف ہیں۔ جی پی اے فارمولہ کی فیصد صرف آپ کی فیصد کو 100 سے تقسیم کریں اور 4 سے ضرب کریں۔ اگر آپ کی فیصد 75 فیصد ہے تو آپ کا گریڈ (75/100) * 4 = 3 ہوگا۔",
    grdSet_grade_point: " اگر گریڈ پوائنٹس ہیں ",
    //managegrade
    mngGrd_grades: " گریڈ ",
    mngGrd_modify: " ترمیم کریں ",
    mngGrd_save_grades: " گریڈز کو بچائیں ",
    mngGrd_modify_grades: " درجات میں ترمیم کریں ",
    mngGrd_grade_info: " گریڈ کی معلومات ",
    //content - components - ContentParticipants
    //components-admnAnsView
    admnAns_answer_list_for_question:
      " ذیل میں اس مواد گروپ کے تمام سوالنامے کے جوابات کی فہرست ہیں۔",
    //components-participants
    prtcpt_certification: " سرٹیفیکیشن:",
    prtcpt_other_content_group: " دوسرے مواد گروپس میں ",
    prtcpt_sales: " فروخت ",
    prtcpt_marketing: " مارکیٹنگ ",
    prtcpt_human_resource: " انسانی وسائل ",
    //manageparticipants
    mngPrtcpt_add_participants: " شرکاء کو شامل کریں ",
    mngPrtcpt_participants_list: " شرکاء کی فہرستیں ",
    mngPrtcpt_import_participants: " شرکاء کو درآمد کریں ",
    mngPrtcpt_download_sample: " نمونہ ڈاؤن لوڈ کریں ",
    mngPrtcpt_no_participants_added: " ابھی تک کوئی شریک نہیں شامل کیا گیا ہے!",
    mngPrtcpt_add_new_participant:
      " ایک نیا شرکا شامل کریں ، شامل کرنے کے لئے مذکورہ بالا شرکاء کے بٹن کو شامل کریں ",
    //modal-add-participants
    addPrtcpt_select_participants: " شرکاء کو منتخب کریں ",
    addPrtcpt_model_add_participants: " شرکاء کو شامل کریں ",
    //partipantGradeView
    prtcptGrde_participant_grade: " شریک جماعت کی تفصیلات ",
    prtcptGrde_grade_participants_list: " شرکاء کی فہرست ",
    //content - components - ContentQuestionnaire
    //managequestionnaire
    mngQuesnr_create_questionnaire: " سوالنامہ بنائیں ",
    questionnaire_list: " سوالنامہ کی فہرست ",
    //managequestions
    mngQues_question_details: " سوالنامے کی تفصیلات ",
    mngQues_no_question_created: " ابھی تک کوئی سوال پیدا نہیں ہوا ہے!",
    mngQues_create_new_question:
      " ایک نیا سوال بنائیں ، تخلیق کرنے کے لئے مندرجہ بالا سوالیہ بٹن پر کلک کریں ",
    //modal-create-quest-group
    mdlGrp_questionnaire_name: " سوالنامہ کا نام ",
    mdlGrp_update: " اپ ڈیٹ ",
    mdlGrp_create: " بنانا ",
    //modal-create-questions
    mdlCrtQues_question_type: " سوال کی قسم ",
    mdlCrtQues_sel_question_type: " سوال کی قسم منتخب کریں ",
    mdlCrtQues_single_sel_multiple_choice: " سنگل سلیکٹ ایک سے زیادہ چوائس ",
    mdlCrtQues_multiselect_multiple_choice: " ملٹی سلیکٹ ایک سے زیادہ چوائس ",
    mdlCretPoll_single_sel_multi_choice: "کثیر الانتخاب",
    mdlCrtQues_ture_false: " صحیح یا غلط ",
    mdlCrtQues_enter_answer_choice:
      " جواب کے انتخاب داخل کریں ، اور نشان لگائیں کہ کون سا جواب صحیح ہے ",
    mdlCrtQues_add_another_choice: "+ دوسرا انتخاب شامل کریں ",
    //viewQuestionnaire
    viewQues_add_questions: " سوالات شامل کریں ",
    viewQues_no_question_created: " ابھی تک کوئی سوال پیدا نہیں ہوا ہے!",
    viewQues_create_new_question:
      " ایک نیا سوال بنائیں ، تخلیق کرنے کے لئے مندرجہ بالا سوالیہ بٹن پر کلک کریں ",
    //content - components - createContent
    //createcontent
    crteContent_create_new_content: " نیا مواد بنائیں ",
    crteContent_update_content: " مواد کو اپ ڈیٹ کریں ",
    crteContent_save_content: " مواد کو محفوظ کریں ",
    crteContent_content_list: " مواد کی فہرستیں ",
    edit_content: " مواد میں ترمیم کریں ",
    crteContent_create_content: " مواد بنائیں ",
    crteContent_create_your_content_like:
      " تصاویر ، ویڈیو فائلوں ، آڈیو فائلوں ، اور دستاویزات جیسے میڈیا کو شامل کرکے اپنا مواد بنائیں۔",
    crteContent_upload_document: " دستاویزات اپ لوڈ کریں ",
    crteContent_upload_media: " میڈیا اپ لوڈ کریں ",
    crteContent_document: " دستاویزات ",
    crteContent_media_files: " میڈیا فائلیں ",
    //view-content
    viewCon_content_view: " مواد کا نظارہ ",
    viewCon_content_list: " مواد کی فہرستیں ",
    viewCon_View_content: " مشمولات دیکھیں ",
    viewCon_enable: " فعال: ",
    viewCon_document: " دستاویزات ",
    viewCon_media_files: " میڈیا فائلیں ",
    //content - components - contentRow
    conRow_by: " منجانب: ",
    //content - components - managecontent
    create_new_content: " مواد بنائیں ",
    mngCon_all: " سب ",
    mngCon_content_list: " مواد کی فہرستیں ",
    mngCon_no_content_created: " ابھی تک کوئی مواد تیار نہیں کیا گیا ہے!",
    mngCon_create_new_content:
      " ایک نیا مواد بنائیں ، تخلیق کرنے کے لئے مندرجہ بالا مواد بٹن پر کلک کریں ",
    //content - components - model-access-right
    mdlAccRight_share_access: " دوسرے انسٹرکٹرز کے ساتھ رسائی کا اشتراک کریں ",
    mdlAccRight_type_id_add: " ای میل آئی ڈی ٹائپ کریں اور ایڈ کریں ",
    mdlAccRight_no_instructor_added:
      " ابھی تک کوئی انسٹرکٹر شامل نہیں کیا گیا ہے!",
    mdlAccRight_add_people_from_addressbok:
      " لوگوں کو اپنی ایڈریس بک سے ، یا ای میل ایڈریس ٹائپ کرکے شامل کریں۔",
    mdlAccRight_contacts: " رابطے ",
    mdlAccRight_add_contacts:
      " اپنے ایڈریس بک کے روابط سے ، مواد گروپ میں رابطے شامل کریں ",
    mdlAccRight_no_contacts_added: " ابھی تک کوئی رابطہ شامل نہیں کیا گیا ہے۔",
    //content - components - model-confirm-delete
    mdlConfDel_confirmation: " تصدیق ",
    mdlConfDel_are_you_sure_delete: " کیا آپ واقعی اسے حذف کرنا چاہتے ہیں؟ ",
    mdlConfDel_delete: " حذف کریں ",
    //content - components - model-create-content-group
    mdlCrtConGrp_alert_enter_group_title: " براہ کرم گروپ ٹائٹل درج کریں ",
    mdlCrtConGrp_alert_enter_group_description:
      " براہ کرم گروپ کی تفصیل درج کریں ",
    mdlCrtConGrp_group_name: " گروہ کا نام ",
    //content - components - model-upload-doc
    mdlUpldoc_alert_enter_title_doc: " براہ کرم دستاویز کا عنوان درج کریں ",
    mdlUpldoc_upload_document: " دستاویزات اپ لوڈ کریں ",
    mdlUpldoc_document_title: " دستاویز کا عنوان ",
    mdlUpldoc_upload_doc_from_system:
      " اپنے سسٹم سے دستاویز اپ لوڈ کریں ، یہ .pdf ، ایکسل ، ورڈ دستاویز کی حمایت کرتا ہے۔",
    mdlUpldoc_upload_doc: " دستاویز اپ لوڈ کریں ",
    mdlUpldoc_added_doc: " شامل دستاویزات ",
    //content - components - model-upload-media
    mdlUplMedia_alert_enter_title_media: " براہ کرم میڈیا کا عنوان درج کریں ",
    mdlUplMedia_alert_enter_title_url: " براہ کرم عنوان اور URL درج کریں ",
    mdlUplMedia_alert_enter_youtube_vimeo_url:
      "براہ کرم درست اور URL درج کریں (یوٹیوب / Vimeo)",
    mdlUplMedia_upload_media: " میڈیا اپ لوڈ کریں ",
    mdlUplMedia_upload_url: " یو آر ایل اپ لوڈ کریں ",
    mdlUplMedia_Upload_media_system:
      "اپنے سسٹم سے ہائی ریزولیوشن فائلیں اپ لوڈ کریں، یہ .jpg, .png, .jpeg, .mp3, .mp4 کو سپورٹ کرتا ہے۔",
    mdlUplMedia_add_media_url:
      " میڈیا کو منسلک کرنے کیلئے میڈیا یو آر ایل ایڈریس شامل کریں ",
    mdlUplMedia_upload_media_url: " میڈیا یو آر ایل اپ لوڈ کریں ",
    mdlUplMedia_upload_youtube_url: " نوٹ: یوٹیوب یو آر ایل اپ لوڈ کریں ",
    mdlUplMedia_Add_media_file: " شامل میڈیا فائلیں ",

    //content - managecontent - index
    // "mngContent_content" : " مواد ",
    mngContent_participants: " امیدوار ",
    mngContent_grade_settings: " گریڈ کی ترتیبات ",

    //content - index
    content_all_content_group: " تمام مواد گروپس ",
    create_new_group: " گروپ بنائیں ",
    content_no_group_created: " ابھی تک کوئی گروپ تشکیل نہیں دیا گیا ہے!",
    content_create_new_group:
      " ایک نیا گروپ بنائیں ، تخلیق کرنے کے لئے مذکورہ بالا گروپ بنائیں بٹن پر کلک کریں ",
    //ContentShare - contentList
    conList_all_group: " تمام گروپس ",
    conList_no_content_created: " ابھی تک کوئی مواد تیار نہیں کیا گیا ہے!",
    //contentShare - grouplist
    grpList_all_content_group: " تمام مواد گروپس ",
    grpList_no_group_created: " ابھی تک کوئی گروپ تشکیل نہیں دیا گیا ہے!",
    //ContentShare - questionStepper
    queStepper_cant_skip: " آپ ایسا قدم نہیں چھوڑ سکتے جو اختیاری نہیں ہے۔",
    queStepper_back: " پیچھے ",
    queStepper_next: " اگلے ",
    queStepper_skip: " چھوڑ دو ",
    queStepper_finish: " ختم ",
    queStepper_submit_next: " جمع کروائیں اور اگلا ",
    //contentshare - showContent
    conList_content_list: " مشمولات کی فہرست ",
    showCont_document: " دستاویزات ",
    showCont_previous: " پچھلا ",
    showCont_next: " اگلے ",
    showCont_have_completed_topic:
      " میں نے اس مواد میں عنوانات کو مکمل کیا ہے ",
    //contentShare - showMedia
    showMedia_page: " صفحہ ",
    showMedia_of: " کا ",
    showMedia_previous: " پچھلا ",
    //contentShare - showquestions
    showQues_min_left: " منٹ باقی ",
    showQues_completed_test: " آپ نے اس سوالنامے میں ٹیسٹ مکمل کرلیا ہے۔",
    showQues_go_back_content_group: " واپس مواد کے گروپ پر جائیں ",
    //contentShare - viewUserScore
    viewUserScore_view_score: " اسکور دیکھیں ",
    viewUserScore_total_marks: " کل نمبر:",
    viewUserScore_scored_marks: " اسکور کردہ نمبر:",
    viewUserScore_GPA_score: " آپ کا جی پی اے اسکور:",
    viewUserScore_below_list_of_answer:
      " ذیل میں اس مواد گروپ کے تمام سوالنامے کے جوابات کی فہرست ہیں۔",
    viewUserScore_answered: " جواب دیا ",
    viewUserScore_correct_answer: " درست جواب ",
    //schedule - components
    //ConfirmCancelInvite
    confCancle_confirmation: " تصدیق ",
    confCancle_are_you_sure: " کیا تمہیں یقین ہے؟",
    confCancle_delete_user: " صارف کو حذف کریں ",
    //confirmscheduledelete
    confSche_are_you_sure_delete:
      " کیا آپ واقعی اس شیڈول کو حذف کرنا چاہتے ہیں؟",
    confSche_no: " نہیں ",
    //PastMeetingitem
    // "pastMtnItem_rn" : "RN",
    // "pastMtnItem_room_name" : " کمرے کا نام: ",
    // "pastMtnItem_webinar_list" : " ویبنار کی فہرست ",
    // "pastMtnItem_list_webinar" : " ذیل میں ویبنرز کی فہرست ہے۔",
    // "pastMtnItem_today" : " آج ",
    // "pastMtnItem_webinar_title_falls" : " ویبینار عنوان یہاں آتا ہے ",
    // "pastMtnItem_view" : " دیکھیں ",
    // "pastMtnItem_upcoming" : " آنے والا ",
    //SchedulesView
    //"scheView_edit_content" : " مواد میں ترمیم کریں ",
    scheView_scheduled_by: " طے شدہ: ",
    scheView_delete: " حذف کریں ",
    scheView_download_calander: " کیلنڈر ڈاؤن لوڈ کریں ",
    scheView_invite_participants: " شرکا کو مدعو کریں ",
    scheView_start_conference: " کانفرنس کا آغاز کریں ",
    scheView_event_details: " واقعہ کی تفصیلات ",
    scheView_room_name: " کمرے کا نام ",
    scheView_minutes: " منٹ ",
    scheView_conference_password: " کانفرنس کا پاس ورڈ ",
    scheView_settings: " ترتیبات ",
    scheView_webinar_event: " ویبنار تقریب ",
    scheView_list_webinar:
      " اس ویبنار ایونٹ کو instavc.com/webinar میں درج کریں ، اور رجسٹریشن قبول کریں۔",
    scheView_guest_login_anonymous:
      " مہمان گمنام کے طور پر لاگ ان کر سکتے ہیں ",
    scheView_allow_invities: " صرف دعوت نامے کو کانفرنس میں شرکت کی اجازت دیں ",
    scheView_enable_webinar_chat: " ویبنار چیٹ کو فعال کریں ",
    scheView_enable_hand_rise: " ویبنار میں ہاتھ اٹھانا فعال کریں ",
    scheView_list_of_people_invited: " ذیل میں مدعو افراد کی فہرست ہے ",
    scheView_alert_err_to_join: " شمولیت میں خرابی ",
    //WebinarDetails
    webnrDtls_upcoming_webinar_room:
      " اس کمرے کے لئے نیچے آنے والا ویبنار ذیل میں ہے۔",
    // Webinar 1
    // Webinar 2
    // Webinar 3
    webnrDtls_webinar_details: " ویبنار کی تفصیلات ",
    webnrDtls_webinar_list: " ویبنرز کی فہرست ",
    webnrDtls_webinar_title: " ویبنار عنوان ",
    webnrDtls_webinar_title_falls: " ویبنار عنوان یہاں پڑتا ہے ",
    webnrDtls_get_more_joining:
      " اس ویبینار میں شامل ہوکر مزید معلومات حاصل کریں۔",
    webnrDtls_join_webinar: " ویبنار میں شامل ہوں ",
    //webinarList
    webnrList_webinar_list: " ویبنار کی فہرست ",
    webnrList_below_list_of_webinar: " ذیل میں ویبینرز کی فہرست ہے۔",
    webnrList_today: " آج ",
    webnrList_webinar_title_falls: " ویبینار عنوان یہاں آتا ہے ",
    webnrList_view: " دیکھیں ",
    webnrList_upcoming: " آنے والا ",

    //schedule -
    //AddressBook
    addBook_address_book: " ایڈریس بک ",
    addBook_contact: " رابطے ",
    addBook_add_contact_to_meeting:
      "اپنے ایڈریس بک رابطوں سے سیشن میں رابطے شامل کریں۔",
    //MeetingList
    meetingList_past_meetings: "ماضی کے سیشنز",
    meetingList_past_meetings_list: "ماضی کے سیشنوں کی فہرست",
    meetingList_room_name: " کمرے کا نام:",
    meetingList_view_content: " مشمولات دیکھیں ",
    meetingList_recording: " ریکارڈنگ ",
    meetingList_view: " دیکھیں ",
    //scheduleInvite
    scheInvt_err_invalid_id: " غلط ای میل شناخت ",
    scheInvt_invite_participants: " شرکا کو مدعو کریں ",
    scheInvt_address_book: " ایڈریس بک ",
    scheInvt_invite_people_to_meeting:
      "لوگوں کو اس سیشن میں مدعو کریں۔ اپنی ایڈریس بک سے، یا ای میل ایڈریس ٹائپ کرکے لوگوں کو شامل کریں۔",
    scheInvt_start: " شروع ہوتا ہے @ ",
    scheInvt_below_list_of_answer:
      " ذیل میں اس مواد گروپ کے تمام سوالنامے کے جوابات کی فہرست ہیں۔",
    scheInvt_host: " میزبان:",
    scheInvt_minutes: " منٹ ",
    //Webinar 1
    scheInvt_add: " شامل کریں ",
    scheInvt_no_participants_added: " کوئی شریک نہیں شامل کیا ",
    scheInvt_add_ppl_to_meetings:
      "اپنی ایڈریس بک سے لوگوں کو اس سیشن میں بطور شرکاء شامل کریں، یا انہیں تلاش کے ذریعے شامل کریں۔",
    scheInvt_send_invitation: " دعوت نامہ بھیج دیں ",
    scheInvt_send_passcodes: " علیحدہ میل میں پاس کوڈ بھیجیں۔",
    //Invitation - component - invitationbody
    invitBody_invite_only_upto: " آپ صرف 10 لوگوں کو مدعو کرسکتے ہیں ",
    invitBody_invite_ppl_meeting_email_add:
      "لوگوں کو اس سیشن میں مدعو کریں، اپنی ایڈریس بک سے لوگوں کو شامل کریں، یا بذریعہ ای میل ایڈریس شامل کریں۔",
    invitBody_copy: " کاپی ",
    invitBody_enter_emailid: " ای میل کی شناخت درج کریں ",
    invitBody_close: " بند کریں ",
    invitBody_send_invitation: " دعوت نامہ بھیج دیں ",
    //documentShare
    //index,js
    docShare_doc_sharing: " دستاویز کا اشتراک ",
    docShare_upload_doc_system_pdf:
      " اپنے سسٹم سے دستاویز اپ لوڈ کریں ، یہ .pdf ، ایکسل ، ورڈ دستاویز کی حمایت کرتا ہے۔",
    docShare_upload_doc: " دستاویز اپ لوڈ کریں ",
    docShare_no_doc: " کوئی دستاویزات نہیں ",
    docShare_no_doc_in_list: " فہرست میں ابھی تک کوئی دستاویزات شامل نہیں ہیں۔",
    docShare_add_doc: " شامل دستاویزات ",
    docShare_alert_title_doc: " براہ کرم دستاویز کا عنوان درج کریں ",
    docShare_alert_something_went_wrong: " براہ کرم دوبارہ کوشش کریں ",
    //components - PermitDocShare
    permitDocShr_permit_doc_share_access: " اجازت دستاویز شیئر تک رسائی ",
    permitDocShr_req_permission_doc_share:
      " دستاویز شیئر تک رسائی کی اجازت کی درخواست کی ہے۔",
    permitDocShr_deny: " انکار کریں ",
    permitDocShr_allow: " اجازت دیں ",
    //components - RequestDocShare
    reqDocShr_req_doc_share_access: " دستاویز شیئر تک رسائی کی درخواست کریں ",
    reqDocShr_access_permission_host:
      " دستاویز شیئرنگ کو اہل بنانے کے لئے ، میزبان سے رسائی کی اجازت کی ضرورت ہے۔",
    reqDocShr_plz_wait: " برائے مہربانی انتظار کریں ",
    reqDocShr_permission_start_doc_share:
      "(میزبان) دستاویز کا اشتراک شروع کرنے کی اجازت۔",
    reqDocShr_doc_share: " دستاویز بانٹیں!",
    //components - ShowDocument View
    showDocViewback: " پیچھے ",
    showDocViewdoc_title_name: " دستاویز کا عنوان نام ",
    showDocViewnext: " اگلے ",
    showDocViewprevious: " پچھلا ",
    //Broadcast -
    //boradcastScreenShare
    borcstScreen_alert_unsupported:
      " غیر تعاون یافتہ پلے آرڈر کی درخواست کی گئی۔ تائید شدہ فارمیٹس webrtc اور hls ہیں۔ playOrder = webrtc، hls جیسی کوئی چیز استعمال کریں ",
    borcstScreen_alert_no_stream_spec:
      " کوئی ندی بیان نہیں کی گئی ہے۔ براہ کرم یو آر ایل میں؟ id = {STREAM_ID. شامل کریں ",
    borcstScreen_Plz_enable_js:
      " اس ویڈیو کو دیکھنے کے لئے ، براہ کرم جاوا اسکرپٹ کو چالو کریں ، اور کسی ایسے ویب براؤزر میں اپ گریڈ کرنے پر غور کریں جس سے ",
    borcstScreen_support_HTML5: " HTML5 ویڈیو کی حمایت کرتا ہے ",
    borcstScreen_steam_play_when_live:
      " جب یہ ویڈیو سلسلہ جاری رہے گا تب جاری رہے گا ",
    //broadcast
    broadcast_alert_unsupported:
      " غیر تعاون یافتہ پلے آرڈر کی درخواست کی گئی۔ تائید شدہ فارمیٹس webrtc اور hls ہیں۔ playOrder = webrtc، hls جیسی کوئی چیز استعمال کریں ",
    broadcast_alert_no_stream_spec:
      " کوئی ندی بیان نہیں کی گئی ہے۔ براہ کرم یو آر ایل میں؟ id = {STREAM_ID} شامل کریں ",
    broadcast_enter_your_name: " براہ مہربانی اپنا نام درج کریں ",
    broadcast_enter_your_email: " برائے مہربانی اپنا ای میل درج کریں ",
    broadcast_user_details: " صارف کی تفصیلات ",
    broadcast_submit_next: " جمع کرائیں ",
    broadcast_Plz_enable_js:
      " اس ویڈیو کو دیکھنے کے لئے ، براہ کرم جاوا اسکرپٹ کو چالو کریں ، اور کسی ایسے ویب براؤزر میں اپ گریڈ کرنے پر غور کریں جس سے ",
    broadcast_support_HTML5: " HTML5 ویڈیو کی حمایت کرتا ہے ",
    broadcast_steam_play_when_live: " ویڈیو بھاپ یہ چلائے جانے پر چلے گی ",
    //broadcastConference
    brdcstConf_whiteboard: " وائٹ بورڈ ",
    brdcstConf_screen_share: " اسکرین شیئر ",
    // "brdcstConf_participants" : " امیدوار ",
    brdcstConf_broadcast: " نشر کرنا ",
    brdcstConf_right: " ٹھیک ہے ",
    //broadcast - component
    //broadcasterParicipants
    brdcstPart_broadcast_list: " براڈکاسٹر لسٹ ",
    //Containers - calender
    //index
    calender_scheduled_calendar: " نظام الاوقات کیلنڈر ",
    calender_select_all: " تمام منتخب کریں ",
    calender_calender: " کیلنڈر ",
    calender_daily: " روزانہ ",
    calender_weekly: " ہفتہ وار ",
    calender_month: " مہینہ ",
    calender_today: " آج ",
    //Dashboard - componenet
    //MeetingReminder
    meetReminder_scheduled_confirm: " شیڈول تصدیق ",
    meetReminder_meeting_has_been_scheduled:
      "اس وقت مندرجہ ذیل سیشن طے کیا گیا ہے۔",
    meetReminder_start_meeting: "یہ سیشن شروع کریں۔",
    meetReminder_join_meeting: "اس سیشن میں شامل ہوں۔",
    meetReminder_quick_start_another_meeting: "ایک اور سیشن فوری شروع کریں۔",
    //MyMeetingItem
    myMeetItem_start: " شروع کریں ",
    myMeetItem_for: " کے لئے ",
    myMeetItem_minutes: " منٹ ",
    myMeetItem_host: " میزبان: ",
    //MyMeeting
    myMeet_my_meetings: "میرے سیشنز",
    myMeet_search_my_meetings: "میرے سیشن تلاش کریں۔",
    //NoScheduledMeeting
    noScheMeet_no_meeting_scheduled: "کوئی سیشن شیڈول نہیں ہے۔",
    noScheMeet_no_upcoming_meetings:
      "آپ کا ابھی تک کوئی آئندہ سیشن طے نہیں ہوا ہے۔ آپ ایک نیا شیڈول بنا سکتے ہیں یا اپنی کانفرنس کو ابھی شروع کر سکتے ہیں۔",
    noScheMeet_create_schedule: " نظام الاوقات بنائیں ",
    noScheMeet_quick_start: " فورا شروع کرنا ",
    noScheMeet_or: " یا ",
    //RoomSettings
    roomSet_alert_select_license: " برائے کرم لائسنس منتخب کریں ",
    roomSet_manage_licenses: " لائسنس کا انتظام کریں ",
    roomSet_package: " پیکیج ",
    roomSet_no_of_rooms: " کمروں کی تعداد ",
    roomSet_no_of_user: " صارفین کی تعداد ",
    roomSet_purchased_on: " پر خریدا گیا ",
    roomSet_expired_on: " میعاد ختم ہوگئی ",
    roomSet_create_room: " کمرہ بنائیں ",
    //conference - component
    //AddSipDevice
    addSipDev_add_sip_details: " ایس آئی پی کی تفصیلات شامل کریں ",
    addSipDev_sip_address: " ایس آئی پی ایڈریس:",
    addSipDev_connect: " جڑیں ",
    addSipDev_enter_sip_address: " ایس آئی پی ایڈریس درج کریں ",
    //ConfNotification
    confNotf_notification: " اطلاعات ",
    confNotf_user_name: " صارف کا نام ",
    confNotf_want_to_join: "اس سیشن روم میں شامل ہونا چاہتا ہے۔",
    confNotf_allow: " اجازت دیں ",
    confNotf_deny: " انکار کریں ",
    confNotf_ask_question: " ایک سوال پوچھا۔",
    confNotf_send_msg_lobby: " لابی کی طرف سے ایک پیغام بھیجا۔",
    //Loddy
    lobby_participants_loddy: " لابی میں شریک ",
    lobby_pramote_all: " سب کو فروغ دیں ",
    lobby_user_name: " صارف کا نام ",
    //RemoveUserDialog
    removeUserDlg_manage_user_selecting:
      " اس میں سے کسی بھی اختیارات کو منتخب کرکے اس صارف کا نظم کریں:",
    removeUserDlg_user_name: " صارف کا نام ",
    removeUserDlg_block_participant: " بلاک شریک ",
    removeUserDlg_send_to_lobby: " لابی کو بھیجیں ",
    removeUserDlg_remote_participant: " شریک کو ہٹا دیں ",
    removeUserDlg_close: " بند کریں ",
    //participantsList
    PartList_participants_in_lobby: " لابی میں شریک ",
    PartList_alert_something_went_wrong:
      " کچھ غلط ہو گیا ، براہ کرم دوبارہ کوشش کریں ",
    PartList_in_webinar: " ویبنار میں ",
    PartList_promote_all: " سب کو فروغ دیں ",
    //participants2020	Retry
    //WaitingRoom
    waitingRoom_waiting_room: " انتظار گاہ ",
    waitingRoom_plz_wait_host_allow:
      " براہ کرم انتظار کریں جب تک کہ میزبان آپ کو کانفرنس میں شامل ہونے کی اجازت نہیں دیتا ہے۔",
    waitingRoom_chat: " چیٹ ",
    waitingRoom_mins: " منٹ ",
    waitingRoom_no_msg_yet: " ابھی تک کوئی پیغامات نہیں!",
    waitingRoom_no_msg_from_host: " میزبان کی طرف سے کوئی پیغامات نہیں۔",
    //userRemoved
    userRemoved_you_removed_by_host:
      " میزبان کے ذریعہ آپ کو شرکاء کی فہرست سے ہٹا دیا گیا ہے ",
    //invitationSlide
    invitSlide_invite: " مدعو کریں ",
    invitSlide_add_email: " ای میلز شامل کریں ",
    invitSlide_add: " شامل کریں ",
    invitSlide_broadcast_list: " براڈکاسٹ لنک ",
    invitSlide_invite_people_to_meeting:
      "لوگوں کو اس سیشن میں مدعو کریں۔ لوگوں کو ان کا ای میل ایڈریس ٹائپ کرکے شامل کریں اور دعوت نامہ بھیجنے کے لیے فہرست میں شامل کریں۔",
    invitSlide_err_invalid_id: " غلط ای میل شناخت ",
    //participantsChat
    particiChat_no_chat_msg: " ابھی چیٹ کے کوئی پیغامات نہیں ہیں!",
    particiChat_start_conversation:
      " پیغامات کو دیکھنے کے لئے گفتگو شروع کریں۔",

    //components - lobbyparticipants
    lobbyPartici_no_participants: " کوئی شریک نہیں ",
    lobbyPartici_no_participants_lobby: " لابی میں کوئی شریک نہیں ہے۔",
    //conference
    //simulcast
    simulcast_alert_decline_access: " میزبان نے رسائی سے انکار کردیا ",
    simulcast_invalid_url: " غلط URL ",
    simulcast_no_host_available:
      " ایسا لگتا ہے کہ اس وقت کوئی میزبان دستیاب نہیں ہے ، براہ کرم اسکرین کا اشتراک کرنے کیلئے میزبان بنیں ",
    //simulcastVAD & // Conference.js
    conference_access_to_participants: " شرکاء تک رسائی ",
    conference_screen_share: " اسکرین شیئر ",
    conference_chat: " چیٹ ",
    conference_lock_all: " سب کو لاک کریں ",
    conference_lock_conf: " لاک کانفرنس ",
    conference_you_are_host: " آپ میزبان ہیں ",
    conference_share: " بانٹیں ",
    conference_document_share: " دستاویز بانٹیں ",
    conference_content_share: " مشمولات بانٹنا ",
    conference_more: " مزید...",
    conference_become_host: " میزبان بنیں ",
    conference_alert_no_host_aval_screen:
      " ایسا لگتا ہے کہ اس وقت کوئی میزبان دستیاب نہیں ہے ، براہ کرم اسکرین کا اشتراک کرنے کیلئے میزبان بنیں ",
    conference_alert_no_host_aval_doc:
      " ایسا لگتا ہے کہ اس وقت کوئی میزبان دستیاب نہیں ہے ، براہ کرم دستاویز کا اشتراک کرنے کے لئے میزبان بنیں ",
    conference_alert_err_sip_device: " گھونٹ آلہ کو مربوط کرنے میں خرابی ",
    conference_alert_host_decline_access: " میزبان نے رسائی سے انکار کردیا ",
    conference_alert_invalid_url: " غلط URL ",
    conference_unmute_mic_start_talk:
      " بات شروع کرنے کے لئے اپنے مائکروفون کو خاموش کریں ",
    // tools
    confTools_new_whiteboard: " آپ کا نیا وائٹ بورڈ یہاں آتا ہے ",
    confTools_video_sync: " آپ کا ویڈیو ہم آہنگی ",
    confTools_microphone: " مائکروفون ",
    confTools_type_text_here: " اپنا متن ٹائپ کریں ...",
    whiteboard: " وائٹ بورڈ ",
    //meetingRecording
    meetRec_video_rec_meeting_name: "سیشن کے نام کی ویڈیو ریکارڈنگز",
    meetRec_page_view: " صفحہ دیکھیں:",
    //meetingRecording- recordinglistview
    recListView_title_name_rec: " ریکارڈنگ کا عنوان نام ",
    recListView_name_user: " صارف کا نام ",
    // /////////////////////////////////////////////////////////////////////
    //Src
    //component - common - BrowserUpgrade
    brwUpg_req_fun_not_avail: " مطلوبہ فعالیت آپ کے براؤزر میں دستیاب نہیں ہے ",
    brwUpg_meeting_req_fun_sup:
      "اس سیشن سروس کے لیے فنکشنلسٹ درکار ہے جو آپ کے براؤزر سے تعاون یافتہ نہیں ہے۔",
    brwUpg_plz_upgrade:
      " براہ کرم اپ گریڈ کریں ، کسی دوسرے براؤزر میں سوئچ کریں ، یا اپنی ترتیبات کو چیک کریں۔ تائید شدہ براؤزر:",
    //"    Samsung Internet
    //component - common - header - header.js
    header_content: "مواد",
    header_loading: " لوڈ ہو رہا ہے…",

    //containers/admin/plans/components/createPlan.js
    crtePln_plz_enter_name: " برائے مہربانی اس منصوبے کا نام درج کریں ",
    crtePln_plz_amount_Plan: " برائے مہربانی منصوبہ کی رقم درج کریں ",
    crtePln_plz_enter_des: " براہ کرم تفصیل درج کریں ",
    crtePln_Plz_sel_product: " براہ کرم پروڈکٹ منتخب کریں ",
    crtePln_plz_sel_no_host: " براہ کرم نمبر منتخب کریں۔ میزبانوں کی ",
    crtePln_plz_enter_no_participants: " براہ کرم نمبر درج کریں شرکاء کی ",
    crtePln_plz_enter_roomno: " براہ کرم نمبر درج کریں کمروں کا ",
    crtePln_select_period: " براہ کرم مدت منتخب کریں ",
    crtePln_sel_interval: " براہ کرم وقفہ منتخب کریں ",
    crtePln_update_succ: " کامیابی کے ساتھ اپ ڈیٹ ہوا ",
    crtePln_err_creating_plan: " منصوبہ بنانے میں خرابی ",
    //containers/broadcast/components/BroadcastHandRaise.js
    brdcRaise_alert_question_50_char:
      " آپ کے سوال میں کم از کم 50 حروف کی بات چیت ہونی چاہئے ",
    //containers/conference/components/components
    cofCom_no_part_lobby: " لابی میں کوئی شریک نہیں ہے۔",
    //containers/conference/components/ConfirmUserDetails.js
    confmUser_plz_provide_name_email:
      " براہ کرم اپنا نام اور ای میل فراہم کریں ",
    confmUser_notes: " نوٹ ",
    //containers/conference/ConferenceSetup.js
    confSetup_telepresence: " ٹیلیفینس ",
    confSetup_alert_not_generate_meetingID:
      "سیشن آئی ڈی بنانے کے قابل نہیں، کچھ دیر بعد کوشش کریں۔",
    confSetup_auth_part_can_join: " صرف مجاز شرکاء ہی شامل ہوسکتے ہیں۔",
    confSetup_invalid_link: " غلط لنک ",
    confSetup_meeting_notyet_started:
      "یہ سیشن ابھی شروع نہیں ہوا ہے۔ براہ کرم بعد میں شامل ہوں! اگر آپ میزبان ہیں، تو براہ کرم instaVC میں لاگ ان کریں اور میٹنگ شروع کریں۔",
    confSetup_meeting_locked_byhost: "یہ سیشن میزبان کے ذریعہ مقفل ہے۔",
    confSetup_meeting_notyet_started_wait_host:
      "یہ سیشن ابھی شروع نہیں ہوا ہے۔ براہ کرم میزبان کے سیشن شروع ہونے کا انتظار کریں!",
    //containers/conference/components/NewChat.js",
    newChat_panel_chat: " پینل چارٹ ",
    //containers/conference/libs/InstaVC.js
    instaVc_server_busy:
      " لگتا ہے سرور مصروف ہے! دوسرے سرور سے رابطہ قائم کرنے کی کوشش کر رہا ہے…",
    //"    load-message",
    instaVc_server_busy_reload_tojoin:
      " لگتا ہے سرور مصروف ہے! کانفرنس میں شرکت کے لئے دوبارہ لوڈ کریں ",
    instaVc_broadcast_scr_failed: " براڈکاسٹ اسکرین ناکام ",
    instaVc_broadcast_failed: " براڈ کاسٹ ناکام ",
    instaVc_waiting_for_host: " میزبان ویڈیو کا انتظار ہے ",
    //containers/content/components/contentQuestionnaire/modal-create-quest-group.js
    modlCreate_plz_enter_title: " براہ کرم عنوان درج کریں ",
    modlCreate_poll: " پول ",
    //containers/content/components/contentQuestionnaire/modal-create-poll-question.js
    mdlCretPoll_plz_enter_quest: " براہ کرم سوال درج کریں ",
    mdlSubmit_pollsuccess: "پول کامیابی کے ساتھ جمع کرایا گیا۔",
    mdlCretPoll_option_should_not_same: " اختیارات ایک جیسے نہیں ہونے چاہئیں ",
    mdlCretPoll_plz_enter_option: " براہ کرم اختیارات درج کریں ",
    mdlCretPoll_plz_select_type_option: " براہ کرم اختیارات کی قسم منتخب کریں ",
    alert_server_error: " اندرونی سرور کی خرابی ، براہ کرم دوبارہ کوشش کریں ",
    mdlCretPoll_update_ques: "پول سوال کو اپ ڈیٹ کریں۔",
    mdlCretPoll_create_ques: " سوال بنائیں ",
    mdlCretPoll_enter_que_here: " اپنا سوال یہاں درج کریں ",
    mdlCretPoll_end: " ختم ",
    //containers/content/components/contentQuestionnaire/viewQuestionnaire.js
    delete_successfully: " کامیابی کے ساتھ حذف ہوا ",
    //containers/content/components/hozContentNavBlock.js / managecontent-index.js
    // "mngContent_mngContent_content" : " مواد ",
    // "mngContent_mngContent_participants" : " امیدوار ",
    mngContent_mngContent_fav_prog_lang:
      " آپ کو پروگرامنگ کی پسندیدہ زبان کیا ہے؟",
    mngContent_mngContent_pollings: " پولنگ ",

    //containers/contentShare/showQuestions.js
    showQue_obtained_marks: " حاصل کردہ نمبر:",
    //containers/contentShare/viewUserScore.js
    viewUser_your_grade: " آپ کا درجہ:",
    //containers/packages/Package.js
    package_one_host: "1 میزبان اور ",
    //"package_participants" : " امیدوار ",
    // SOHO
    //"    SMB 300
    package_concurrentUser_room2: "20 ہم آہنگی صارفین - 2 کمرے ",
    package_concurrentUser_room5: "30 ہم آہنگی صارفین -5 کمرے ",
    package_concurrentUser_room20: "100 ہم آہنگی صارفین - 20 کمرے ",
    package_concurrentUser_room30: "200 ہم آہنگی صارفین - 30 کمرے ",
    package_concurrentUser_room50: "500 ہم آہنگی صارفین - 50 کمرے ",
    //containers/schedule/components/PastMeetingItem.js
    pastMeeting_rn: "RN",
    pastMeeting_chat_history_deleted:
      " چیٹ کی تاریخ کامیابی کے ساتھ حذف ہوگئی ",
    pastMeeting_past_meeting_dtls: "گزشتہ سیشن کی تفصیلات",
    pastMeeting_duration: " دورانیہ:",
    pastMeeting_download_parti_atten: " شریک اور شرکاء کو ڈاؤن لوڈ کریں ",
    pastMeeting_download_webinar: " ویبنار ڈاؤن لوڈ کریں ",
    // "pastMeeting_participants" : " امیدوار ",
    pastMeeting_attendees: " شرکاء ",
    pastMeeting_chat_history: " چیٹ ہسٹری ",
    pastMeeting_recordings: " ریکارڈنگ ",
    pastMeeting_webinar_user: " ویبنار صارفین ",
    pastMeeting_webinar_chat: " ویبنار چیٹ ",
    pastMeeting_no_participants_in_meeting: "اس سیشن میں کوئی شریک نہیں!",
    pastMeeting_no_parti_attended_meeting: "اس سیشن میں کوئی شریک نہیں تھا۔",
    pastMeeting_guest_list: " مہمانوں کی فہرست ",
    pastMeeting_no_guest_in_meeting: " اس اجلاس میں مہمان نہیں!",
    "pastMeeting_no_guests_were_invited ":
      "اس سیشن میں کوئی مہمان ایسا نہیں تھا جسے مدعو کیا گیا ہو یا اس میں شرکت کی ہو۔",
    pastMeeting_meeting_chat_history: "سیشن چیٹ کی سرگزشت",
    pastMeeting_delete_all: " تمام حذف کریں ",
    pastMeeting_no_chat_msg_inmeeting: "اس سیشن میں کوئی چیٹ پیغامات نہیں!",
    pastMeeting_no_conver_during_meeting:
      "سیشن کے دوران چیٹ میں کوئی بات چیت نہیں ہوئی۔",
    pastMeeting_no_user_inwebinar: " اس ویبینار میں کوئی صارف نہیں!",
    pastMeeting_no_user_attand_webinar:
      " اس ویبینار میں شریک کوئی صارف نہیں تھا۔",
    pastMeeting_webinar_chat_history: " چیٹ ہسٹری ویبنار ",
    pastMeeting_no_chat_msg_inwebinar:
      " اس ویبینار میں کوئی چیٹ پیغامات نہیں ہیں!",
    pastMeeting_no_conver_during_webinar:
      " ویبنار کے دوران چیٹ میں کوئی گفتگو نہیں ہوئی۔",
    pastMeeting_del_chat_history: " چیٹ کی تاریخ کو حذف کریں ",
    pastMeeting_delete_all_chat_history:
      " کیا آپ واقعی چیٹ کی سبھی تاریخ کو مستقل طور پر حذف کرنا چاہتے ہیں؟",
    pastMeeting_delete: " حذف کریں ",
    //containers/schedule/components/Schedules.js
    schedul_webinar_description: " تفصیل ویبنار ",
    schedul_upload_custom_banner:
      " اپنے ویبنار ایونٹ کیلئے کسٹم بینر اپ لوڈ کریں۔",
    schedul_setting: " ترتیبات ",
    //containers/schedule/components/SchedulesView.js
    schedulView_time: " وقت ",
    schedulView_edit: " ترمیم ",
    schedulView_enable_training_mode: " ٹریننگ وضع کو فعال کریں ",
    schedulView_audio_conference: " آڈیو کانفرنس ",
    schedulView_enable_mix_video: " پہلے سے طے شدہ مکس ویڈیو کو فعال کریں ",

    //class components
    //content - components - hozContentNavBlock
    // "hozConNav_content" : " مواد ",
    //scheduleMeeting
    scheMeet_room_reserved_from: " کمرہ سے محفوظ ",
    scheMeet_meeting_name: "سیشن کے نام کے ساتھ",
    //dashboard - component -Contact
    contact_alert_already_in_call:
      " آپ دوسرے صارف کو کال نہیں کرسکتے ہیں ، جب آپ پہلے ہی کال میں ہوں گے ",
    contact_alert_user_offline: " صارف کا آف لائن ",
    //dashboard - dashboard.js
    dashboard_alert_cannot_start:
      " جب آپ دوسری کال میں ہوں تو آپ کانفرنس شروع نہیں کرسکتے ہیں ",
    dashboard_alert_cannot_join:
      " جب آپ دوسری کال میں ہوں تو آپ کانفرنس میں شامل نہیں ہوسکتے ہیں ",
    dashboard_quick_start_conf: " فوری آغاز کانفرنس ",
    dashboard_maintenance_msg:
      " براہ کرم نوٹ کریں کہ ہم معمول کی بحالی کی وجہ سے 22 اپریل 2020 کو صبح 8.30 بجے سے IST سے 9.00 بجے IST تک سرور کا سامنا کریں گے۔",
    //coBrowsing
    "coBrows_host_share-video":
      " برائے مہربانی انتظار کریں! میزبان ایک ویڈیو شیئر کرنے والا ہے ",
    //Additionalcamera
    addCam_add_device: " آلہ شامل کریں ",
    // genral same lang
    answer_list: " جوابات کی فہرست ",
    answer: " جوابات ",
    answered: " جواب دیا ",
    correct_answer: " درست جواب ",
    please_try_again: " دوبارہ کوشش کریں ",
    question: " سوال ",
    cancel: " منسوخ کریں ",
    questionnaire: " سوالنامہ ",
    content: " مواد ",
    address_book: " ایڈریس بک ",
    view: " دیکھیں ",
    rn: "RN",
    // new langs
    plz_sel_crtans: " براہ کرم درست جواب منتخب کریں ",
    truefalse_choice: " سچ / غلط انتخاب ",
    questionnarie: " سوالنامہ ",
    content_title: " مواد کا عنوان ",
    media_title: " میڈیا_ٹائٹل ",
    add_url_add: " یو آر ایل ایڈریس شامل کریں ...",
    val_shuld_grtr_from_val: " ویلیو سے زیادہ ہونا چاہئے ",
    val_shuld_grtr_grade: " قدر سے گریڈ سے زیادہ ہونا چاہئے ",
    to_val: " قدرکرنا ",
    enable_hand_raise:
      " کسی ویبینار میں ہاتھ اٹھانا / سوال پوچھیں کو فعال کریں ",
    enable_waiting_room: " ویٹنگ روم کو فعال کریں ",
    allow_only_invite: " صرف مدعو افراد کو کانفرنس میں شرکت کی اجازت دیں ",
    guest_login_anonymous: " مہمان گمنام کے طور پر لاگ ان کرسکتے ہیں ",
    give_name_webinar: " اپنے ویبینار کو ایک نام دیں ",
    Webinar: " ویبنار ",
    video_syn: " ویڈیو ہم آہنگی ",
    notepad: " نوٹ پیڈ ",
    enable_handraise: " کسی ویبینار میں ہاتھ اٹھانا فعال کریں ",
    pastMeeting_notes: " نوٹ ",
    //new one venkatesh
    polls_list: " پولس کی فہرست ",
    no_poll_assign: " ابھی تک کوئی پول تفویض نہیں کیا گیا ہے!",
    poll_view: " رائے شماری ",

    // new Prudhvi
    filter_block: " فلٹر بلاک ",
    file_size: " فائل کا ناپ ",
    select_room: " براہ کرم ایک کمرہ منتخب کریں ",
    provide_event_name: " براہ کرم واقعہ کا نام فراہم کریں ",
    end_time_greater_start_time:
      " اختتامی وقت آغاز کے وقت سے زیادہ ہونا چاہئے!",
    invite_people_meeting: "لوگوں کو اس سیشن میں مدعو کریں۔",
    download_ical: " iCal ڈاؤن لوڈ کریں ",
    download: " ڈاؤن لوڈ کریں ",
    delete_meeting: "اس سیشن کو حذف کریں۔ ",
    room: " کمرہ ",
    new_event: " نیا واقعہ ",
    end_repeat: " آخر دوبارہ ",
    invite_users_timezone: " مندرجہ ذیل ٹائم زون والے صارفین کو مدعو کریں ",
    update_event: " تازہ ترین واقعہ ",
    create_event: " واقعہ بنائیں ",
    wrong_password: " غلط پاس ورڈ ",
    college: " کالج ",
    university: " جامع درس گاہ ",
    country: " ملک ",
    time_period: " وقت کی مدت:",
    currently_working_here: " فی الحال یہاں کام کرنا ",
    from: " منجانب:",
    to: " تک:",
    graduated: " فارغ التحصیل ",
    enter_description: " اپنی تفصیل یہاں داخل کریں ...",
    concentration: " توجہ مرکوز کرنا ",
    school: " اسکول ",
    poll_question: "رائے شماری کے سوالات ",
    create_poll_ques: " رائے شماری بنائیں ",
    options: " اختیارات ",
    no_ques_assigned_yet: " ابھی تک کوئی سوال تفویض نہیں کیا گیا ہے!",
    create_new_ques_click_create_ques:
      " مندرجہ بالا سوالیہ بٹن کو کلک کرنے کے لئے ایک نئے سوالات بنائیں ",
    enter_room_name: " برائے مہربانی کمرے کا نام درج کریں ",
    billed_annually: "* سالانہ بل ",
    subscribe_now: " اب سبسکرائب کریں ",
    group: " گروپ ",
    sample_webinar: " نمونہ ویبینار ",
    webinar_affiliate: " متعلقہ افراد کے بارے میں ویبنار ",
    webinar_one: " ویبنار ایک ",
    workspace: " ورک اسپیس ",
    company: " کمپنی ",
    add_another: " ایک اور شامل کریں ",

    assignment: " تفویض ",
    assignments: " اسائنمنٹس ",
    create_new_poll: " تفویض کرنا شروع کرنے کے لئے ایک نیا پول سوال پیدا کریں۔",
    plz_title_url: " پلیز ٹائٹل اور یو آر ایل درج کریں ",
    votes: " ووٹ ",
    enter_content_title: " براہ کرم مواد کا عنوان درج کریں ",
    failed_result: " ناکام نتیجہ ",
    removed_successfully: " کامیابی کے ساتھ ہٹا دیا گیا ",
    enter_duration: " براہ کرم مدت درج کریں ",
    select_questionnarie: " براہ کرم سوالنامہ منتخب کریں ",
    no_assignments: " کوئی اسائنمنٹ نہیں ",
    create_new_assignment:
      " ایک نیا تفویض بنائیں ، تخلیق کرنے کے لئے مندرجہ بالا تفویض بٹن پر کلک کریں ",
    create_assignment: " تفویض بنائیں ",
    assignments_list: " اسائنمنٹس کی فہرست ",
    assignment_description: " تفویض کی تفصیل ",
    assignment_name: " تفویض نام ",
    update_assignment: " اسائنمنٹ کو اپ ڈیٹ کریں ",
    add_new_assignment: " نئی تفویض شامل کریں ",
    assignment_list: " تفویض کی فہرست ",
    assign_assignments: " اسائنمنٹس تفویض کریں ",
    assigned_assignments_list: " تفویض کردہ تفویض فہرست ",
    assignment_answer: " تفویض جواب ",
    no_assig_submitted: " ابھی تک کوئی تفویض پیش نہیں کیا گیا۔",
    no_assig_submitted_participants:
      " کسی بھی شریک کی طرف سے ابھی تک کوئی تفویض پیش نہیں کیا گیا ہے۔",
    assigned_participants: " شرکا کو تفویض کیا ",
    select_assignment: " تفویض منتخب کریں ",
    fill_your_assignment: " اپنی تفویض کو پُر کریں ",
    submit_assignment: " تفویض جمع کروائیں ",
    assignment_details: " تفویض کی تفصیلات ",
    assignment_submit_success: " تفویض کامیابی کے ساتھ جمع کرائی گئ ",
    assignment_saved_success: "تفویض کامیابی کے ساتھ محفوظ ہوگئی",
    how_to_get_started: " شروع کرنے کا طریقہ",
    create_new_room: " نیا کمرہ بنائیں ",
    create_room_add_participants:
      " ایک نیا کمرہ بنائیں اور شرکا کو کمرے میں شامل کریں۔",
    repeats_every: " ہر ایک کو دہراتا ہے ",
    now: " ابھی ",
    Plz_enter_title_meeting: "براہ کرم سیشن کا عنوان درج کریں۔",
    no_start_time: " آغاز کا کوئی وقت نہیں ملا ",
    no_end_time: " کوئی آخری وقت نہیں ملا ",
    item_id_not_found: " آئٹم کی شناخت نہیں ملی ",
    msg_title_not_found: " پیغام کا عنوان نہیں ملا ",
    plz_join_conf_clicking_link:
      " برائے کرم مندرجہ ذیل لنک پر کلک کرکے کانفرنس میں شامل ہوں ",
    room_permanently: " کمرہ مستقل طور پر؟",
    sure_want_to_delete_participants:
      " کیا آپ واقعی اس شریک کو حذف کرنا چاہتے ہیں؟",
    delete_participant: " شریک کو حذف کریں ",
    add_email: " ای میل شامل کریں ",
    add_participants_to_the_room:
      " اس کمرے میں شرکاء کو اپنا ای میل پتہ نیچے ان پٹ باکس میں ٹائپ کرکے شامل کریں۔",
    no_of_users: " صارفین کی تعداد نہیں ",
    edit_the_name:
      " آپ اس کمرے کے نام اور صارفین کی تعداد میں ترمیم کرسکتے ہیں۔",
    delete_room: " کمرہ حذف کریں ",
    are_you_sure_delete: " کیا آپ واقعی کو ختم کرنا چاہتے ہیں؟ ",
    delete_this_room: " اس کمرے کو حذف کریں ",
    delete_room_will_parmanently:
      " حذف پر کلک کرنے سے ، اس کمرے کو صاف طور پر حذف کردیا جائے گا۔",
    enable_storage: " اسٹوریج کو فعال کریں ",
    enable_recordings: " ریکارڈنگ کو فعال کریں ",
    enable_SIP: " ایس آئی پی کو فعال کریں ",
    addons: " اڈونز ",
    expires_on: " اختتامی میعاد ",
    purchased_on: " پر خریدا گیا ",
    more_storage: " مزید ذخیرہ ",
    total_storage: " کل ذخیرہ ",
    storage_occupied: " اسٹوریج پر قبضہ ",
    added: " شامل ",
    open_graphs: " گراف کھولیں ",
    participant_controls: " شرکاء کے کنٹرول ",
    "dashboard_controls ": " ڈیش بورڈ کنٹرولز ",
    start_meeting: "ایک سیشن شروع کریں۔",
    join_a_meeting: "ایک سیشن میں شامل ہوں۔",
    meeting_settings: " میٹنگ کی ترتیبات ",
    videos_to_get_started: " ویڈیوز شروع کرنے کے لئے ",
    if_you_are_host:
      "اگر آپ میزبان ہیں تو سیشن شروع کرنے کے لیے نیچے والے بٹن پر کلک کریں۔",
    guest_link: " مہمان لنک ",
    pay_now: " اب ادا ",
    promo_code_apply_here: " پرومو کوڈ ہے؟ یہاں درخواست دیں ",
    per_month: " فی مہینہ ",
    billed_for: " کے لئے بل ",
    gst_applicable:
      " سرکاری اصولوں کی تعمیل کے مطابق ، ہندوستان میں صارفین کے لئے اضافی 18٪ جی ایس ٹی لاگو ہوگا۔",
    select_country_code: " ملک کا کوڈ منتخب کریں ",
    country_code: " ملک کا کوڈ ",
    enter_email_id: " ای میل کی شناخت درج کریں ...",
    downLoad_chat: " ڈاؤن لوڈ لوڈ چیٹ ",
    allow_guest_control_their:
      " مہمان کو ان کی ویڈیو / آڈیو کو کنٹرول کرنے کی اجازت دیں ",
    below_list_people_invited: " ذیل میں مدعو افراد کی فہرست ہے ",
    verification_code: " تصدیقی کوڈ ",
    open_link_enter_verify_code:
      " نیچے یو آر ایل لنک کھولیں ، اور انضمام کے لئے اپنا توثیقی کوڈ درج کریں ",
    social_media_integration: " سوشل میڈیا انٹیگریشن ",
    integrate_social_media_platform:
      " آپ سوشل میڈیا پلیٹ فارم کو مربوط کرسکتے ہیں ، ایک بٹن پر کلک کرکے ، آپ کو توثیقی کوڈ ملے گا ، اس کو انضمام کے ل use استعمال کریں گے۔",
    plz_enter_val_email: " براہ کرم درست ای میل درج کریں ",
    in_conference: " کانفرنس میں ",
    password_if_any: " پاس ورڈ (اگر کوئی ہے)",
    stop_send: " روکیں اور بھیجیں ",
    broadcast_not_enabled_meeting: "اس سیشن کے لیے براڈکاسٹ فعال نہیں ہے۔",
    facebook_url: " فیس بک یو آر ایل ",
    enter_facebook_url: " فیس بک آر ٹی ایم بی یو آر ایل درج کریں ",
    add_facebook_url: " فیس بک آر ٹی ایم بی یو آر ایل درج کریں ",
    youtube_url: " یوٹیوب یو آر ایل ",
    enter_youtube_url: " یوٹیوب آر ٹی ایم بی یو آر ایل درج کریں ",
    add_youtube_url: " یوٹیوب آر ٹی ایم پی یو آر ایل شامل کریں ",
    register: " رجسٹر کریں ",
    time_of_program: " پروگرام کا وقت ",
    date_of_program: " پروگرام کی تاریخ ",
    name_program_interested: " دلچسپی رکھنے والے پروگرام کا نام ",
    email_id: " ای میل کا پتہ ",
    dob: " پیدائش کی تاریخ ",
    applicant_address: " درخواست دہندہ کا پتہ ",
    qualification: " اہلیت ",
    designation: " عہدہ ",
    org_name_address: " تنظیم کا نام اور پتہ ",
    fullname_participant: " شریک کا مکمل نام ",
    registration_form: " Registration Form ",
    thanks_submitting_data: " آپ کا ڈیٹا پیش کرنے کا شکریہ ",
    manage_content: " مشمولات کا نظم کریں ",
    API_settings: " API کی ترتیبات ",
    schedule_API: " شیڈول API ",
    image_upload_success: " شبیہہ کامیابی کے ساتھ اپ لوڈ ہوا ",
    less_than_10MB: " براہ کرم 10MB سے کم فائل اپ لوڈ کریں ",
    at_time_of_event: " واقعہ کے وقت ",
    min_5: "5 منٹ پہلے ",
    min_10: "10 منٹ پہلے ",
    min_15: "15 منٹ پہلے ",
    min_30: "30 منٹ پہلے ",
    hrs_1: "1 گھنٹہ پہلے ",
    hrs_2: "2 گھنٹہ پہلے ",
    day_1: "1 دن پہلے ",
    day_2: "2 دن پہلے ",
    jan: " جنوری ",
    feb: " فروری ",
    mar: " مارچ ",
    apr: " اپریل ",
    may: " مئی ",
    jun: " جون ",
    jul: " جولائی ",
    aug: " اگست ",
    sep: " ستمبر ",
    oct: " اکتوبر ",
    nov: " نومبر ",
    dec: " دسمبر ",
    mon: " پیر ",
    tue: " منگل ",
    wed: " بدھ ",
    thu: " جمعرات ",
    fri: " جمعہ ",
    sat: " ہفتہ ",
    sun: " اتوار ",
    all_day: " تمام دن ",
    starts_ddmmyyyy: " شروع ہوتا ہے (تاریخ / مہینہ / سال)",
    ends_ddmmyyyy: " ختم (تاریخ / مہینہ / سال) ",
    ddmmyyyy: " (تاریخ / مہینہ / سال) ",
    by_dayweek: " دن / ہفتہ کے ذریعہ ",
    never: " کبھی نہیں ",
    on_date: " تاریخ پر ",
    alert: " انتباہ ",
    multi_factor_auth: " ملٹی فیکٹر استناد (ایم ایف اے) کو قابل بنائیں",
    advanced_settings: " اعلی درجے کی ترتیبات ",
    verify_Otp: " او ٹی پی کی تصدیق کریں ",
    resend_Otp: " او ٹی پی کو دوبارہ بھیجیں ",
    otp_sent_mobile: " اپنے موبائل نمبر پر بھیجی گئی او ٹی پی درج کریں ",
    update_mobile: " موبائل کو اپ ڈیٹ کریں ",
    verify_mobile: " موبائل کی تصدیق کریں ",
    mob_verfi_pending: " آپ کے موبائل کی تصدیق زیر التوا ہے۔",
    mobile_number: " موبائل فون کانمبر ",
    enter_Otp: " او ٹی پی درج کریں ",
    enter_mob_no: " براہ کرم موبائل نمبر درج کریں ",
    sure_want_to_delete_rec: " کیا آپ واقعی ریکارڈنگ کو حذف کرنا چاہتے ہیں؟ ",
    delete_recording: " ریکارڈنگ کو حذف کریں ",
    invalid_credentials: " جعلی اسناد ",
    join_conf_by_clicking_link:
      " برائے کرم مندرجہ ذیل لنک پر کلک کرکے کانفرنس میں شامل ہوں ",
    hi_there: " ہیلو,",
    valid_room_name: " براہ کرم درست کمرے کا نام درج کریں ",
    internal_server_error: " داخلی سرور کی خرابی ، براہ کرم دوبارہ کوشش کریں ",
    room_limit_exceed: " کمرے کی حد تجاوز کرگئی ",
    cant_start_meeting_already_goingon:
      "آپ سیشن شروع نہیں کر سکتے، کیونکہ ایک سیشن پہلے سے جاری ہے۔",

    //new
    social_integration: "سماجی اتحاد",
    advanced: "اعلی درجے کی",
    add_youtube: "یوٹیوب شامل کریں",
    plugins: "پلگ انز",
    subtitles: "سب ٹائٹلز",
    view_local: "مقامی دیکھیں",
    hide_local: "مقامی چھپائیں",
    switch_conf_mode: "کانفرنس وضع میں سوئچ کریں",
    switch_pres_mode: "پریزنٹر موڈ پر سوئچ کریں",
    conference_locked: "کانفرنس مقفل ہے",
    conference_unlocked: "کانفرنس کھلا",
    sharing_tools: "شیئرنگ ٹولز",
    record: "ریکارڈ",
    recording: "ریکارڈنگ",
    plz_wait_host_shr_video:
      "برائے مہربانی انتظار کریں! میزبان ایک ویڈیو شیئر کرنے والا ہے",
    supported_sources_include: "معاون ذرائع میں شامل ہیں",

    team_plugins: "ٹیم پلگ انز",
    open: "کھولو",
    click: "کلک کریں",
    more_app: "زیادہ اطلاقات",
    upload_custom_app: "کسٹم ایپ اپ لوڈ کریں",
    download_team_plugin: "ٹیم پلگ ان ڈاؤن لوڈ کریں",
    install_mng_app_microsoft_team:
      "مائیکرو سافٹ ٹیموں میں ایپ کو انسٹال کرنے اور ان کا نظم کرنے کا طریقہ",
    microsoft_step1: "مرحلہ 1: مائیکرو سافٹ ٹیمیں کھولیں",
    microsoft_step1_para1:
      "شروع کرنے کے لئے ، پہلے آپ کو اس صفحے کے اوپری حصے میں موجود سسٹم میں ٹیم پلگ ان ڈاؤن لوڈ کرنے کی ضرورت ہے۔ پھر اپنی مائیکرو سافٹ ٹیمیں کھولیں اور منتخب کریں",
    microsoft_step1_para2:
      " ٹیم ایپس کو دیکھنے کے لئے ضمنی نیویگیشن سے اختیارات۔",
    microsoft_step2: "مرحلہ 2: مزید ایپس پر جائیں",
    microsoft_step2_para1:
      "یہاں آپ کو مزید ایپس نامی بٹن کے ساتھ کچھ ایپس مل سکتی ہیں۔ پر کلک کریں",
    microsoft_step2_para2:
      "مزید کسٹم اپ لوڈ آپشن اور اسٹور کے دیگر آپشنز کی جانچ پڑتال کرنے کیلئے۔",
    microsoft_step3: "مرحلہ 3: اپلی کیشن اپ لوڈ کریں",
    microsoft_step3_para1:
      "ایک بار جب آپ اسٹور کھولتے ہیں تو ، آپ کو ایک مل جاتا ہے",
    microsoft_step3_para2:
      " بائیں نیویگیشن میں آپشن. اس پر کلک کریں اور اپنی ڈاؤن لوڈ کردہ پلگ ان ایپ کو یہاں اپ لوڈ کریں۔",
    microsoft_step4: "مرحلہ 4: اسٹوریج سے InstaVC ایپ منتخب کریں",
    microsoft_step4_para1:
      "جب ونڈو اشارہ کرتی ہے تو ، اپنے سسٹم سے InstaVC پلگ ان ایپ کو منتخب کریں جو ڈاؤن لوڈ کیا گیا تھا (مرحلہ 1) اور کلک کریں",
    microsoft_step5: "مرحلہ 5: مائیکرو سافٹ ٹیموں میں اپ لوڈ کردہ ایپ",
    microsoft_step5_para1:
      "فائل اپ لوڈ کرنے کے بعد ، یہ مائیکروسافٹ ٹیم ایپس لسٹ میں اپ لوڈ ہوجاتی ہے۔ اس کے بعد آپ اسے دیکھنے اور ٹیموں میں شامل کرنے کے لئے ایپ پر کلک کرسکتے ہیں۔",
    microsoft_step6: "مرحلہ 6: انسٹا سی سی ایپ کھولیں",
    microsoft_step6_para1:
      "ایک بار جب آپ انسٹا سی سی ایپ پر کلک کرتے ہیں تو ، اب آپ پلگ ان ایپ کی مکمل تفصیلات کے ساتھ بٹن کو بھی دیکھ سکتے ہیں",
    microsoft_step6_para2:
      "اس ایپ کو مائیکرو سافٹ ٹیموں میں شامل کرنے کے لئے بٹن۔",
    microsoft_step7: "مرحلہ 7: انسٹا سی سی نے مائیکرو سافٹ ٹیموں میں شامل کیا",
    microsoft_step7_para1:
      "اب آپ کے ایپ کو آسان اور تخصیص بخش استعمال کے ل Microsoft بائیں طرف کی نیویگیشن پر مائیکرو سافٹ ٹیموں میں شامل کیا جائے گا۔",

    ddyymm: " تار‍یخ / مہ‍ینہ / سال ",
    fill_details_for_webinar:
      " برائے کرم و‍یبینار‍ کے لئے اپن‍ی رجسٹر‍یشن‍ ک‍ی‍ تفص‍یلات‍ پر پر کر‍یں ",
    microsoft_teams: " مائ‍یکرو‍ سافٹ ٹ‍یمیں ",
    microsoft_outlook: " مائ‍یکروسافٹ‍ آؤٹ لک ",
    select_the_plan: " براہ کرم منصوبہ منتخب کر‍یں ",
    enter_code: " براہ کرم کوڈ درج کر‍یں ",
    enter_valid_coupon_code: " براہ کرم درست کوپن کوڈ درج کر‍یں ",
    coupon_alreadt_taken: " یہ‍ کوپن کوڈ پہلے ہ‍ی‍ ل‍یا‍ گ‍یا‍ ہے ",
    error_updating_plan: " منصوبہ کو اپ ڈ‍یٹ‍ کرنے م‍یں‍ خراب‍ی ",
    unit: " یونٹ ",
    referrals: " حوالہ جات ",
    sel_coupon: " براہ کرم کوپن منتخب کر‍یں ",
    share_val_0_99: " ش‍یئر‍ و‍یلیو 0 سے 99 کے درم‍یان‍ ہون‍ی‍ چاہئے",
    enter_share_val: " براہ کرم ش‍یئر‍ و‍یلیو‍ درج کر‍یں ",
    valid_commission_per: " براہ کرم درست کم‍یشن‍ ف‍یصد‍ درج کر‍یں ",
    enter_commission_per: " برائے کرم کم‍یشن‍ ف‍یصد‍ درج کر‍یں ",
    enter_commission_name: " برائے کرم کم‍یشن‍ کا نام درج کر‍یں ",
    sync_successfully: " صارف‍ین‍ کام‍یابی‍ کے ساتھ ہم آہنگ‍ی‍ کرتے ہ‍یں ",
    room_deleted_suc: " کمرہ کام‍یابی‍ کے ساتھ حذف ہوگ‍یا ",
    lic_deleted_suc: " لائسنس کام‍یابی‍ کے ساتھ حذف ہوگ‍یا ",
    female: " عورت ",
    male: " مرد ",
    insta_conference: " انسٹا کانفرنس ",
    quick_meeting_by: "کی طرف سے فوری سیشن",
    in_lobby: " لاب‍ی‍ م‍یں ",
    switch_to_broadcast: " براڈکاسٹ پر جائ‍یں ",
    Broadcasters_5: " براڈکاسٹر (5)",
    Participants_5: " شرکاء (5)",
    search_participants: " شرکاء کو تلاش کر‍یں ",
    host_controls: " م‍یزبان‍ کنٹرولز ",
    deleteroom: " کمرے کو حذف کر‍یں ",
    pm: " پ‍ی‍ ا‍یم ",
    am: " صبح ",
    email_exist_inroom: " اس کمرے م‍یں‍ ا‍ی‍ م‍یل‍ پہلے سے موجود ہے ",
    type_a_message: " ا‍یک‍ پ‍یغام‍ ٹائپ کر‍یں…",
    please_enter_user_limit: " براہ کرم صارف ک‍ی‍ حد درج کر‍یں ",
    user_limit_exceeded: " صارف ک‍ی‍ حد سے تجاوز کرگ‍یا ",
    sel_country_code: " براہ کرم ملک کا کوڈ منتخب کر‍یں ",
    available_storage: " دست‍یاب‍ اسٹور‍یج ",
    enter_phone_number: " فون نمبر درج کر‍یں ",
    startdate_less_enddate:
      " براہ کرم آغاز ک‍ی‍ تار‍یخ‍ اختتام‍ی‍ تار‍یخ سے کم منتخب کر‍یں ",
    havent_add_data:
      " آپ نے ابھ‍ی‍ تک کوئ‍ی‍ ڈ‍یٹا‍ شامل نہ‍یں‍ ک‍یا‍ ہے ، براہ کرم ڈ‍یٹا‍ شامل کر‍یں‍۔",
    professional_skills: " پ‍یشہ‍ ورانہ مہارت ",
    enter_prof_skills: " پ‍یشہ‍ ورانہ مہارت درج کر‍یں ",
    Present_Invitations: " دعوت نامے پ‍یش‍ کر‍یں ",
    sending: " بھ‍یج‍ رہا ہے…",
    sent: " بھ‍یجا‍ گ‍یا ",
    invite_10ppl_only: " آپ صرف 10 لوگوں کو مدعو کرسکتے ہ‍یں ",
    join_meeting: "سیشن میں شامل ہوں۔",
    enter_doc_title: " دستاو‍یز‍ کا عنوان درج کر‍یں ",
    meeting_name: "سیشن کا نام",
    select_the_weeks: " براہ کرم ہفتوں کا انتخاب کر‍یں ",
    grade: " گر‍یڈ ",
    coference_ID: " کانفرنس ک‍ی‍ شناخت ...",
    dont_find_room_meetingid:
      "ہمیں کوئی کمرہ نہیں ملا، جو اس سیشن آئی ڈی سے وابستہ ہو۔",
    wireless_share: " وائرل‍یس‍ ش‍یئر ",
    video_layout: " و‍یڈیو‍ لے آؤٹ ",
    speaker_screen: " اسپ‍یکر‍ اسکر‍ین ",
    presentation_screen: " پر‍یزنٹیشن‍ اسکر‍ین ",
    multiple_display: " ا‍یک‍ سے ز‍یادہ‍ ڈسپلے ",
    hellow: " ہ‍یلو ",
    enter_passcode: " پاس کوڈ درج کر‍یں ",
    another_meeting_stillon:
      "ایک اور سیشن ابھی جاری ہے، آپ اس سیشن کو ابھی شروع نہیں کر سکتے",
    SIP_device: " ا‍یس‍ آئ‍ی‍ پ‍ی‍ ڈ‍یوائس ",
    instavc_whiteBoard: " انسٹا و‍ی‍ س‍ی‍ وائٹ بورڈ ",
    speaker: " اسپ‍یکر ",
    instavc_notepad: " انسٹا و‍ی‍ س‍ی‍ نوٹ پ‍یڈ ",
    promote_in: " کو فروغ د‍یں ",
    guest: " مہمان ",
    breakout_rooms: " بر‍یکآؤٹ‍ کمرے ",
    stop_broadcast: " نشر‍یات‍ بند کرو ",
    noise_suppress: " شور دبانے ",
    echo_cancel: " بازگشت منسوخ‍ی:",
    enter_name_here: " یہاں‍ نام درج کر‍یں ",
    Viewer: " ناظر‍ین ",
    SIP_user: " ا‍یس‍ آئ‍ی‍ پ‍ی‍ صارف ",
    remove_participants: " شرکا کو ہٹا د‍یں ",
    disable_audio_video: " ر‍یموٹ‍ آڈ‍یو‍ اور و‍یڈیو‍ کو غ‍یر‍ فعال کر‍یں ",
    disable_audio: " آڈ‍یو‍ کو غ‍یر‍ فعال کر‍یں ",
    enable_audio: " آڈ‍یو‍ کو فعال کر‍یں ",
    disable_video: " و‍یڈیو‍ کو غ‍یر‍ فعال کر‍یں ",
    enable_video: " و‍یڈیو‍ کو فعال کر‍یں ",
    audio_video: " آڈ‍یو‍ اور و‍یڈیو ",
    audio_only: " صرف آڈ‍یو ",
    video_only: " صرف و‍یڈیو ",
    outlook_addins: " آؤٹ لک ا‍یڈ‍ انز ",
    install_microsoft:
      " مائ‍یکروسافٹ‍ آؤٹ لک م‍یں‍ ا‍یڈز‍ انسٹال کرنے اور ان کا نظم کرنے کا طر‍یقہ ",
    outlook_step1: " مرحلہ 1: لنک کاپ‍ی‍ کر‍یں‍ اور آؤٹ لک کھول‍یں ",
    first_copy_link: " پہلے لنک کو کاپ‍ی‍ کر‍یں ",
    add_plugin_oulook:
      " پلگ ان کو اپنے آؤٹ لک م‍یں‍ شامل کرنے ک‍یلئے یہاں‍ سے۔",
    outlook_step2: " مرحلہ 2: ا‍یڈ‍ انز حاصل کر‍یں ",
    outlook_step2_para:
      " اب آؤٹ لک کو کھول‍یں‍ اور ہوم ٹ‍یب‍ کے تحت آپ کو ا‍یڈ‍ ان ان حاصل کر‍یں‍ کا آپشن مل سکتا ہے۔ ا‍یڈ‍ انز اور د‍یگر‍ کسٹم آپشنز د‍یکھنے‍ ک‍یلئے‍ اس پر کلک کر‍یں‍۔",
    outlook_step3: " مرحلہ 3: م‍یری‍ ا‍یڈ‍ انز ",
    outlook_step3_para:
      " اب آپ بائ‍یں‍ ن‍یویگیشن‍ کے ساتھ شامل کردہ صفحہ د‍یکھ‍ سکتے ہ‍یں‍۔ اپن‍ی‍ ا‍یڈز‍ کو منظم کرنے کے لئے م‍یری‍ ا‍یڈز‍ پر جائ‍یں‍۔",
    outlook_step4: " مرحلہ 4: کسٹم ا‍یڈ‍ شامل کر‍یں ",
    outlook_step4_para:
      " یہاں‍ آپ کو م‍یری‍ ا‍یڈ‍ انز پ‍یج‍ م‍یں‍ کسٹم ا‍یڈ ان ان کسٹم اڈ انس کے تحت ڈراپ ڈاؤن ڈاؤن ا‍یڈ‍ کسٹم ا‍یڈ‍ ان ان مل سکتا ہے۔ ڈراپ ڈاؤن سے ‍یو‍ آر ا‍یل‍ سے شامل کر‍یں‍ کا انتخاب کر‍یں‍۔",
    outlook_step5: " مرحلہ 5: یو‍ آر ا‍یل‍ سے نج‍ی‍ ا‍یڈ‍ ان شامل کر‍یں ",
    outlook_step5_para:
      " اب آپ ‍یو‍ آر ا‍یل‍ سے نج‍ی‍ ا‍یڈ‍ ان شامل کرنے کے لئے پوپ اپ د‍یکھ‍ سکتے ہ‍یں‍۔ اب ان پٹ ف‍یلڈ‍ م‍یں‍ جس لنک ک‍ی‍ آپ نے کاپ‍ی‍ ک‍ی (مرحلہ 1) چسپاں کر‍یں‍ اور ٹھ‍یک‍ ہے پر کلک کر‍یں‍ ، اس سے آؤٹ لک م‍یں‍ ا‍یڈ‍ ان انسٹال ہوجاتا ہے۔",
    outlook_step6:
      " مرحلہ 6: انسٹا س‍ی‍ س‍ی‍ نے م‍یری‍ ا‍یڈ‍ انز م‍یں‍ شامل ک‍یا ",
    outlook_step6_para:
      " شامل کرنے کے بعد ، آپ اپن‍ی‍ م‍یری‍ ا‍یڈ‍-انز ک‍ی‍ فہرست م‍یں‍ شامل کردہ اضافے کو چ‍یک‍ کرسکتے ہ‍یں‍۔ ‍یہاں‍ سے آپ اپن‍ی‍ ا‍یڈز‍ کو مز‍ید‍ منظم کرسکتے ہ‍یں‍۔",
    outlook_step7: " مرحلہ 7: آؤٹ لک کو بند کر‍یں‍ اور دوبارہ کھول‍یں ",
    outlook_step7_para:
      " انسٹال کرنے کے بعد ، اس بات کو ‍یقینی بنائ‍یں‍ کہ آپ ا‍یک‍ بار مکمل آؤٹ لک بند کرد‍یں‍ اور ا‍یڈ‍ کو د‍یکھنے‍ کے لئے دوبارہ کھل‍یں‍۔",
    outlook_step8: " مرحلہ 8: نئے آئٹمز پر جائ‍یں ",
    outlook_step8_para:
      " آؤٹ لک کھولنے کے بعد ، اب آپ نئ‍ی‍ م‍یٹنگز م‍یں‍ جاسکتے ہ‍یں & # 62؛ انسٹاو‍یسی‍ کو د‍یکھنے‍ کے لئے م‍یٹنگ‍ آؤٹ لک م‍یں‍ شامل ک‍ی‍ گئ‍ی‍۔",
    outlook_step9: " مرحلہ 9: انسٹا و‍ی‍ س‍ی‍ م‍یٹنگ‍ ک‍ی‍ اوپن کر‍یں ",
    outlook_step9_para:
      " ا‍یک‍ بار جب آپ م‍یٹنگز‍ کھولتے ہ‍یں‍ تو ، آپ کو م‍یٹنگز‍ ٹ‍یب‍ کے تحت اوپر‍ی‍ بار م‍یں‍ انسٹا و‍ی‍ س‍ی‍ م‍یٹنگ‍ م‍یں‍ شامل ا‍یڈ‍ انوائس کے ساتھ کمپوز م‍یل‍ ونڈو کے ساتھ کھول د‍یا‍ جائے گا۔",
    outlook_step10: " مرحلہ 10: نظام الاوقات بنائ‍یں ",
    outlook_step10_para:
      " کمپوز م‍یل‍ لے آؤٹ سے ، ن‍یا‍ ش‍یڈول‍ ت‍یار کرنے کے لئے انسٹاو‍یک‍ م‍یٹنگز‍ پر کلک کر‍یں‍۔ اگر ‍یہ‍ پہل‍ی‍ بار ہے تو آپ کو دائ‍یں‍ طرف انسٹا س‍ی‍ س‍ی‍ م‍یٹنگ‍ لاگ ان کے ساتھ کھولا جائے گا۔ پہلے سے لاگ ان صارف‍ین‍ کے ل rooms ، انہ‍یں‍ کمروں ک‍ی‍ فہرست م‍یں‍ بھ‍یج‍ د‍یا‍ جائے گا اور ش‍یڈول بنا‍یا‍ جاسکتا ہے۔",
    outlook_step11: " مرحلہ 11: انسٹا و‍ی‍ س‍ی‍ م‍یٹنگ‍ ک‍ی‍ اوپن کر‍یں ",
    outlook_step11_para:
      " آپ بائ‍یں‍ طرف ا‍یک‍ ش‍یڈول‍ تشک‍یل‍ دے سکتے ہ‍یں‍ اور کس‍ی‍ خاص کمرے م‍یں‍ م‍یٹنگ‍ کے ش‍یڈول‍ کے لئے دائ‍یں‍ جانب ا‍یک‍ کمرہ منتخب کرسکتے ہ‍یں‍۔ ا‍یک‍ بار ش‍یڈول‍ بنانے کے بعد ، آپ ابھ‍ی‍ م‍یٹنگ‍ کا آغاز بٹن د‍یکھ سکتے ہ‍یں‍۔ ‍یہاں‍ سے آپ کلک کر کے م‍یٹنگ‍ کا آغاز کرسکتے ہ‍یں‍۔",
    outlook_step12: " مرحلہ 12: تقو‍یم‍ ک‍یلنڈر‍ م‍یں‍ د‍یکھیں ",
    outlook_step12_para:
      " ا‍یک‍ بار جب آپ ش‍یڈول‍ ت‍یار‍ کرل‍یں‍ ، اگل‍ی بار جب آپ ک‍یلنڈر‍ کھول‍یں‍ گے ، تو آپ اپنے نظام الاوقات بھ‍ی‍ ک‍یلنڈر‍ م‍یں‍ د‍یکھ   سکتے ہ‍یں‍۔",
    outlook_step13: " مرحلہ 13: نظام الاوقات ت‍یار‍ ک‍یا‍ گ‍یا ",
    outlook_step13_para:
      " ا‍یک‍ بار ش‍یڈول‍ بنانے کے بعد ، آپ اس کے بعد ت‍یار‍ کردہ م‍یل‍ کو دائ‍یں‍ جانب اسٹارٹ م‍یٹنگ‍ اسٹارٹ بٹن کے ساتھ د‍یکھ‍ سکتے ہ‍یں‍۔",
    sel_declaration: " براہ کرم اعلام‍یہ‍ منتخب کر‍یں ",
    enter_company_code: " براہ کرم کمپن‍ی‍ کا کوڈ درج کر‍یں ",
    invalid_company_code: " کمپن‍ی‍ کا غلط کوڈ ",
    affiliate_acc: " آپ کے ملحقہ اکاؤنٹ ک‍ی‍ منظور‍ی‍ ز‍یر‍ التوا ہے۔",
    aff_acc_approved: " آپ کا وابستہ اکاؤنٹ منظور ہوگ‍یا‍ ہے۔",
    aff_acc_rej: " آپ کا ملحقہ اکاؤنٹ مسترد کرد‍یا‍ گ‍یا‍ ہے۔",
    aff_TC: " وابستہ شرائط و ضوابط ",
    ref_par_agreement: " ر‍یفریل‍ پارٹنر معاہدہ ",
    aff_partner_agreement:
      'یہ‍ پارٹنر معاہدہ ، اس کور پ‍یج‍ اور منسلک کاروبار‍ی شرائط (اجتماع‍ی طور پر ، یہ "معاہدہ") پر مشتمل ہے ، اور پ‍یپل‍ لنک یونیفائیڈ‍ مواصلات پرائ‍یوٹ‍ لم‍یٹڈ (جسے پ‍یپل‍ لنک کے نام سے بھ‍ی‍ جانا جاتا ہے) اور پارٹنر  کے ماب‍ین‍ بنا‍یا‍ گ‍یا ہے یا  "پ‍ارٹنر" یا "آپ" سے مراد وہ شخص یا کمپن‍ی (جس م‍یں‍ کمپن‍ی‍ کا نام اور د‍یگر‍ معلومات شامل ہ‍یں) فارم م‍یں‍ داخل ہ‍یں‍۔ معاہدہ آپ کے معاہدے ک‍ی‍ قبول‍یت‍ ک‍ی‍ نشاندہ‍ی‍ کرنے کے لئے ر‍یفلل‍ پارٹنر پروگرام فارم ("فارم") مکمل اور جمع کرانے کے بعد ا‍یک‍ بار پابند ہوجائے گا۔ پ‍یپل‍ لنک او‍ر‍ پارٹنر کو بعض اوقات "پارٹ‍ی‍" اور ا‍یک‍ ساتھ "پارٹ‍یوں‍" کہا جاتا ہے۔ ',
    "background ": " پس منظر ",
    aff_market_advertise:
      ' پ‍یپل‍ لنک انسٹا و‍ی‍ س‍ی یونیفائیڈ‍ مواصلات‍ی خدمات اور حل پ‍یش‍ کرتا ہے۔ پارٹنر اس معاہدے کے مطابق ، اپن‍ی‍ و‍یب سائٹ (زبان‍یں) اور د‍یگر‍ مارک‍یٹنگ‍ چ‍ینلز‍ کے ذر‍یعہ‍ ، پ‍یپل‍ لنک مصنوعات اور ممکنہ پ‍یپل‍ لنک صارف‍ین ("حوالہ") کے حل ک‍ی‍ تشہ‍یر‍ ، مارک‍یٹنگ‍ اور تشہ‍یر‍ کرنا چاہتا ہے۔',
    agreement: " معاہدہ ",
    aff_parties_agree: " جماعت‍یں‍ مندرجہ ذ‍یل‍ طور پر متفق ہ‍یں:",
    heading1: " پروگرام کم‍یٹییں ",
    heading2: " کوال‍یفائیڈ‍ ر‍یفرنلز‍ ، کم‍یٹی‍۔",
    heading3: " اصطلاح اور مدت۔",
    heading4: " عام ",
    the_program: " پروگرام. ",
    to_participate_program_partner:
      ' پروگرام م‍یں‍ حصہ ل‍ینے‍ کے لئے پارٹنر کو پ‍یپلز لنک یا‍ اس سے وابستہ و‍یب سائٹ ("سائٹ") پر پائے جانے والے پروگرام م‍یں‍ شرکت کے لئے آن لائن درخواست مکمل کرنا ہوگ‍ی اور یہ‍ معاہدہ درج کرنا ہوگا۔ لوگ لنک کس‍ی‍ بھ‍ی‍ درخواست کو اپن‍ی‍ صوابد‍ید پر قبول یا‍ مسترد کرسکتے ہ‍یں‍۔',
    aff_str11: " قانون‍ی‍ معاہدے",
    aff_str12: " تشہ‍یر‍ ، حوالہ دار سرگرم‍یاں:",
    aff_str13: " ممنوعہ سرگرم‍یاں",
    aff_str14: " پ‍یپل‍ لنک مارکس کا قابل اجازت استعمال ",
    aff_str15: " واجبات",
    aff_str16: " گاہک سے تعلق.",
    aff_str11_para:
      "پروگرام م‍یں‍ اور اس کے شر‍یک‍ ہونے کے بطور ، پ‍یپلز‍ لنک کے پارٹنر ک‍ی‍ ح‍یثیت‍ سے ، شراکت دار اس معاہدے اور پروگرام ، رہنما خطوط ، اور پ‍یپلز‍ ل‍ینک‍ کے ذر‍یعہ‍ وقتا فوقتا مقرر کردہ کس‍ی‍ بھ‍ی‍ دوسر‍ی درخواستوں اور قواعد سے اتفاق کرتا ہے۔ اس کے معقول صوابد‍ید‍ م‍یں‍ ، پروگرام م‍ی‍ں پارٹنر ک‍ی‍ جار‍ی‍ شرکت اور پ‍یپلز‍ لنک پروڈکٹس ، حل اور خدمت کے حوالہ جات   کے فروغ کے سلسلے م‍یں‍۔ اس معاہدے کے تحت اپن‍ی‍ تمام سرگرم‍یوں‍ م‍یں‍ ، اور پارٹنر ک‍ی‍ پ‍یپلز‍ لنک کے فروغ سے متعلق ا‍یسی‍ مخصوص سرگرم‍یاں‍ ، پارٹنر پ‍یپل لنک کے ساتھ تعاون کر‍یں‍ گے اور ن‍یک‍ ن‍یتی‍ کے ساتھ کام کر‍یں‍ گے۔ اس معاہدے م‍یں داخل ہونے سے پارٹنر ، پ‍یپلز‍ لنک ک‍ی‍ خدمات ک‍ی‍ شرائط م‍یں‍ طے کردہ شرائط و ضوابط کو مز‍ید‍ تسل‍یم‍ اور قبول کرتا ہے۔",
    aff_str12_para:
      " پارٹنر لائسنس ‍یافتہ‍ مارکس اور مارک‍یٹنگ‍ م‍یٹریلز کا استعمال کرتے ہوئے مختلف مارک‍یٹنگ‍ چ‍ینلز‍ م‍یں‍ پ‍یپل‍ لنک پروڈکٹس اور حل ک‍ی مسلسل ، فعال فروغ م‍یں‍ شامل ہونے پر اتفاق کرتا ہے ، اور اس معاہدے ک‍ی‍ شرائط ک‍ی‍ تعم‍یل‍ م‍یں‍ ا‍یسا‍ کرتا ہے۔",
    aff_str13_para:
      ' پارٹنر مارک‍یٹنگ‍ مواد کو کس‍ی‍ بھ‍ی‍ طرح سے غ‍یر قانون‍ی‍ طور پر منسلک کرنے پر متفق نہ‍یں ہے ، یا‍ جو نقصان دہ ، دھمک‍ی‍ آم‍یز‍ ، ہتک آم‍یز‍ ، فحش ، ناگوار ، ہراساں کرنے ، جنس‍ی‍ طور پر صر‍یح‍ ، متشدد ، امت‍یازی سلوک ، یا‍ پ‍یپلز‍ ل‍ینک‍ ک‍ی‍ صوابد‍یدی‍ طور پر قابل اعتراض ہے۔ ساتھ‍ی متف‍ق‍ ہے کہ متعدد غ‍یر متعلقہ وصول کنندگان ("اسپ‍یمنگ") کو پ‍یپل‍ لنک خدمات اور حل کو فروغ د‍ینے‍ م‍یں ، یا‍ بصورت د‍یگر‍ اس معاہدے کے تحت منعقدہ سرگرم‍یوں کے سلسلے م‍یں‍ قانون کے ذر‍یعہ‍ ممنوعہ بڑے پ‍یمانے‍ پر ال‍یکٹرانک‍ مواصلات ک‍ی‍ کس‍ی بھ‍ی‍ طرح م‍یں‍ ملوث ہونے پر اتفاق نہ‍یں کرتا ہے‍۔',
    aff_str14_para1:
      " پارٹنر واضح طور پر لائسنس ‍یافتہ‍ نمبروں کے استعمال اور مارک‍یٹنگ‍ کے سامان ت‍یار‍ کرنے م‍یں‍ ان تمام شرائط ک‍ی‍ تعم‍یل‍ کرنے پر اتفاق کرتا ہے۔",
    aff_str14_para2:
      " رہنما خطوط اور دوسر‍ی‍ صورت م‍یں‍ ، پ‍یپلز‍ لنک وقتا فوقتا وضاحت‍یں‍ اور د‍یگر‍ ہدا‍یات‍ مہ‍یا‍ کرے گا تا کہ شراکت دار کے لائسنس یافتہ‍ نشانوں کا مارک‍یٹنگ‍ م‍یٹریلیز‍ بنانے اور پ‍یپل‍ لنک سروس کو فروغ د‍ینے م‍یں‍ جائز استعمال ہو۔ ساتھ‍ی‍ اس طرح ک‍ی‍ تمام وضاحت‍یں‍ اور ہدا‍یات‍ ک‍ی‍ تعم‍یل کرنے‍ پر اتفاق کرتا ہے۔",
    aff_str14_para3:
      " پارٹنر اس بات کو ‍یقینی‍ بنائے گا کہ اس کے مارک‍یٹنگ‍ م‍یٹریلز‍ پر دکھائے جانے والے تمام لائسنس شدہ نشانات رہنما خطوط م‍یں پ‍یپل‍ لنک کے ذر‍یعہ‍ منظور شدہ فارم م‍یں‍ موجود ہ‍یں یا‍ کس‍ی‍ اور طرح سے ، پ‍یپل لنک کے ذر‍یعہ‍ فراہم کردہ معقول ہدا‍یات‍ کے برخلاف ، کس‍ی‍ بھ‍ی‍ پ‍یپلز‍ ل‍ینک مارکس م‍یں‍ ترم‍یم‍ نہ‍یں‍ کر‍یں گے یا‍ د‍یگر‍ مارک‍یٹنگ‍ کے مواد م‍یں‍ کاف‍ی‍ حد تک ترم‍یم‍ نہ‍یں کر‍یں‍ گے ، اور مز‍ید‍ تعم‍یل‍ کر‍یں‍ گے۔ مارک‍یٹنگ‍ م‍یٹریلز‍ ک‍ی‍ شکل ، مواد اور نمائش کے بارے م‍یں‍ پ‍یپل‍ لنک ک‍ی‍ معقول ہدا‍یت‍ کے ساتھ۔ کس‍ی‍ بھ‍ی وجہ سے ، یا پ‍یپل‍ لنک ک‍ی‍ تحر‍یری‍ درخواست پر ، اس م‍عاہدے کے ختم ہونے پر ، یہاں‍ د‍یا‍ ہوا لائسنس ختم ہوجائے گا اور پارٹنر اس معاہدے کے تحت فور‍ی‍ طور پر اپن‍ی‍ تمام سرگرم‍یاں‍ ختم کردے گا۔",
    aff_str15_para:
      " شراکت دار اس معاہدے کے تحت عمل کرنے م‍یں‍ اپن‍ی کارروائ‍یوں‍ کا مکمل طور پر ذمہ دار ہوگا ، اس معاہدے کے سلسلے م‍یں‍ تخل‍یق کردہ اور استعمال کردہ ساتھ‍ی‍ کے کاموں اور مواد ک‍ی‍ قانون‍ی‍ ح‍یثیت‍ ، بشمول ، کس‍ی‍ حد کے بغ‍یر‍۔ سوائے اس دعوے کے جو کہ پ‍یپل‍ لنک مارک کس‍ی‍ ت‍یسری‍ پارٹ‍ی کے تجارت‍ی‍ نشان کے حقوق ک‍ی‍ خلاف ورز‍ی‍ کرتا ہے ، پ‍یپل‍ لنک شراکت دار کے مارک‍یٹنگ مواد ک‍ی‍ ترق‍ی‍ ، کارروائ‍ی یا‍ اس کے مشمولات کا ذمہ دار نہ‍یں‍ ہے اور پارٹنر ، پ‍یپل‍ لنک کو کس‍ی‍ بھ‍ی‍ دعوے ، کارروائ‍یوں‍ ، وجوہات کے خلاف کوئ‍ی‍ نقصان نہ‍یں پہنچا سکتا۔ پارٹنر کے مارک‍یٹنگ‍ کے س‍امان‍ ک‍ی‍ ترق‍ی‍ ، عمل ، مشمولات اور د‍یکھ بھال سے متعلق کارروائ‍ی ، نقصانات ، یا اخراجات (اٹارن‍ی‍ ف‍یسوں‍ سم‍یت)۔",
    aff_str16_para:
      " مدت کے دوران اور اس کے بعد ، پ‍یپل‍ لنک ، پ‍یپل لنک اور ر‍یفرلز‍ کے ماب‍ین‍ شراکت کے ذر‍یعے‍ بن‍ی‍ نوع‍یت‍ کے تعلقات کے خصوص‍ی‍ مالک ہوں گے ، بشمول کس‍ی‍ بھ‍ی‍ اور تمام معلومات ک‍ی‍ نشاندہ‍ی‍ کرنے والے ر‍یفرلز‍ جو پ‍یپل‍ لنک سروس کے استعمال کے لئے پ‍یپل‍ لنک کے ساتھ معاہدہ کرتے ہ‍یں‍۔ پ‍یپل لنک سروس کے لئے شرائط ، رازدار‍ی‍ ک‍ی‍ پال‍یسی‍ ، اور پ‍یپل‍ لنک کے قواعد و ضوابط ان ر‍یفرلز‍ پر لاگو ہوں گے اور ان کو پارٹنر کو پ‍یشگی‍ اطلاع کے بغ‍یر‍ پ‍یپل‍ لنک   کے ذر‍یعہ‍ تبد‍یل‍ ک‍یا‍ جاسکتا ہے ، اور پارٹنر ان شرائط کے تحت پ‍یپلز‍ لنک کے ساتھ اپنے تعلقات ک‍ی‍ نوع‍یت‍ کے حوال‍ے‍ بتانے پر اتفاق کرتا ہے۔",
    aff_str20_para1:
      " پارٹنر کے ذر‍یعہ‍ پ‍یپل‍ لنک کو حوالہ د‍یا‍ گ‍یا‍ ہے اور جو ن‍یچے دفعہ 3 (ب‍ی) م‍یں‍ ب‍یان‍ کردہ طر‍یقہ‍ کار کے مطابق سائن اپ کے عمل کو مکمل کرتے ہ‍یں‍۔",
    aff_str20_para2:
      " پ‍یپل‍ لنک ک‍ی‍ خدمات کے سلسلے م‍یں‍ پ‍یپلز‍ لنک کا کوئ‍ی‍ ر‍یکارڈ‍ نہ‍یں ہے ، یا‍ وہ ، جو اس وقت پارٹنر کے ذر‍یعہ‍ ، پ‍یپر‍ لنک کے ساتھ کس‍ی‍ بھ‍ی معاہدہ تعلقات یا‍ پ‍یپل‍ لنک سروس کے سلسلے م‍یں‍ جار‍ی‍ مذاکرات کے سلسلے م‍یں‍ پ‍یپلز‍ لنک کے حوالے ک‍یا‍ جاتا ہے۔",
    aff_str20_para3:
      " جو شرائط کو قبول کرتے ہ‍یں‍ اور ا‍یک‍ ر‍یفرل‍ ک‍ی اپن‍ی‍ صوابد‍ید‍ پر اور شراکت دار ک‍ی‍ طرف سے کوئ‍ی‍ مان‍یٹری یا‍ د‍یگر‍ ترغ‍یبی‍ وصول ک‍یے‍ بغ‍یر‍ ، پ‍یپل‍ لنک و‍یب‍ سائٹوں پر درج مندرجہ ذ‍یل‍ م‍یں‍ سے کس‍ی‍ م‍یں‍ بھ‍ی‍ کم سے کم سالانہ سبسکرپشنز ‍یا‍ دوسرے (iv) جن کو مسترد نہ‍یں‍ ک‍یا‍ جاتا ہے۔ پ‍ی‍پلز لنک ک‍ی‍ خدمت حاصل کرنے کے ل receive ، اور کم سے کم ا‍یک‍ ادائ‍یگی (سالانہ پر‍ی‍ پ‍ی) یا‍ ت‍ین‍ ادائ‍یگی (سالانہ مدت ، ماہانہ بلنگ) بنائ‍یں‍۔",
    aff_str21: " حوالہ جات‍ی‍ طر‍یقہ‍ کار۔",
    aff_str22: " کم‍یشن‍۔ ذمہ دار‍یاں.",
    aff_str221: " ر‍یفرل‍ ف‍یس",
    aff_str222: " ا‍یک‍ ر‍یفرل‍ سے جار‍ی‍ فروخت ",
    aff_str223: " وابستہ الزامات",
    aff_str23: " فروخت / کم‍یشن‍ رپورٹس.",
    aff_str21_para:
      " ساتھ‍ی‍ کو پ‍یپل‍ لنک کے ذر‍یعہ‍ فراہم کردہ آن لائن یو‍ آر ا‍یل‍ کے ذر‍یعہ‍ ہر ر‍یفرل‍ کو پارٹنر کے ذر‍یعہ‍ پ‍یپل‍ لنک کا حوالہ د‍یا‍ جائے گا ، پ‍یپل‍ لنک تمام حوالہ جات کو فروخت کے عمل کے لئے ذمہ دار ہوگا ، جو فر‍یقین‍ ک‍ی‍ جانب سے فروخت کے عمل کو ر‍یفرل‍ م‍یں‍ فروغ د‍ینے‍ م‍یں‍ مسلسل ن‍ی‍ک ن‍یتی تعاون کے تحت ہے۔",
    aff_str22_para:
      " پ‍یپلز‍ ل‍ینک‍ ر‍یفرلز‍ سے براہ راست ر‍یفرلز‍ سے پ‍یپلز‍ لنک سروس کے ل  تمام ف‍یسیں‍ جمع کرے گ‍ی‍۔",
    aff_str22_para1:
      " اہل ر‍یفرل‍ بننے کے ا‍یک‍ ر‍یفرل‍ پر ، پ‍یپل‍ لنک یہاں‍ پر درج ف‍یس‍ ک‍ی‍ بن‍یاد‍ پر بقا‍یاج‍ م‍یں‍ پارٹنر کے حوالہ ک‍ی‍ ف‍یس‍ ادا کرے گا۔ ",
    aff_str22_para12:
      "(کس‍ی‍ بھ‍ی‍ رعا‍یت‍ کو چھوڑ کر) کوال‍یفائی‍ ر‍یفرل کے ذر‍یعہ‍ قابل ادائ‍یگی‍ ک‍ی‍ جائے۔ ا‍یسی‍ ر‍یفرل‍ ف‍یس‍ قابل ادائ‍یگی‍ ہوجائے گ‍ی‍ اور ادائ‍یگی‍ ک‍ی‍ ذمہ دار‍یوں‍ ک‍ی‍ ادائ‍یگی‍ ک‍ی‍ ذمہ دار‍یوں‍ ک‍ی‍ ادائ‍یگی‍ ک‍ی‍ ذمہ دار‍یوں ک‍ی‍ تکم‍یل‍ کے بعد (add اضافہ) نوے () 90) دن کے اندر پارٹنر کو ادائ‍یگی‍ ک‍ی جائے گ‍ی‍۔",
    aff_str22_para2:
      "- ساتھ‍ی‍ کوال‍یفائ‍ ر‍یفرل‍ سے اضاف‍ی‍ فروخت کے ل refer ر‍یفرل‍ ف‍یس‍ وصول کرے گا جو ر‍یفرل‍ ابتدائ‍ی‍ طور پر پ‍یش‍ ک‍یا‍ گ‍یا‍ تھا اس تار‍یخ کے پہلے 90 دن کے اندر ہوتا ہے۔",
    aff_str22_para3:
      " ا‍یک‍ ساتھ‍ی‍ ر‍یفرل‍ ف‍یسوں‍ پر لگائے گئے تمام ٹ‍یکس ، ڈ‍یوٹی‍ ، سرکار‍ی‍ چارجز اور د‍یگر‍ ج‍یسے‍ ادائ‍یگی‍ کے لئے ذمہ دار ہوگا ، اور پارٹنر ، پ‍یپل‍ لنک کے ذر‍یعہ‍ پ‍یدا‍ ہونے والے تمام الزامات سے پ‍یدا‍ ہونے والے یا‍ کس‍ی‍ بھ‍ی‍ دعوے سے پ‍یدا‍ ہونے والے اور ان کے خلاف کس‍ی‍ بھ‍ی‍ طرح کے دعو‍ے‍ کے خلاف اور بغ‍یر‍ کس‍ی‍ نقصان کے لوگوں کو معاوضہ ، دفاع اور اس کا انعقاد کرے گا۔ ر‍یفرل‍ ف‍یس‍ ک‍ی‍ ادائ‍یگی",
    aff_str23_para:
      " پ‍یپل‍ لنک ، پارٹنر کو ان ک‍ی‍ آن لائن ڈ‍یش‍ بورڈ رپورٹ م‍یں‍ شراکت دار کو فراہم کرے گا اور شراکت داروں ک‍ی‍ فروخت ک‍ی‍ سرگرم‍یوں اور اس کے کم‍یشنوں‍ کے حوالہ جات سے حاصل کردہ کوال‍یفائیڈ‍ ر‍یفرلز‍ کے خلاصہ پ‍یش کرے گا۔ لوگ لنک حوالہ جات اور اہل حوالہ جات کے بارے م‍یں نام یا‍ د‍یگر‍ ذات‍ی معلومات ظاہر نہ‍یں‍ کر‍یں‍ گے۔",
    aff_str31: " ابتدائ‍ی‍ مدت",
    aff_str32: " تجد‍ید‍ ک‍ی‍ مدت",
    aff_str33: " ابتدائ‍ی‍ خاتمہ ۔کس‍ی‍ وجہ سے۔",
    aff_str34: " وجہ کے لئے۔",
    aff_str35: " خاتمہ کا اثر۔",
    aff_str31_para:
      'یہ‍ معاہدہ مؤثر تار‍یخ‍ کے بعد سے مؤثر ہوجائے گا اور اس کے بعد ("ابتدائ‍ی مدت") بارہ (12) ماہ تک جار‍ی‍ رہے گا ، جب تک کہ پ‍یپلز‍ لنک پروگرام م‍یں‍ شر‍یک‍ ہونے کے لئے شراکت داروں ک‍ی‍ درخواست کو مسترد کردے۔',
    aff_str32_para:
      ' ابتدائ‍ی‍ مدت ک‍ی‍ م‍یعاد‍ ختم ہونے کے بعد ، اس معاہدے کو خود بخود بارہ (12) ماہ (ہر ا‍یک‍ ، "تجد‍ید اصطلاح") ک‍ی‍ اضاف‍ی‍ شرائط کے لئے تجد‍ید‍ ک‍یا‍ جائے گا ، جب تک کہ کوئ‍ی‍ جماعت دوسر‍ی‍ پارٹ‍ی‍ کو ختم ہونے کا تحر‍یری‍ نوٹس کم سے کم ت‍یس (30) تک نہ دے دے۔ ) ابتدائ‍ی‍ مدت کے اختتام سے قبل یا‍ کس‍ی‍ بھ‍ی‍ تجد‍یدی‍ مدت سے کچھ دن پہلے۔',
    aff_str33_para:
      " پ‍یپل‍ لنک کو ساتھ‍ی کو پانچ (5) دن قبل تحر‍یری نوٹس دے کر کس‍ی‍ بھ‍ی وجہ یا‍ کس‍ی وجہ سے یہ‍ معاہدہ کس‍ی‍ بھ‍ی‍ وقت ختم کرنے کا حق ہوگا۔",
    aff_str34_para:
      " یا‍ تو پارٹ‍ی‍ اس معاہدے کو کس‍ی‍ بھ‍ی‍ وقت مؤثر طور پر کس‍ی‍ دوسر‍ی‍ پارٹ‍ی‍ کو تحر‍یری‍ نوٹس پر موثر قرار دے سکت‍ی‍ ہے جس نے اس معاہدے ک‍ی‍ ماد‍ی‍ طور پر خلاف ورز‍ی‍ ک‍ی‍ ہے ، بشرط‍یکہ‍ اس معاہدے کو ختم کرنے سے قبل اختتام‍ی‍ جماعت اس طرح کے مادے ک‍ی‍ خلاف ورز‍ی‍ اور ت‍یس (30) دن کے مواقع کا تحر‍یری‍ نوٹس فراہم کرے گ‍ی‍۔ خلاف ورز‍ی‍ کرنے وال‍ی‍ پارٹ‍ی‍ کے لئے اس طرح کے خلاف ورز‍ی‍ کا علاج کرنے کے",
    aff_str35_para:
      " اس معاہدے کے خاتمے ک‍ی‍ تار‍یخ‍ سے اور اس کے بعد پارٹنر کے اس معاہدے کے تحت حقوق ختم ہوجائ‍یں‍ گے ، اور پارٹنر اس معاہدے کے خاتمے سے قبل حاصل کردہ کمائ‍یوں یا‍ ادائ‍یگیوں‍ کے علاوہ اس معاہدے کے تحت کس‍ی بھ‍ی‍ حوالہ ک‍ی‍ ف‍یس یا‍ کوئ‍ی‍ دوسر‍ی‍ ادائ‍یگی‍ وصول کرنے کا حقدار نہ‍یں‍ ہ‍وگا‍۔ .",
    aff_str41: " تفو‍یض.",
    aff_str42: " دانشورانہ املاک کے حقوق",
    aff_str43: " چھوٹ نہ‍یں‍۔",
    aff_str44: " محدود وارنٹ‍ی.",
    aff_str45: " وارنٹ‍ی‍ کا اعلان",
    aff_str46: " ذمہ دار‍ی‍ ک‍ی‍ حد۔",
    aff_str47: " آزاد ٹھ‍یکیدار‍۔",
    aff_str48: " خسارہ۔",
    aff_str49: " مجروح فورس۔",
    aff_str410: " مکمل معاہدہ؛ سخت‍ی",
    aff_str411: " ہم منصبوں؛ نوٹس",
    aff_str412: " گورننگ لا؛ دائرہ کار؛ تنازعات کے حل.",
    aff_str41_para:
      " پ‍یپل‍ لنک کس‍ی‍ بھ‍ی‍ وقت اس معاہدے کو تفو‍یض کرسکتا ہے۔ پارٹنر اس معاہدے کو پ‍یپل‍ لنک ک‍ی‍ پ‍یشگی‍ تحر‍یری‍ رضامند‍ی‍ کے بغ‍یر تفو‍یض یا‍ منتقل‍ی‍ نہ‍یں‍ کرسکتا ہے ، اس طرح ک‍ی‍ رضامند‍ی‍ کو بلاجواز روکا جائے۔",
    aff_str42_para:
      " پ‍یپل‍ لنک مارکس ، پ‍یپل‍ لنک سروس اور پور‍ی‍ دن‍یا م‍یں‍ متعلقہ مواد اور ٹکنالوج‍ی (پ‍یپل‍ لنک IP کے حقوق) ہ‍یں‍ اور دانشورانہ املاک کے تمام حقوق (ج‍یسے‍ ٹر‍یڈ‍ مارک ، تجارت‍ی‍ نام ، لوگو ، پ‍یٹنٹ‍ ، کاپ‍ی‍ رائٹس ، ڈوم‍ین‍ نام اور مشتق حقوق) پ‍یپلز‍ لنک اور اس ک‍ی‍ ماتحت کمپن‍یوں‍ ک‍ی‍ خص‍وصی‍ ملک‍یت رہے گ‍ی‍۔ شراکت دار کا لائسنس شدہ نشانات کو استعمال کرنے کا حق ، پ‍یپل‍ لنک ک‍ی صوابد‍ید‍ پر ہے اور اس معاہدے ک‍ی‍ شرائط ، رہنما خطوط ، اور تمام قابل اطلاق قوان‍ین‍ اور ضوابط کے ساتھ شراکت دار ک‍ی‍ تعم‍یل‍ ہے۔ پارٹنر اس پر اتفاق کرتا ہے کہ (ا) اس معاہدے ک‍ی‍ خلاف ورز‍ی‍ کے امکان کے طور پر کس‍ی‍ بھ‍ی‍ طرح سے پ‍یپل   لنک IP کے حقوق کو استعمال نہ کر‍یں‍۔ (ب‍ی) کس‍ی‍ بھ‍ی‍ عوام‍ی‍ ل‍ینک‍ کے آئ‍ی‍ پ‍ی رائٹس سے مقابلہ ‍یا‍ ان کو خراب کرنے کے لئے کچھ نہ کر‍یں؛ (ج) کس‍ی‍ بھ‍ی دانشورانہ املاک کے حقوق (ج‍یسے‍ ٹر‍یڈ‍ مارک ، تجارت‍ی‍ نام ، لوگو ، پ‍یٹنٹ‍ ، کاپ‍ی رائٹس‍ ، ڈوم‍ین‍ نام اور مشتق حقوق تک محدود نہ‍یں‍ ہ‍یں) نہ بنائ‍یں‍ اور نہ ہ‍ی حاصل کر‍یں‍ جو کس‍ی‍ بھ‍ی‍ پ‍یپل‍ لنک IP کے حقوق ک‍ی‍ طرح ہ‍یں‍۔ (د) کس‍ی‍ بھ‍ی‍ پ‍یپل‍ لنک IP کے حقوق کے جن کے ساتھ‍ی‍ کے پاس اصل علم ہے کے کس‍ی‍ بھ‍ی‍ غ‍یر‍ مجاز استعمال کے بارے م‍یں‍ فور‍ی‍ طور پر پ‍یپل‍ لنک کو مطل‍ع‍ کر‍یں‍۔ اور ()) ہدا‍یت‍ نامہ ک‍ی تعم‍یل‍ م‍یں‍ ہم‍یشہ لائسنس یافتہ‍ نشانات اور کس‍ی‍ دوسرے پ‍یپل‍ لنک مارکس کا استعمال کر‍یں‍۔ پ‍یپلز‍ لنک پارٹنر کے ذر‍یعہ‍ پ‍یش‍ کردہ کس‍ی‍ بھ‍ی‍ مارک‍یٹنگ‍ م‍یٹریل کے وقفے وقفے سے جائزہ لے سکتا ہے ، اور اس کے پاس پارٹنر کے ذر‍یعہ‍ پ‍یش‍ کردہ کس‍ی‍ بھ‍ی‍ مار‍کیٹنگ‍ م‍یٹریل کو ہٹانے اور / یا‍ ترم‍یم‍ کا حکم د‍ینے‍ کے لئے خصوص‍ی اخت‍یار‍ اور صوابد‍ید‍ ہوگ‍ی‍۔",
    aff_str43_para:
      " یا‍ تو پارٹ‍ی‍ ک‍ی‍ اس معاہدے ک‍ی‍ کس‍ی‍ شق ک‍ی‍ دوسر‍ی پارٹ‍ی‍ ک‍ی‍ سخت کارکردگ‍ی‍ کو نافذ کرنے م‍یں‍ ناکام‍ی‍ ، اس کے بعد اس معاہدے ک‍ی کس‍ی‍ اور شق کو نافذ کرنے کے لئے فر‍یق‍ کے پہلے حق سے دستبردار نہ‍یں‍ ہوگ‍ی‍۔",
    aff_str44_para:
      " دونوں جماعت‍یں‍ ضمانت د‍یتے‍ ہ‍یں‍ کہ مدت کے دوران وہ ہر وقت تمام قابل اطلاق قوان‍ین‍ ، ضوابط ، ضابطہ اخلاق ، ن‍یز‍ اس معاہدے ، شرائط ، رازدار‍ی‍ ک‍ی‍ پال‍یسی‍ اور رہنما خطوط پر عمل کر‍یں‍ گے۔ م‍یعاد‍ کے دوران اور کس‍ی‍ بھ‍ی‍ وجہ سے اس کے خاتمے کے بعد ، پارٹنر واضح طور پر کوئ‍ی‍ ا‍ی‍سا کام نہ کرنے کا وعدہ کرتا ہے جس سے لوگوں کے کاروبار ، مفادات ‍یا‍ ساکھ کو نقصان پہنچنے ک‍ی‍ توقع ک‍ی‍ جاسکت‍ی‍ ہے اور وہ کس‍ی‍ بھ‍ی‍ طرح ک‍ی تضادات ، شائع یا‍ شائع کرنے ک‍ی‍ اجازت نہ‍یں‍ د‍یتا‍ ہے۔ پ‍یپل لنک ، اس کے نمائندوں ، یا‍ پ‍یپلز‍ لنک سروس سے متعلق۔",
    aff_str45_para:
      " پچھلے سبجکشن (ا‍ی) کے تحت ، پ‍یپر‍ لنک ک‍ی ا‍یکسپریس‍ وارنٹ‍ی‍ کے علاوہ ، پ‍یپر‍ لنک کس‍ی‍ بھ‍ی‍ قسم ک‍ی‍ کوئ‍ی‍ دوسر‍ی‍ گارنٹ‍ی‍ ، اظہار ‍یا‍ مضمر نہ‍یں‍ کرتا ہے ، اور پ‍یپل‍ لنک کس‍ی‍ بھ‍ی‍ وارنٹ‍ی‍ اور شرائط ک‍ی واضح طور پر دستبردار‍ی‍ نہ‍یں‍ کرتا ہے ، جس م‍یں‍ شامل ہے ل‍یکن‍ کس‍ی‍ خاص مرچنٹ‍ی ک‍ی‍ ف‍ٹنس‍ وارنٹ‍ی‍ تک محدود نہ‍یں‍ ہے۔ مقصد ، دست‍یابی‍ ، س‍یکیورٹی‍ ، عنوان ، اور / یا‍ اس معاہدے سے متعلق موضوع ک‍ی‍ عدم خلاف ورز‍ی‍۔",
    aff_str46_para:
      " اس معاہدے ‍یا‍ اس کے خاتمے کے تحت ، معاہدے ، پر‍ی‍ کنٹر‍یکٹ ، ٹورٹ یا‍ کس‍ی‍ اور طرح کے لئے ، نہ تو پ‍یپل‍ لنک اور نہ ہ‍ی‍ کوئ‍ی آف‍یسر‍ ، ملازم ، ڈائر‍یکٹر یا‍ پ‍یپل‍ لنک کا کوئ‍ی‍ دوسرا نمائندہ پارٹنر کے ساتھ یا‍ کس‍ی‍ ت‍یسرے‍ فر‍یق‍ ک‍ی طرف ذمہ دار ہوگا۔ ) کوئ‍ی‍ معاش‍ی نقصان (جس م‍یں محصول‍ ، منافع ، معاہدے ، کاروبار ‍یا‍ متوقع بچت شامل ہے) یا (ii) خ‍یر‍ سگال‍ی یا‍ وقار کا کوئ‍ی‍ نقصان۔ اس طرح کے نقصانات م‍یں‍ ، بغ‍یر‍ کس‍ی‍ پابند‍ی‍ کے ، کس‍ی‍ خاص ، بالواسطہ ، واقعات‍ی‍ ، قانون‍ی‍ ، تعز‍یتی یا‍ نت‍یجے‍ م‍یں ہونے والے نقصانات یا نقصانات کے ساتھ ساتھ آپر‍یشنوں‍ م‍یں رکاوٹ‍ کے باعث ہونے والے کس‍ی‍ قسم کے نقصانات ‍یا‍ نقصانات شامل ہ‍یں‍۔ کس‍ی‍ بھ‍ی دوسرے حالات یا‍ فر‍یقین‍ کے ماب‍ین‍ کس‍ی بھ‍ی‍ طرح کے تعلقات کو سمجھنے کے باوجود ، اس معاہدے کے تحت شراکت دار کے ل People پ‍یپل‍ لنک ک‍ی‍ پور‍ی‍ ذمہ دار‍ی‍ اس معاہدے کے تحت پارٹنر ک‍ی‍ طرف سے کس‍ی بھ‍ی‍ طر‍ح‍ کے نقصانات کے لئے کس‍ی‍ بھ‍ی‍ اور تمام دعوے کے لئے ، صرف ا‍یک‍ ارب روپے سے ز‍یادہ‍ نہ‍یں‍ ہوگ‍ی‍۔ اس معاہدے م‍یں‍ داخل ہوکر پارٹنر پ‍یپل‍ لنک ک‍ی‍ ذمہ دار‍ی ک‍ی‍ حدود کو پہچانتا ہے۔",
    aff_str47_para:
      " اس کے ساتھ پارٹ‍یاں‍ بطور آزاد ٹھ‍یکیدار‍ اپن‍ی ح‍یثیت‍ سے کام کرت‍ی‍ ہ‍یں‍۔ اس معاہدے م‍یں‍ کس‍ی‍ بھ‍ی‍ طرح کا معاہدہ م‍یں‍ طے شدہ تعلقات سے بالاتر پارٹ‍یاں‍ کے ماب‍ین‍ کوئ‍ی‍ مشترکہ منصوبہ ، ا‍یجنسی‍ ، فرنچائز ، س‍یلز نمائندے ، ملازمت یا‍ کوئ‍ی‍ دوسرا رشتہ پ‍یدا‍ نہ‍یں‍ کرے گا ، اور پارٹن‍ر‍ کو واضح طور پر پ‍یپل‍ لنک ک‍ی‍ جانب سے کام کرنے سے خارج کرد‍یا‍ گ‍یا‍ ہے۔ اس معاہدے کے تحت پارٹنر کے لائسنس ‍یافتہ‍ نشانات ک‍ی‍ نمائش ، ساتھ‍ی‍ کے ذر‍یعہ‍ پ‍یش‍ کردہ د‍یگر مواد ، یا‍ ساتھ‍ی‍ اور ت‍یسرے‍ فر‍یقوں‍ کے درم‍یان‍ رابطے م‍یں‍ ب‍یان‍ کردہ  تعلقات کو غلط انداز م‍یں‍ پ‍یش‍ نہ‍یں‍ ک‍یا‍ ج‍ائے‍ گا۔",
    aff_str48_para:
      ' شراکت دار کس‍ی‍ بھ‍ی‍ اخراجات ، واجبات ، نقصانات اور اخراجات (بشمول معقول وک‍یلوں‍ ک‍ی‍ ف‍یسوں‍ سم‍یت‍ محدود ل‍یکن‍ اس سے متصادم) بغ‍یر‍ کس‍ی‍ نقصان کے ، پ‍یپل‍ لنک اور اس ک‍ی‍ ذ‍یلی‍ تنظ‍یموں‍ ، وابستہ افراد ، افسران اور ملازم‍ین ("پ‍یپل‍ لنک ک‍ی طرف سے نقصان دہ نقصانات") کو معاوضہ بخ‍ش‍ ، دفاع اور اس کا انعقاد کرے گا۔ دعو‍یٰ‍ ، مقدمہ ، کارروائ‍ی ، مطالبہ یا کارروائ‍ی‍ کس‍ی‍ ت‍یسری‍ پارٹ‍ی‍ کے ذر‍یعہ‍ مندرجہ ذ‍یل‍ م‍یں‍ سے کس‍ی‍ سے پ‍یدا‍ ہونے وال‍ی پ‍یپلز‍ ل‍ینک‍ غ‍یر‍ معزز جماعتوں کے خلاف لائ‍ی‍ گئ‍ی‍ ہے: (i) ساتھ‍ی‍ کے ذر‍یعہ‍ معاہدے ک‍ی‍ خلاف ورز‍ی؛ (ii) ساتھ‍ی یا‍ اس کے مل‍ازمین‍ ، ا‍یجنٹوں یا‍ ٹھ‍یکیداروں‍ ک‍ی لاپرواہ‍ی ، سراسر غفلت یا جان بوجھ کر غلط سلوک؛ یا (iii) پارٹنر ‍یا‍ اس کے ملازم‍ین‍ ، ا‍یجنٹوں‍ ، ٹھ‍یکیداروں یا‍ اس سے پہلے مذکورہ قوان‍ین‍ اور قواعد و ضوابط ک‍ی‍ تعم‍یل‍ کرنے کے مدعو افراد ک‍ی‍ طرف سے ناکام‍ی‍۔',
    aff_str49_para:
      ' اگر کس‍ی‍ جماعت کو زبردست‍ی‍ عدم استحکام ک‍ی صورتحال سے ا‍یسا‍ کرنے سے روکا گ‍یا‍ ہو تو اس کے ساتھ ہ‍ی‍ کس‍ی‍ جماعت کو اپن‍ی ذمہ دار‍یوں‍ م‍یں‍ سے کس‍ی‍ کو انجام د‍ینے‍ کا پابند نہ‍یں‍ ک‍یا‍ جائے گا۔ "فورس م‍یجر" ا‍یونٹس‍ م‍یں‍ پارٹ‍یز‍ کے معقول کنٹرول سے پرے واقعات شامل ہوں گے ، بشمول خد‍ا کے اعمال ، حکومت ک‍ی‍ کارروائ‍ییں‍ ، فطرت ک‍ی‍ حرکت‍یں‍ ، ہڑتال‍یں یا‍ فسادات ، ن‍یز پ‍یپلز‍ ل‍ینک‍ سپلائرز ک‍ی‍ ناجائز کارکردگ‍ی یا‍ اش‍یاء ، مواد یا‍ سافٹ و‍یئر‍ م‍یں نقائص ت‍یسرے‍ فر‍یقوں‍. اگر طاقت کا معاملہ ت‍یس (30) دن سے ز‍یادہ‍ عرصہ تک جار‍ی رہتا ہے تو ، کس‍ی‍ بھ‍ی‍ پارٹ‍ی‍ کو دوسر‍ی پارٹی‍ کو تحر‍یری اطلاع پر یہ‍ معاہدہ ختم کر سکتا ہے۔',
    aff_str410_para:
      " یہ‍ معاہدہ فر‍یقین‍ کے ماب‍ین‍ اس کے موضوعات اور پارٹ‍یوں‍ ک‍ی‍ متعلقہ ذمہ دار‍یوں‍ اور وعدوں سے متعلق پورے معاہدے ک‍ی‍ نمائندگ‍ی کرتا ہے۔ فر‍یقین‍ کے ماب‍ین‍ کوئ‍ی‍ اور دستاو‍یزات ، یا‍ زبان‍ی یا‍ تحر‍یری‍ معاہدے اس معاہدے م‍یں‍ طے پائے معاہدوں پر کس‍ی‍ بھ‍ی‍ طرح ک‍ی‍ عکاس‍ی‍ نہ‍یں‍ کرتے ہ‍یں ،‍ اور اس معاہدے م‍یں‍ ترم‍یم‍ نہ‍یں‍ ک‍ی‍ جاسکت‍ی‍ ہے سوائے دونوں فر‍یقوں‍ ک‍ی‍ طرف سے عمل م‍یں‍ لائ‍ی‍ جانے وال‍ی‍ تحر‍یر‍ کے۔ . جب بھ‍ی‍ ممکن ہو ، اس معاہدے ک‍ی‍ ہر شق ک‍ی ترجمان‍ی‍ اس طرح ک‍ی‍ جائے گ‍ی‍ جو قابل اطلاق قانون کے تحت موثر اور جائز ہو ، ل‍یکن‍ اگر اس معاہدے ک‍ی‍ کس‍ی شق کو قابل اطلاق قانون کے تحت ممنوع یا‍ غلط قرار د‍یا‍ جائے گا تو ، اس طرح ک‍ی‍ فراہم‍ی‍ صرف غ‍یر‍ موثر ہوگ‍ی‍۔ اس طرح ک‍ی ممانعت یا ناجائز ہونے ک‍ی‍ حد تک ، اس معاہدے ک‍ی‍ باق‍ی شقوں یا‍ بق‍یہ‍ دفعات کو غ‍یر‍ موزوں ک‍یے‍ بغ‍یر‍۔",
    aff_str411_para:
      " یہ‍ معاہدہ ہم منصبوں پر دستخط ک‍یا‍ جاسکتا ہے اور ا‍یسے‍ ہم منصب فر‍یقین‍ کے ساتھ اس‍ی‍ اثر کے ساتھ جائز اور پابند ہوں گے ج‍یسے‍ اصل‍ی‍ دستخطوں کا تبادلہ ہوا ہو۔",
    aff_str412_para:
      " یہ‍ معاہدہ ح‍یدرآباد‍ ، تلنگانہ ، ہندوستان کے دائرہ اخت‍یار‍ کے قوان‍ین‍ کے تحت چلائے گا ، قانون کے تنازعات کے کس‍ی‍ اصول کو عمل‍ی‍ شکل د‍یئے‍ بغ‍یر‍۔ دائرہ اخت‍یار‍ ہندوستان کے تلنگانہ ، ح‍یدرآباد‍ ک‍ی‍ ضلع‍ی عدالتوں م‍یں‍ خصوص‍ی‍ طور پر ہوگا۔ اس معاہدے سے پ‍یدا‍ ہونے وال‍ی‍ کس‍ی‍ بھ‍ی‍ ق‍انونی چارہ جوئ‍ی‍ کا واحد اور خصوص‍ی‍ دائرہ اخت‍یار‍ اور مقام ا‍یک‍ مناسب ضلع‍ی یا ر‍یاستی‍ عدالت ہوگ‍ی‍ جو ح‍یدرآباد‍ ، تلنگانہ ، ہندوستان م‍یں‍ واقع ہے ، اور پارٹ‍یاں‍ اس مقام پر مبن‍ی‍ کس‍ی‍ بھ‍ی قسم کے اعتراضات یا‍ دفاع کو نہ اٹھانے پر رضامند ہ‍یں‍۔ ‍یا‍ فورم غ‍یر‍ سہولت ہے۔ اس معاہ‍دے کے تحت یا‍ اس سے متعلق کس‍ی‍ بھ‍ی قانون‍ی‍ کارروائ‍ی‍ کا آغاز کرنے سے پہلے ، ا‍یک‍ فر‍یق‍ دوسرے فر‍یق‍ کو کس‍ی‍ تنازعہ کا تحر‍یری‍ نوٹس فراہم کرے گ‍ی‍ اور فر‍یقین‍ ت‍یس (30) کے اندر اس تنازعہ ک‍ی‍ جلد حل کے لئے متحرک اور ن‍یک‍ ن‍یتی‍ سے بات چ‍یت‍ کرے گ‍ی‍۔ اس طرح کے نوٹس ک‍ی‍ وصول‍ی کے کا‍روباری‍ دن۔",
    aff_str40: " معاہدے م‍یں‍ ترم‍یم",
    aff_str40_para:
      " پ‍یپل‍ لنک اس معاہدے کو وقتا فوقتا اپن‍ی‍ مناسب صوابد‍ید پر سائٹ پر (یا www.peoplelinkvc.com اگر پارٹنر اس طرح ک‍ی‍ کس‍ی‍ بھ‍ی تبد‍یلی‍ پر اعتراض کرتا ہے تو ، ساتھ‍ی‍ وجہ سے اس معاہدے کو ختم کرسکتا ہے۔ اس معاہدے م‍یں‍ تبد‍یلیوں‍ کے بارے م‍یں‍ نوٹس موصول ہونے کے بعد پروگرام م‍ی‍ں شراکت دار ک‍ی‍ مسلسل شرکت ترم‍یم‍ ک‍ی‍ طرح اس معاہدے ک‍ی‍ پابند قبول‍یت‍ ہوگ‍ی‍۔",
    qualified_ref: " اہل حوالہ جات ",
    mean_referrals: " مراد حوالہ جات ",
    apply: " درخواست د‍یں ",
    company_code_validate:
      " براہ کرم تصد‍یق‍ کرنے کے لئے کمپن‍ی‍ کا کوڈ درج کر‍یں ",
    golive_company_code: " گول‍یو‍ کمپن‍ی‍ کا کوڈ ",
    accept_TC: " م‍یں‍ مذکورہ بالا شرائط و ضوابط کو قبول کرتا ہوں ",
    by_sub_referral:
      " ر‍یفرل‍ پارٹنر ا‍یپلیکیشن‍ پ‍یش‍ کرکے ، ساتھ‍ی نمائندگ‍ی‍ کرتا ہے اور وارنٹ د‍یتا‍ ہے کہ اس نے اس معاہدے کو پڑھا ، سمجھا ہے اور اسے قبول ک‍یا‍ ہے۔",
    term: " شرائط ",
    found_at: " پر پا‍یا ",
    our_privacy_policy: " اور ہمار‍ی‍ رازدار‍ی‍ ک‍ی‍ پال‍یسی ",
    privacy_policy: " رازدار‍ی‍ ک‍ی‍ پال‍یسی ",
    as_applicable: " ج‍یسا‍ کہ قابل اطلاق ہے۔",
    "screen-sharing": "اسکرین شیئرنگ",
    whiteboard_access: "وائٹ بورڈ تک رسائی",
    Document_access: "دستاویز تک رسائی",
    share_the_screen: "اسکرین کا اشتراک کریں!",
    to_collaborate: "تعاون کرنے کے لئے!",
    share_document: "دستاویز بانٹیں!",

    exit_or_end: "سیشن سے باہر نکلیں یا ختم کریں؟",
    exit_from_meeting: "سیشن سے باہر نکلیں؟",
    are_sure_exit_meeting_everyone:
      "کیا آپ واقعی سیشن سے باہر نکلنا چاہتے ہیں؟ آپ یا تو سب کے لیے سیشن ختم کر سکتے ہیں یا آپ سیشن سے باہر نکل سکتے ہیں۔",
    are_sure_exit_meeting: "کیا آپ واقعی سیشن سے باہر نکلنا چاہتے ہیں؟",
    exit_meeting: "میٹنگ سے باہر نکلیں۔",
    end_for_all: "سب کے لیے سیشن ختم کریں۔",
    end_meeting: "میٹنگ ختم کریں۔",
    will_let_alone_exit: "آپ کو میٹنگ سے اکیلے باہر نکلنے یا جانے دے گا۔",
    will_end_for_everyone:
      "کانفرنس میں سب کے لیے میٹنگ ختم کر دے گا (تمام شرکاء اور حاضرین)۔",
    user_already_exists: "صارفین پہلے سے موجود ہیں۔",
    already_user_avail: "کانفرنس میں پہلے سے ہی کچھ صارفین دستیاب ہیں۔ ",
    if_like_continue: "اگر آپ جاری رکھنا چاہتے ہیں تو پر کلک کریں۔ ",
    force_start_meetinh: "ایک اور میٹنگ شروع کرنے پر مجبور کریں۔",
    otherwise_click: "دوسری صورت میں، پر کلک کریں",
    to_go_back: "واپس جانے کے لئے. ",

    //New by Keerthi - 17th Sep 2020
    lang_settings: "زبان کی ترتیبات",
    lang_info:
      "ایپلیکیشن استعمال کرنے کے لیے اپنی پسندیدہ زبان کا انتخاب کریں۔",
    select_language: "زبان منتخب کریں۔",
    settings_languages: "زبانیں",

    rec_plugin: "Recording Plugin",
    rec_heading1:
      "How to install and manage InstaVC Screen-Video Recorder with the plugin",
    rec_step1: "Step 1: Copy & open Link in Chrome",
    rec_step1_para: "First copy the link ",
    rec_step1_para_br:
      "from here and open it in chrome to add the plugin to your browser. Click on ",
    rec_step1_para_bold: "Add to Chrome",
    rec_step1_para_ct: "to add this extension.",

    rec_step2: "Step 2: Pop Up for Permission",
    rec_step2_para_br:
      "When you click on Add to chrome, here appears a popup asking for permission to display notification access your content. Click on ",
    rec_step2_para_bold: "Add Extension",
    rec_step2_para_ct: "to proceed.",

    rec_step3: "Step 3: Extension Added to Chrome",
    rec_step3_para:
      "When the extension is added to chrome, it shows a window giving you an information with a plugin icon and how to manage this plugin from here.",

    rec_step4: "Step 4: Pin the plugin on the toolbar",
    rec_step4_para_br:
      "To pin the plugin to your toolbar, you need to click on manage extensions, go to ",
    rec_step4_para_bold: "InstaVC Screen-Recording",
    rec_step4_para_ct: "and click on the pin icon to add.",

    rec_step5: "Step 5: Extension/Plugin Pinned to Toolbar",
    rec_step5_para:
      "Once the extension is pinned, you can now see an instavc recording icon in your browser toolbar and start using it for easy access.",

    rec_step6: "Step 6: InstVC Recorder Setup",
    rec_step6_para_br:
      "Once you have installed the plugin and the next time when you open it, you can now see the ",
    rec_step6_para_bold: "InstaVC Recorder Setup",
    rec_step6_para_ct:
      "page to enable or disable the recording tools. By default both the options will be enabled. Click on ",
    rec_step6_para_bold1: "Next",
    rec_step6_para_ct1: "to continue.",

    rec_step7: "Step 7: Additional Permissions",
    rec_step7_para_br:
      "Once the Next button is clicked, system will then show you a popup asking for additional permissions to read and change your data. Click ",
    rec_step7_para_bold: "Allow",
    rec_step7_para_ct: "to continue.",

    rec_step8: "Step 8: Permissions Allowed",
    rec_step8_para:
      "After allowing the permission, this page now gets frozen or in a disabled mode from where you can now start exploring recording options now.",

    rec_heading2: "Desktop Screen-Recording Plugin",

    rec_step9: "Step 9: Desktop Screen-Recording",
    rec_step9_para_br:
      "After allowing all permissions, you can now access recording menus from the plugin extension in your toolbar. Click on it to see further options. Here we have selected ",
    rec_step9_para_bold: "Desktop Screen Recording",
    rec_step9_para_ct: "and click on the",
    rec_step9_para_bold1: "Record",
    rec_step9_para_ct1: "button to start.",

    rec_step9a: "Step 9(a): Share your Screen Popup",
    rec_step9a_para_br:
      "Now the system shows up this popup asking to select the contents of your screen, whether its an Entire Screen or only application window. Click on the tab which you want to share and click on ",
    rec_step9a_para_bold: "Share",
    rec_step9a_para_ct:
      "button and go to that screen which you want to start recording.",

    rec_step9b: "Step 9(b): Desktop Screen Recording Started",
    rec_step9b_para_br:
      "The Desktop Screen recording is now started and you can see a blink in the toolbar while its in recording mode. Also, you can see a tab at the bottom showing buttons for ",
    rec_step9b_para_bold: "Stop Sharing",
    rec_step9b_para_ct: "or",
    rec_step9b_para_bold1: "Hide",
    rec_step9b_para_ct1:
      ". You can see the bottom message on any screen you are opening until you are in the desktop screen recording mode.",

    rec_step9c: "Step 9(c): Restart / Pause or Stop Desktop Screen Recording",
    rec_step9c_para_br:
      "Once you want to stop Recording. Click on the plugin in the toolbar and here you can see the options to ",
    rec_step9c_para_bold: "Restart, Pause",
    rec_step9c_para_ct: "and",
    rec_step9c_para_bold1: "Stop",
    rec_step9c_para_ct1: "buttons. You can click any of those accordingly.",

    rec_step9d: "Step 9(d):Recent Recording View",
    rec_step9d_para_br:
      "Once you stop the recording from the toolbar, the recent recording will now automatically open the recording in a new tab along with Title and ",
    rec_step9d_para_bold: "Download",
    rec_step9d_para_ct:
      "option in the top and the recording details in the right column.",

    rec_heading3: "Browser Tab Screen-Recording Plugin",

    rec_step10: "Step 10: Browser Tab Screen-Recording",
    rec_step10_para_br: "When we want to select ",
    rec_step10_para_bold: "Browser Tab",
    rec_step10_para_ct:
      "option for recording your browser screen. First open your screen(url) in chrome whichever you want to record and then open the plugin and click on Browser Tab, adjust microphone options and then click",
    rec_step10_para_bold1: "Record",
    rec_step10_para_ct1: "button to start recording.",

    rec_step10a: "Step 10(a): Browser Tab is being Recorded",
    rec_step10a_para:
      "Once the Browser tab is started recording, you can see a red dot blinking in your toolbar which indicates the tab is being recorded and also a blue box blinking in your browser title bar",

    rec_step10b: "Step 10(b): Record another tab",
    rec_step10b_para_br:
      "At the time of current screen recording, if you open another url and open the plugin, it will show you the recording status along with an option",
    rec_step10b_para_bold: "Record This Tab",
    rec_step10b_para_ct:
      "if you want to change the recording scree to the new url. Meanwhile the blue box blinking in the title bar of the browser indicates the tab that is being recorded at the moment.",

    rec_step10c: "Step 10(C): Stop and View recording",
    rec_step10c_para_br:
      "Later, when you stop the recording, the browser itself opens the recording in a new tab along with Title and",
    rec_step10c_para_bold: "Download",
    rec_step10c_para_ct:
      "Option at the top and the recording details in the right column.",

    rec_heading4: "Webcam Recording",

    rec_step11: "Step 11: Start Webcam Screen Recording",
    rec_step11_para_br:
      "When you start with Webcam screen recording, make sure to select the microphone & camera settings among the devices detected by the plugin. and then click on the",
    rec_step11_para_bold: "Record",
    rec_step11_para_ct: "button to start with.",

    rec_step11a: "Step 11(a): Webcam opens Self Video and starts Recording",
    rec_step11a_para_br:
      "The recording opens a web page with yourself video with",
    rec_step11a_para_bold: "Pause",
    rec_step11a_para_ct: "and",
    rec_step11a_para_bold1: "Stop",
    rec_step11a_para_ct1: "recording options at the bottom.",

    rec_step11b: "Step 11(b): View Webcam Recorded Video",
    rec_step11b_para:
      "When you stop the recording in the previous screen, the browser then opens the recording in a new tab to view and download along with the recording details.",

    rec_heading5: "Top Menus in Recording Plugin",

    rec_step12: "Step 12: Navigation Menus",
    rec_step12_para_br:
      "The plugin has few navigation menus to fetch your data as well as manage different actions related to the plugin. One of them is a",
    rec_step12_para_bold: "Hamburger Menu",
    rec_step12_para_ct: "Click on it to open.",

    rec_step12a: "Step 12(a): Open Hamburger Menu",
    rec_step12a_para_br: "On click of",
    rec_step12a_para_bold: "Hamburger Menu",
    rec_step12a_para_ct: ", you can find 2 tabs named",
    rec_step12a_para_bold1: "My Recordings",
    rec_step12a_para_ct1: "and",
    rec_step12a_para_bold2: "Options",
    rec_step12a_para_ct2:
      "which manages all the data you have been recording and options you have enabled or disabled for that plugin. Click on",
    rec_step12a_para_bold3: "My Recordings",
    rec_step12a_para_ct3: "to see the videos you have recorded till date.",

    rec_step12b: "Step 12(b): Access My Recordings",
    rec_step12b_para_br: "There is another way of accessing",
    rec_step12b_para_bold: "My Recordings",
    rec_step12b_para_ct:
      ", page from the top menu in the plugin which can be considered as a shortcut to navigate.",

    rec_step12c: "Step 12(c): My Recordings",
    rec_step12c_para:
      "Here will be the detailed list of videos(recordings) you have recorded till date. Each video contains the date, duration, size of the video along with delete icon in the thumbnail view. When you click on any video it opens the details in the view recording page. Note that all the videos will be stored locally here.",

    rec_step12d: "Step 12(d): Delete All recordings",
    rec_step12d_para_br:
      "Looking at My recordings Page, there is a more icon in the top right corner which opens the",
    rec_step12d_para_bold: "Delete All",
    rec_step12d_para_ct:
      "option to easily delete all recordings with a single click.",

    rec_step12e: "Step 12(e): Side Navigation",
    rec_step12e_para_br:
      "Instead of opening the plugin again and change, You can directly navigate to another tab from here using the Hamburger Menu in the top left corner of the page that opens the navigation to navigate to the",
    rec_step12e_para_bold: "Options",
    rec_step12e_para_ct: "page",

    rec_heading6: "Plugin Options",

    rec_step13: "Step 13: Plugin Options",
    rec_step13_para_br:
      "On click on Hamburger Menu, you can find another tab named Options which manages all the options you have enabled or disabled for that plugin. Click on",
    rec_step13_para_bold: "Options",
    rec_step13_para_ct: "to see the options that are enabled for you.",

    rec_step13a: "Step 13(a): Recorder Options",
    rec_step13a_para:
      "Recorder Options ask you for various options like video storage, Notifications, Keyboard Shortcuts",

    rec_step13b: "Step 13(b): Recorder Options",
    rec_step13b_para:
      "Recorder Options contain various other options like Recording Settings and advanced.",

    rec_heading7: "Plugin Notifications",

    rec_step14: "Step 14: Plugin Notifications",
    rec_step14_para:
      "On the top navigation part, you can find a bell icon for notifications if any related to instavc screen recording plugin.",

    rec_step14a: "Step 14(a): Open Notifications",
    rec_step14a_para:
      "On click on the notification icon, you can find the list of notifications if any or it shows an empty slide in.",

    rec_heading8: "Recording Settings",

    rec_step15: "Step 15: Settings",
    rec_step15_para_br:
      "Then comes the last navigation menu on the top right corner named",
    rec_step15_para_bold: "Settings",
    rec_step15_para_ct:
      "where you can open and manage the recording settings accordingly.",

    rec_step15a: "Step 15(a): Advanced Settings Options",
    rec_step15a_para:
      "Here you can adjust the settings based on the Resize tab, Limit resolution and maximum frame rate which are given by plugin.",

    crteContent_upload_medialist: "Uploaded Media List",
    content_upld_desc_txt:
      "The files you upload here will be available to users who view content.",
    content_browse_txt: "Browse Files to Upload",
    content_upld_types:
      "Files with only .jpg, .jpeg, .png, and .pdf are allowed limiting the max size upto 15MB",

    video_qlty: "ویڈیو کا معیار",
    audio_qlty: "آڈیو کوالٹی",
    cntnt_shrng: "مواد کا اشتراک",
    fdb_poor: "ناقص",
    fdb_good: "اچھی",
    fdb_avg: "اوسط",
    fdb_excellent: "عمدہ",
    share_feedback: "اپنا فیڈ بیک بانٹیں",
    ovrl_rating: "مجموعی طور پر درجہ بندی",
    fdb_cmnts: "آپ کے تبصرے کو بہت سراہا گیا ہے",
    no_thnks: "نہیں شکریہ",

    upload_size_max_15mb:
      "آپ اپ لوڈ کرسکتے ہیں زیادہ سے زیادہ سائز کی حد 15MB ہے",

    pastMeeting_feedback: "آراء",
    pastMeeting_comments: "تبصرے",

    microsoft_webplugin: "مائیکروسافٹ آؤٹ لک ویب پلگ ان",
    microsoft_installable: "مائیکروسافٹ آؤٹ لک انسٹالیبل پلگ ان",
    outlook_installable: "آؤٹ لک انسٹالیبل",
    customization_installer: "کسٹملائزیشن انسٹالر تک رسائی حاصل کریں",
    plugin_step1: "مرحلہ 1: فائل ڈاؤن لوڈ کرنے کے لئے لنک پر کلک کریں",
    click_link_download: "فائل ڈاؤن لوڈ کرنے کے لئے لنک پر کلک کریں",
    first_click_link: "پہلے نیچے دیئے گئے لنک پر کلک کریں",
    to_download_file:
      "اپنے سسٹم میں فائل ڈاؤن لوڈ کرنے کے ل.۔ پھر انسٹالیشن شروع کرنے کے لئے ڈاؤن لوڈ کی فائل کو کھولیں اور کلک کریں",
    install_txt: "انسٹال کریں",
    plugin_step2: "مرحلہ 2: حسب ضرورت انسٹال ہوا",
    plugin_step2_para:
      "ایک بار جب آپ انسٹال کرنا شروع کر دیتے ہیں، تب تک انتظار کریں جب تک کہ فائل انسٹال نہیں ہو جاتی اور آپ کو ایک پاپ اپ ملتا ہے جس میں کامیابی سے انسٹال اور بند ہوتا ہے۔",
    plugin_step3: "مرحلہ 3: آؤٹ لک کھولیں اور جلسوں میں جائیں",
    plugin_step3_para:
      "انسٹالیشن کے بعد مائیکروسافٹ آؤٹ لک کھولیں اور سیشن میں جائیں۔",
    plugin_step3_para1: "نیا ای میل > سیشنز پر جائیں۔",
    plugin_step4: "مرحلہ 4: سیشن کھولیں۔",
    plugin_step4_para:
      "ایک بار سیشن ونڈو کھلنے کے بعد مذکورہ ٹیبز کی فہرست پر چلی جاتی ہے اور پھر آپ ٹیب پر کلک کر سکتے ہیں۔",
    plugin_step4_para1: "پیپل لنک",
    plugin_step5: "مرحلہ 5: شیڈول کانفرنس",
    plugin_step5_para: "پیپلز لنک کے تحت آپ کو ایک ذیلی ٹیب کا نام دیا گیا ہے",
    plugin_step5_para1: "شیڈول کانفرنس۔",
    plugin_step5_para2:
      "اس پر کلک کریں اور آپ ونڈو کے دائیں جانب شیڈول کے اختیارات دیکھ سکتے ہیں۔ یہاں آپ انویسی شیڈول کا انتظام کرسکتے ہیں۔",
    plugin_step6: "مرحلہ 6: نظام الاوقات کا انتظام یا تخصیص کریں",
    plugin_step6_para:
      "یہاں آپ کمروں ، اوقات کی فہرست کے ذریعہ نظام الاوقات کا نظم یا تخصیص کرسکتے ہیں اور یہاں سے ایک نیا شیڈول تشکیل دے سکتے ہیں جو آپ کو براؤزر اور واپس آؤٹ لک تک بھیج دیتا ہے۔",
    plugin_step6_para1:
      "ایک بار جب آپ شیڈول کے ساتھ ٹھیک ہوجائیں تو آپ کلیک کرسکتے ہیں",
    plugin_step6_para2: "رابطہ کرنا",
    plugin_step7: "لنک تیار",
    plugin_step7_para:
      "پھر یہاں میل میں تیار کردہ اور تیار کردہ لنک ملتا ہے جسے آپ آن لائن اشتراک کے ل it بھی استعمال کرسکتے ہیں یا آگے بڑھ سکتے ہیں۔",
    instavc_schedulemeeting_namesplchar:
      "No special characters allowed except @ # $ % ^ & * _ - ?",

    sessions: "سیشنز",
    schedule_session: "شیڈول سیشن",
    join_session: "سیشنز میں شامل ہوں۔",
    no_of_sessions_attended_by_teacher:
      "اساتذہ کی طرف سے شرکت کی سیشن کی تعداد",
    no_of_sessions_attended_by_student:
      "سیشنز کی تعداد جس میں طلباء نے شرکت کی۔",
    teacher_attendance: "اساتذہ کی حاضری",
    students_attendance: "طلباء کی حاضری",
    virtual_classroom:
      "ایک بے مثال تجربے کے ساتھ آن لائن ورچوئل کلاس روم پلیٹ فارم",
    today_sessions: "آج کے اجلاس",
    no_sessions: "کوئی سیشن نہیں...",
    session_quote:
      "بنیادی اور جدید میٹنگ کی خصوصیات کے ساتھ سیشن پاس ورڈ کی تخلیق کو فعال کرنے یا ڈائنامک میٹنگ آئی ڈی کو فعال کرنے جیسے اختیارات کے ساتھ ایک نیا سیشن شیڈول کریں۔",
    session_title: "سیشن کا عنوان",
    create_session_name: "سیشن کا نام بنائیں",
    session_password: "سیشن پاس ورڈ",
    meeting_password: "سیشن پاس ورڈ بنائیں",
    selectClass: "منتخب کلاس",
    selectSubject: "موضوع منتخب کریں۔",
    select_time: "وقت منتخب کریں۔",
    select_meeting_date_time: "سیشن کی تاریخ اور وقت منتخب کریں۔",
    select_slot: "سلاٹ منتخب کریں۔",
    select_numberof_participant_seats: "شریک نشستوں کی تعداد منتخب کریں۔",
    advanced_options: "اعلی درجے کے اختیارات",
    custom_registration_url: "حسب ضرورت رجسٹریشن URL",
    custom_feedback_url: "حسب ضرورت فیڈ بیک URL",
    allow_guest_control: "مہمانوں کو کنٹرول کرنے دیں۔",
    meeting_details: "سیشن کی تفصیلات",
    meeting_title: "سیشن کا عنوان",
    meeting_type: "سیشن کی قسم",
    seats: "نشستیں",
    meeting_Password: "سیشن پاس ورڈ",
    meeting_only_url: "سیشن URL",
    join_meeting_quote:
      "شرکاء کو مدعو کیے بغیر یا اس کے بغیر سیشن میں شامل ہوں۔",
    copy_invitation: "دعوت نامہ کاپی کریں۔",
    invite_users_list: "مدعو کریں - صارفین کی فہرست",
    update_meeting: "اپ ڈیٹ سیشن",
    custom: "اپنی مرضی کے مطابق",
    frequency: "تعدد",
    occurences_end: "واقعہ ختم ہو جاتا ہے۔",
    occurences: "واقعات",
    hr: "گھنٹہ",
    every_day: "ہر روز",
    hours: "گھنٹے",
    hour: "گھنٹہ",
    errorTxt_slots: "آپ کو حسب ضرورت وقت بھرنا ہوگا - گھنٹے یا منٹ",
    participantSeats: "شریک نشستیں",
    participant_seat: "شریک نشست",
    subjects: "مضامین",
    visible: "نظر آنے والا",
    hidden: "پوشیدہ",
    create_topic: "موضوع بنائیں",
    edit_topic: "موضوع میں ترمیم کریں۔",
    topicName: "موضوع کا نام",
    topicDescripiton: "موضوع کی تفصیل",
    public: "عوام",
    classDescription: "کلاس کی تفصیل",
    editNewClass: "کلاس میں ترمیم کریں۔",
    topics: "عنوانات",
    topicView: "موضوع دیکھیں",
    no_of_sessions_conducted: "منعقدہ سیشنز کی تعداد",
    no_of_students_attended_session:
      "طلباء کی تعداد آپ کے سیشن میں شریک نہیں ہوئی۔",
    yourAssignments: "آپ کی اسائنمنٹس",
    attendance: "حاضری",
    recent_topics: "حالیہ موضوعات",
    no_subjects: "ابھی تک کوئی مضامین نہیں بنائے گئے ہیں!",
    no_subjects_create:
      "اوپر دیے گئے موضوع بنائیں بٹن پر کلک کرکے ایک نیا مضمون بنائیں",
    no_topics: "ابھی تک کوئی عنوان نہیں بنایا گیا ہے!",
    no_topics_create:
      "اوپر دیے گئے Create Topic کے بٹن پر کلک کرکے ایک موضوع بنائیں",
    assgnlist_noassignments: "ابھی تک کوئی اسائنمنٹ تفویض نہیں کیا گیا ہے!",
    assgnlist_assign_new_assign:
      "اوپر دیے گئے اسائنمنٹ بٹن پر کلک کرنے کے لیے ایک نیا اسائنمنٹ تفویض کریں۔",
    start_date_time: "آغاز کی تاریخ اور وقت",
    end_date_time: "اختتامی تاریخ اور وقت",
    join_conference_quote:
      "سیشن میں شامل ہونے کے لیے، نیچے دیے گئے ان پٹ باکس میں سیشن ID فراہم کریں۔",
    edit_student: "طالب علم میں ترمیم کریں۔",
    editTeacher: "ٹیچر میں ترمیم کریں۔",
    subject_name: "موضوع کا نام",
    subject_description: "موضوع کی تفصیل",
    select_type: "قسم منتخب کریں۔",
    others: "دوسرے",
    Institute_name: "انسٹی ٹیوٹ کا نام",
    first_name_contact: "رابطہ کا پہلا نام",
    last_name_contact: "رابطہ کا آخری نام",
    institute_type: "انسٹی ٹیوٹ کی قسم",
    institute_name: "ادارے کا نام",
    contact_number: "رابطہ نمبر",
    signup_as_student: "طالب علم کے طور پر سائن اپ کریں۔",
    state: "حالت",
    city: "شہر",
    institute_name_error: "ادارے کا نام صرف حروف کا ہونا چاہیے۔",
    institute_type_error: "انسٹی ٹیوٹ کی قسم منتخب کی جانی چاہئے۔",
    address_error: "پتہ خاص حروف کو قبول کر سکتا ہے۔",
    student: "طالب علم",
    rowsPerPage: "قطار فی صفحہ",
    institute: "انسٹی ٹیوٹ",
    signUpas: "بطور سائن اپ کریں۔",
    submitted: "جمع کرایا",
    notSubmitted: "جمع نہیں ھوا",
    review: "جائزہ لیں",
    inReview: "نظرثانی میں",
    questionTitle: "سوال کا عنوان",
    questionDescription: "سوال کی تفصیل",
    questionnaireTitle: "سوال کا عنوان",
    started: "شروع",
    testName: "ٹیسٹ کا نام",
    timeTaken: "لیا گیا وقت",
    showAnswers: "جواب ظاہر کرو",
    downloadCertificate: "سرٹیفکیٹ ڈاؤن لوڈ کریں۔",
    startTime: "وقت آغاز",
    endTime: "اختتامی وقت",
    assignmentTitle: "تفویض کا عنوان",
    editor: "ایڈیٹر",
    upload: "اپ لوڈ کریں",
    save_submit: "محفوظ کریں اور جمع کرائیں۔",
    assigned_students: "تفویض شدہ طلباء",
    total_marks: "کل مارکس",
    not_yet_Submitted: "ابھی تک جمع نہیں کیا گیا۔",
    completed: "مکمل",
    due_date: "واجب الادا تاریخ",
    marks_obtained: "مارکس حاصل",
    assign_marks: "نشانات تفویض کریں۔",
    home_inclass_copyright: "© 2022 InstaVC Inc. All Rights Reserved",
    // "© 2022 InstaVC Inc. تمام حق محفوظ | کی طرف سے طاقت Peoplelink Uniified Communications Pvt. لمیٹڈ",
    back_to_classes: "کلاسز پر واپس جائیں۔",
    className: "کلاس کا نام",
    attendanceReports: "حاضری کی رپورٹس",
    present: "موجودہ",
    absent: "غیر حاضر",
    ratio: "تناسب",
    sessionsAttended: "سیشنز میں شرکت کی۔",
    totalSessions: "کل سیشنز",
    filters: "فلٹرز",
    teacher: "استاد",
    userType: "صارف کی قسم",
    class: "کلاس",
    clear: "صاف",
    sessionsConducted: "منعقدہ سیشنز",
    Topic: "موضوع",
    uploadMediaSizeLimit: "15MB تک سائز کی حد کے ساتھ۔",
    assessments: "تشخیصات",
    assessment: "تشخیص کے",
    totalStudents: "کل طلباء",
    totalAssignments: "کل اسائنمنٹس",
    assignmentsCompleted: "اسائنمنٹس مکمل ہو گئے۔",
    assignmentsPending: "اسائنمنٹس زیر التواء",
    score: "سکور",
    submittedDate: "جمع کرانے کی تاریخ",
    dueDateOfSubmission: "جمع کرانے کی آخری تاریخ",
    clearSelections: "انتخاب صاف کریں۔",
    noschedule_meetings: "آپ کے پاس کوئی آئندہ سیشن نہیں ہیں۔",
    nopast_meetings: "آپ کے پاس کوئی ماضی کے سیشن نہیں ہیں۔",
    id: "ID",
    export: "برآمد کریں۔",
    import: "درآمد کریں۔",
    sample_excel: "ایکسل کا نمونہ",
    subject_access: "موضوع تک رسائی",
    submitted_date_time: "جمع کرائی گئی تاریخ/وقت",
    passed: "پاس کیا۔",
    failed: "ناکام",
    average_score: "اوسط سکور",
    total_reviewed: "کل جائزہ لیا گیا۔",
    pending_review: "زیر التواء جائزہ",
    total_students_finished: "کل طلباء ختم",
    total_students_passed: "کل طلباء پاس ہوئے۔",
    total_students_failed: "کل طلباء فیل ہوئے۔",
    total_students_absent: "کل غیر حاضر طلباء",
    time_exceed: "وقت کی حد سے تجاوز کر گیا۔",
    time_exceed_assgn_msg:
      "اس اسائنمنٹ کو جمع کرانے کے لیے مقررہ وقت سے تجاوز کر گیا ہے۔",
    time_exceed_quess_msg:
      "اس سوالنامہ کو جمع کرانے کے لیے مقررہ وقت سے تجاوز کر گیا ہے۔",
    class_code: "کلاس کوڈ",
    subject_code: "سبجیکٹ کوڈ",
    create_new_passwd: "نیا پاس ورڈ بنائیں",
    please_enter_topic_name: "براہ کرم موضوع کا نام درج کریں۔",
    please_enter_topic_description: "براہ کرم موضوع کی تفصیل درج کریں۔",
    plz_select_questionary: "براہ کرم سوالیہ نشان منتخب کریں۔",
    plz_select_duration_checkbox: "براہ کرم وقت کی حد کا چیک باکس منتخب کریں۔",
    Plz_select_assignment: "براہ کرم اسائنمنٹ کو منتخب کریں۔",
    plz_select_valid_date_time: "براہ کرم درست تاریخ اور وقت منتخب کریں۔",
    Plz_enter_valid_marks: "براہ کرم درست نشانات درج کریں۔",
    Plz_enter_subject_title: "براہ کرم مضمون کا عنوان درج کریں۔",
    Plz_enter_subject_description: "براہ کرم موضوع کی تفصیل درج کریں۔",
    Plz_enter_subject_type: "براہ کرم مضمون کی قسم درج کریں۔",
    Plz_enter_subject_code: "براہ کرم موضوع کا کوڈ درج کریں۔",
    Plz_enter_valid_subject_code: "براہ کرم درست مضمون کا کوڈ درج کریں۔",
    Plz_enter_class_code: "براہ کرم کلاس کوڈ درج کریں۔",
    Plz_enter_valid_class_code: "براہ کرم درست کلاس کوڈ درج کریں۔",
    plz_enter: "درج کریں",
    Plz_enter_valid: "براہ کرم درست درج کریں۔",
    Plz_enter_title: "براہ کرم عنوان درج کریں۔",
    Plz_enter_description: "براہ کرم تفصیل درج کریں۔",
    Plz_select_class: "براہ کرم کلاس منتخب کریں۔",
    Plz_select_subject: "براہ کرم موضوع منتخب کریں۔",
    actions: "اعمال",
    enroll: "اندراج کریں۔",
    something_went_wrong: "کچھ غلط ہو گیا.",
    data_is_not_selected: "ڈیٹا منتخب نہیں کیا گیا ہے۔",
    data_added_successfully: "ڈیٹا کامیابی سے شامل ہو گیا۔",
    plz_enter_question: "براہ کرم سوال درج کریں۔",
    plz_enter_marks: "براہ کرم مارکس درج کریں۔",
    Plz_select_type: "براہ کرم قسم منتخب کریں۔",
    opt_should_have_minimum: "اختیارات کم از کم 2 ہونے چاہئیں",
    opt_should_not_empty: "اختیارات خالی نہیں ہونے چاہئیں",
    opt_should_not_duplicate: "اختیارات کو نقل نہیں کرنا چاہئے۔",
    plz_select_the_answer: "براہ کرم جواب منتخب کریں۔",
    question_updated_successfully: "سوال کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔",
    question_created_successfully: "سوال کامیابی سے بنایا گیا۔",
    marks_less_than_total_marks: "درج کردہ نمبر کل نمبروں سے کم ہونے چاہئیں",
    marks_not_negative: "نشانات منفی میں نہیں ہونے چاہئیں",
    assgn_successfully_verifed: "اسائنمنٹ محفوظ کی کامیابی سے تصدیق ہو گئی۔",
    assgn_save_submited_succes:
      "اسائنمنٹ محفوظ اور کامیابی کے ساتھ جمع کرایا گیا۔",
    assgn_save_succes: "اسائنمنٹ کامیابی سے محفوظ ہو گئی۔",
    Plz_enter_valid_content: "براہ کرم درست مواد درج کریں۔",
    Assgn_updated_success: "اسائنمنٹ کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔",
    Assgn_created_success: "اسائنمنٹ کامیابی کے ساتھ تیار ہو گیا۔",
    Assgn_assigned_success: "اسائنمنٹ کامیابی کے ساتھ تفویض کر دیا گیا۔",
    Assgn_disabled_success: "اسائنمنٹ کو کامیابی سے غیر فعال کر دیا گیا۔",
    Assgn_enabled_success: "اسائنمنٹ کامیابی کے ساتھ فعال ہو گیا۔",
    Assgn_deleted_success: "اسائنمنٹ کامیابی کے ساتھ حذف ہو گئی۔",
    Quest_creat_success: "سوالنامہ کامیابی کے ساتھ بنایا گیا۔",
    Quest_updated_success: "سوالنامہ کامیابی سے اپ ڈیٹ ہو گیا۔",
    Poll_created_success: "پول کامیابی کے ساتھ بنایا گیا۔",
    Poll_updated_success: "پول کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔",
    opt_minimum: "اختیارات میں کم از کم 2 اختیارات ہونے چاہئیں",
    Poll_deleted_success: "پول کامیابی کے ساتھ حذف ہو گیا۔",
    Poll_enabled_success: "پولنگ کامیابی سے فعال ہو گئی۔",
    Poll_disabled_success: "پولنگ کو کامیابی سے غیر فعال کر دیا گیا۔",
    Quest_deleted_success: "سوال کامیابی کے ساتھ حذف کر دیا گیا۔",
    Invit_send_success: "دعوت نامہ کامیابی سے بھیج دیا گیا۔",
    teacher_deleted_success: "استاد کو کامیابی سے حذف کر دیا گیا۔",
    error_some_thing_went_wrong: "خرابی، کچھ غلط ہو گیا۔",
    user_updated_success: "صارف کی حیثیت کامیابی کے ساتھ اپ ڈیٹ ہو گئی۔",
    teacher_updated_success: "استاد کو کامیابی سے اپ ڈیٹ کر دیا گیا۔",
    student_remove_success: "طالب علم کو کامیابی سے ہٹا دیا گیا۔",
    teachers_created_success: "اساتذہ کامیابی کے ساتھ بنائے گئے۔",
    error_occured_try_again: "ایک خرابی پیش آگئی، دوبارہ کوشش کریں!",
    please_select_less: "براہ کرم 15MB فائل سائز سے کم منتخب کریں۔",
    submit_success: "کامیابی کے ساتھ جمع کرایا گیا۔",
    grad_updat_success: "گریڈز کی اپ ڈیٹس کامیابی کے ساتھ",
    Quest_delet_succes: "سوالنامہ کامیابی سے حذف کر دیا گیا۔",
    Quest_disab_succes: "سوالنامہ کامیابی سے غیر فعال کر دیا گیا۔",
    Quest_enabled_succes: "سوالنامہ کامیابی سے فعال ہو گیا۔",
    student_add_succes: "طالب علم کامیابی کے ساتھ شامل ہو گیا۔",
    plz_select_atleast_std: "براہ کرم کم از کم 1 طالب علم منتخب کریں۔",
    fail_add_some_student: "کچھ طلباء کو شامل کرنے میں ناکام",
    std_add_succes: "طلباء کامیابی کے ساتھ شامل ہو گئے۔",
    sub_updat_succes: "موضوع کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔",
    sub_creat_succes: "موضوع کامیابی کے ساتھ بنایا گیا۔",
    sub_dlt_succes: "موضوع کامیابی سے حذف ہو گیا۔",
    sub_enabl_succes: "موضوع کامیابی کے ساتھ فعال ہو گیا۔",
    sub_disab_succes: "موضوع کامیابی کے ساتھ غیر فعال ہو گیا۔",
    tchr_add_success: "استاد کو کامیابی کے ساتھ شامل کیا گیا۔",
    plz_slc_atlst_tchr: "براہ کرم کم از کم 1 استاد منتخب کریں۔",
    tchr_remo_success: "استاد کو کامیابی سے ہٹا دیا گیا۔",
    plz_etr_valid_duration: "براہ کرم درست دورانیہ درج کریں۔",
    topic_updat_success: "موضوع کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔",
    class_dlt_success: "کلاس کامیابی کے ساتھ حذف ہو گئی۔",
    class_upt_succes: "کلاس کامیابی کے ساتھ اپ ڈیٹ ہو گئی۔",
    class_creat_succes: "کلاس کامیابی کے ساتھ بنائی گئی۔",
    plz_select_quest: "براہ کرم سوالنامہ منتخب کریں۔",
    first_add_data: "ڈیٹا شامل کرنے کے لیے پلس بٹن پر کلک کریں۔",
    certfct_generat_success: "سرٹیفکیٹ کامیابی کے ساتھ تیار ہو گیا۔",
    plz_select_min_seats: "براہ کرم کم سے کم 2 نشستیں منتخب کریں۔",
    plz_enter_mtng_name: "براہ کرم سیشن کا نام درج کریں۔",
    fail_to_updt_mtng_try_again:
      "سیشن کو اپ ڈیٹ کرنے میں ناکام! دوبارہ کوشش کریں",
    fail_update_scdle: "شیڈول اپ ڈیٹ کرنے میں ناکام",
    std_delet_success: "طالب علم کو کامیابی سے حذف کر دیا گیا۔",
    std_updat_succes: "طالب علم کو کامیابی کے ساتھ اپ ڈیٹ کر دیا گیا۔",
    std_creat_succes: "طالب علم کو کامیابی کے ساتھ بنایا گیا۔",
    fail_create_some_std: "کچھ طلباء کو بنانے میں ناکام",
    std_creat_success: "طلباء نے کامیابی سے تخلیق کی۔",
    tchr_creat_succes: "استاد کو کامیابی کے ساتھ بنایا گیا۔",
    fail_crt_some_user: "کچھ صارفین بنانے میں ناکام",
    fail_create_mtg_try_again: "سیشن بنانے میں ناکام! دوبارہ کوشش کریں",
    fail_create_schedu: "شیڈول بنانے میں ناکام",
    plz_enter_metng_title: "براہ کرم سیشن کا عنوان درج کریں۔",
    invalid_phn_nmb: "غلط فون نمبر",
    plz_enter_phn_num: "براہ کرم فون نمبر درج کریں۔",
    topic_crt_succes: "موضوع کامیابی کے ساتھ بنایا گیا۔",
    topic_enabled_succes: "موضوع کامیابی کے ساتھ فعال ہو گیا۔",
    topic_disabl_success: "موضوع کو کامیابی کے ساتھ غیر فعال کر دیا گیا۔",
    topic_delet_success: "موضوع کامیابی سے حذف ہو گیا۔",
    Media_delet_success: "میڈیا کامیابی سے حذف ہو گیا۔",
    plz_enter_title_upload_doc:
      "براہ کرم پہلے عنوان درج کریں اور دستاویز اپ لوڈ کریں۔",
    doc_add_succes: "دستاویز کامیابی کے ساتھ شامل کر دی گئی۔",
    plz_fst_ent_title_and_media:
      "براہ کرم پہلے عنوان درج کریں اور میڈیا فائل درج کریں۔",
    media_add_success: "میڈیا کامیابی کے ساتھ شامل ہو گیا۔",
    plz_first_title_and_URL:
      "براہ کرم پہلے عنوان درج کریں اور میڈیا URL درج کریں۔",
    plz_etr_valid_url: "براہ کرم درست url درج کریں۔",
    generate: "پیدا کریں۔",
    issue_cert: "سرٹیفکیٹ جاری کریں۔",
    total_score: "مجموعی سکور",
    created_by: "بنائی گئی",
    certificate: "سرٹیفیکیٹ",
    not_completed: "نامکمل",
    view_cert: "سرٹیفکیٹ دیکھیں",
    issue_certificate: "سرٹیفکیٹ جاری کریں۔",
    issue_date: "تاریخ اجرا",
    note_edit_and_delete_txt:
      "نوٹ: ترمیم اور حذف کے بٹن ٹیسٹ سے 10 منٹ پہلے چھپے رہیں گے۔",
    verify_email_msg: "تصدیقی کوڈ کے لیے براہ کرم اپنا ای میل چیک کریں۔",
    start_time_greater_currnt_time:
      "آغاز کا وقت موجودہ وقت کے بعد 10 منٹ سے زیادہ ہونا چاہیے۔",

    copi_to_clipboard: "کلپ بورڈ پر کاپی ہو گیا!",
    host_msg: "میزبان",
    date_time: "تاریخ وقت",
    invities: "تاریخ وقت",
    no_chat_history_avai: "چیٹ کی کوئی سرگزشت دستیاب نہیں ہے۔",
    no_feedbacks_avai: "کوئی فیڈ بیک دستیاب نہیں ہے۔",
    no_invities_list_avai: "کوئی مدعو کرنے والوں کی فہرست دستیاب نہیں ہے۔",
    no_conference_note_avai: "کوئی کانفرنس نوٹس دستیاب نہیں ہے۔",
    total_notes: "کل نوٹ (15)",
    view_log_history: "لاگ ہسٹری دیکھیں",
    total_duration: "کل دورانیہ:",
    min: "کم از کم",
    total_time_spent: "کل وقت گزارا:",
    entry: "داخلہ",
    exit: "باہر نکلیں",
    time_spent: "وقت گزارا۔",
    no_conference_recording_avai: "کانفرنس کی کوئی ریکارڈنگ دستیاب نہیں ہے۔",
    no_meetings: "کوئی سیشن نہیں!",
    this_brow_dont_support_video_tag:
      "یہ براؤزر ویڈیو ٹیگ کو سپورٹ نہیں کرتا ہے۔",
    no_participants_list_avai: "کوئی شرکاء کی فہرست دستیاب نہیں ہے۔",
    total_number_session: "سیشنز کی کل تعداد",
    start_date: "شروع کرنے کی تاریخ:",
    join_mtg_provide_id_below_input:
      "سیشن میں شامل ہونے کے لیے، نیچے دیے گئے ان پٹ باکس میں سیشن ID فراہم کریں۔",
    You_enter_inva_meet: "آپ نے ایک غلط سیشن ID درج کی ہے۔",
    no_ques_creat_yet: "ابھی تک کوئی سوالنامہ نہیں بنایا گیا!",
    creat_quest_click_creat:
      "سوالنامہ تخلیق کریں بٹن پر کلک کرکے سوالنامہ بنائیں۔",
    only_invit_can_join: "صرف مدعو ہی شامل ہو سکتے ہیں۔",
    invc_login_mandato: "inVC لاگ ان لازمی",
    training_mode: "ٹریننگ موڈ",
    audio_only_mode: "صرف آڈیو موڈ",
    mute_parti_upon_entry: "داخلے پر شرکاء کو خاموش کریں۔",
    join_before_host: "میزبان سے پہلے شامل ہوں۔",
    enable_breakout_session: "بریک آؤٹ سیشنز کو فعال کریں۔",
    anonymous_access: "گمنام رسائی",
    send_invite: "دعوت نامہ بھیجیں۔",
    add_part_email_address_mobil_msg:
      "شرکاء کو ان کا ای میل ایڈریس یا موبائل نمبر شامل کرکے شامل کریں، متعدد اندراجات کے لیے انٹر دبائیں۔",
    add_email_mobile: "موبائل نمبر شامل کریں۔",
    make_sure_the_msg:
      "1 - یقینی بنائیں کہ موبائل نمبر کنٹری کوڈ کے ساتھ ہونا چاہیے (مثال کے طور پر: +91-99XXXXXXXXX)",
    email_id_note:
      "1 - ای میل آئی ڈی چھوٹے حروف میں ہونی چاہیے (مثال کے طور پر username@xxx.com)",
    meet_before_schedul_time:
      "آپ مقررہ وقت سے پہلے اس سیشن میں شامل نہیں ہو سکتے۔",
    go_to_dashboard: "ڈیش بورڈ پر جائیں",
    if_you_are_host_msg:
      "اگر آپ میزبان ہیں تو براہ کرم اپنے ڈیش بورڈ سے ایک اور فوری سیشن شروع کریں۔",
    this_meet_expir_on: "اس سیشن کی میعاد ختم ہو گئی ہے۔",
    this_meet_link__expired: "اس سیشن کے لنک کی میعاد ختم ہو چکی ہے۔",
    this_meet_schedul_for: "اس سیشن کے لیے شیڈول کیا گیا ہے۔",
    meet_min_before_schedule_time:
      "آپ مقررہ وقت سے 5 منٹ پہلے اس سیشن میں شامل ہو سکتے ہیں۔",
    this_assign_start_yet: "اس اسائنمنٹ کا وقت ابھی شروع نہیں ہوا...",
    time_not_yet_start: "وقت ابھی شروع نہیں ہوا۔",
    field_once_generat_cannot_edit:
      "براہ کرم تمام فیلڈز کو چیک کریں ایک بار تیار ہونے پر ترمیم نہیں کی جا سکتی",
    certificate_title: "سرٹیفکیٹ کا عنوان",
    invalid_meet_code: "غلط سیشن کوڈ",
    meeting_id_below_input_box:
      "سیشن میں شامل ہونے اور اسکرین کو شیئر کرنے کے لیے، نیچے دیے گئے ان پٹ باکس میں سیشن ID فراہم کریں۔",
    meeting_configuration: "سیشن کنفیگریشن",
    room_participant_limit_exceed:
      "کمرے میں شرکت کرنے والوں کی حد سے تجاوز کر گیا۔",
    only_audio_call_auto_mute_enabl: "صرف آڈیو کال اور آٹو میوٹ فعال ہے۔",
    you_audio_video_mute: "آپ کا آڈیو اور ویڈیو بند ہے۔!",
    only_audio_call: "صرف آڈیو کال",
    your_video_mute: "آپ کی ویڈیو بند ہے۔!",
    your_name: "تمھارا نام",
    ok_you_r_ready: "ٹھیک ہے، آپ تیار ہیں",
    room_empty_meeting_wait_until_host_join:
      "کمرہ خالی ہے! آپ سیشن شروع کرنے کے لیے لاگ ان کر سکتے ہیں یا میزبان کے شامل ہونے تک انتظار کر سکتے ہیں۔",
    room_lock_hang_until_somebody_lets:
      "کمرہ مقفل ہے - اس وقت تک انتظار کریں جب تک کہ کوئی آپ کو اندر جانے نہ دے...",
    your_audio_is_muted: "آپ کا آڈیو خاموش ہے!",
    view_assignment: "اسائنمنٹ دیکھیں",
    assigned_assignment: "تفویض کردہ اسائنمنٹ",
    attempte_assignment_written_anything:
      "آپ نے اسائنمنٹ کی کوشش کی ہے لیکن اس میں کچھ نہیں لکھا۔",
    Marks_not_alloted: "نشانات کی اجازت نہیں ہے۔",
    view_questionnaire: "سوالنامہ دیکھیں",
    assign_questionnaire_list: "سوالنامے کی فہرست تفویض کریں۔",
    assign_assignment: "اسائنمنٹ لسٹ تفویض کریں۔",
    type: "قسم",
    class_description: "کلاس کی تفصیل",
    password_updated: "پاس ورڈ اپ ڈیٹ ہو گیا!",
    numberOfLicense: "لائسنس کی تعداد",
    your_test: "طلباء کی فہرست",
    unattended_incomplete_Questionaire_txt_msg:
      "کچھ وجوہات کی وجہ سے غیر حاضر یا نامکمل تھا۔ اس لیے سکور کارڈ نہیں بن سکا",
    Assgnmnt_time_not_started: "اسائنمنٹ کا وقت ابھی شروع نہیں ہوا...",
    submitted_cnt: "جمع کردہ مواد",
    stud_list: "طلباء کی فہرست",
    test_submitted_successfully: "آپ کا ٹیسٹ کامیابی کے ساتھ جمع کرایا گیا ہے۔",
    score_time_finished_successfully:
      "وقت ختم ہونے کے بعد اسکور ظاہر کیا جائے گا۔",
    topic: "موضوع",
    del_poll: "پولنگ",
    std: "طالب علم",
    profile: "پروفائل",
    topics_list: "عنوانات کی فہرست",
    upload_highResImg: "صرف ہائی ریزولوشن والی تصاویر اپ لوڈ کریں۔",
    meetingList_upcoming_meetings: "آنے والے سیشنز",
    subject_list: "موضوع کی فہرست",
    plz_enter_valid_number_license: "براہ کرم لائسنس کا درست نمبر درج کریں۔",
    no_class_assigned: "کوئی کلاس تفویض نہیں کی گئی ہے۔",
    class_list: "کلاس کی فہرست",
    plz_fill_all_details: "براہ کرم تمام تفصیلات پُر کریں۔",
    plz_click_upload_media_url: "براہ کرم اپ لوڈ میڈیا یو آر ایل پر کلک کریں۔",
    please_enter_msg: "Please Enter",
    Media_msg: "میڈیا۔",
    media_url: "میڈیا یو آر ایل۔",
    title: "عنوان",
    and_msg: "اور",
    wrong_answer: "غلط جواب",
    right_answer: "صحیح جواب",
    User_list: "صارفین کی فہرست",
    questionaire_time_not_yet_start: "سوالنامہ کا وقت ابھی شروع نہیں ہوا...",
    submitted_list: "جمع کرائی گئی فہرست",
    search_by_name: "نام سے تلاش کریں۔",
    scheduleDate: "شیڈول کی تاریخ",
    view_all: "سب دیکھیں",
    view_card: "کارڈ دیکھیں",
    confirm_submit: "کیا آپ واقعی اسائنمنٹ جمع کروانا چاہتے ہیں؟",
    confirm_finish: "کیا آپ واقعی ٹیسٹ مکمل کرنا چاہتے ہیں؟",
    questionaire: "سوالنامہ",
    list_of_questns_for_above_questionaire:
      "مندرجہ بالا سوالنامے کے لیے تفویض کردہ سوالات کی فہرست ذیل میں دی گئی ہے۔",
    view_all_assignments: "تمام اسائنمنٹس دیکھیں",
    action: "عمل",
    start_dte: "شروع کرنے کی تاریخ",
    subject: "مضمون",
    digital_file_upload_and_digital_signature:
      "یہاں اپ لوڈ کردہ ڈیجیٹل فائلیں طلباء کو جاری کردہ ڈیجیٹل سرٹیفکیٹس پر ظاہر ہوں گی۔",
    upload_logo: "لوگو اپ لوڈ کریں۔",
    upload_signature: "دستخط اپ لوڈ کریں۔e",
    upload_stamp: "ڈاک ٹکٹ اپ لوڈ کریں",
    drag_and_drop_file: "اپنی فائل کو یہاں گھسیٹیں اور چھوڑیں یا",
    max_file_mb_dimensions: "زیادہ سے زیادہ فائل سائز 20MB ابعاد",
    note_assgn_qusnr_text:
      "نوٹ *: اسائنمنٹ شروع ہونے سے 10 منٹ پہلے تک آپ اپنے اندراجات میں ترمیم یا حذف نہیں کر سکیں گے۔",
    note_qusnr_text:
      "نوٹ *: آپ سوالنامہ شروع ہونے سے 10 منٹ پہلے تک اپنے اندراجات میں ترمیم یا حذف نہیں کر سکیں گے۔",
    not_attended: "حاضر نہیں ہوا۔",
    not_started: "شروع نہیں کیا",
    dont_have_stu_acc: "طالب علم کا اکاؤنٹ نہیں ہے۔",
    buy_more: "زیادہ خریدیں",
    product: "پروڈکٹ",
    no_subject_assigned: "کوئی مضامین تفویض نہیں کیے گئے ہیں۔",
    logo: "لوگو",
    stamp: "ڈاک ٹکٹ",
    signature: "دستخط",
    uploaded_successfully: "کامیابی سے اپ لوڈ ہو گیا۔",
    renewal: "تجدید",
    domain_name: "سب ڈومین نام",
    pls_sel_frequency:
      "براہ کرم منتخب کریں کہ آپ ہفتے کا کون سا دن شیڈول کرنا چاہتے ہیں۔",
    your_test_successfully_submitted:
      "آپ کا ٹیسٹ کامیابی سے جمع کر دیا گیا ہے۔",
    score_will_finished: "وقت ختم ہونے کے بعد اسکور ظاہر کیا جائے گا۔",
    license_expired: "لائسنس کی میعاد ختم",
    application_longer_accessed_since__license_expired:
      "آپ کے لائسنس کی میعاد ختم ہونے کے بعد درخواست تک مزید رسائی حاصل نہیں کی جا سکتی ہے۔ رسائی کو دوبارہ فعال کرنے کے لیے،",
    respective_admin_license_renewal:
      "براہ کرم لائسنس کی تجدید کے لیے اپنے متعلقہ منتظم سے رابطہ کریں۔",
    okay: " ٹھیک ہے",
    delete_recurring_schedule: "بار بار چلنے والے شیڈول کو حذف کریں۔",
    are_you_sure_delete_recurring_schedule:
      "کیا آپ واقعی اس اعادی شیڈول کو حذف کرنا چاہتے ہیں؟",
    delete_all_recurring_days_completely:
      "تمام بار بار آنے والے دنوں کو مکمل طور پر حذف کریں۔",
    will_eleminate_all_selected: "شیڈول سے تمام منتخب دنوں کو ختم کر دے گا۔",
    remove_only_selected_days: "صرف منتخب دنوں کو ہٹا دیں۔",
    delete_selected_days_schedule:
      "اس سے شیڈول سے صرف منتخب دن حذف ہو جائیں گے۔",
    recurring_dates: "بار بار چلنے والی تاریخیں۔",
    enter_the_coupon_code: "کوپن کوڈ درج کریں۔",
    coupon_applied: "کوپن لاگو کر دیا گیا۔",
    coupon_id: "کوپن آئی ڈی",
    del_recurring_by_dates:
      "سیشن کا کون سا دن منتخب کریں جسے آپ حذف کرنا چاہتے ہیں۔",
    more_details: "مزید تفصیلات",
    removeStudentUser: "کیا آپ واقعی اس طالب علم کو ہٹانا چاہتے ہیں؟",
    removeTeacherUser: "کیا آپ واقعی اس استاد کو ہٹانا چاہتے ہیں؟?",
    sure_you_want_to_delete: "کیا آپ کو یقین ہے کہ آپ اسے حذف کرنا چاہتے ہیں۔",
    deleting_information_database: "اسے حذف کرنے سے ڈیٹا بیس سے تمام معلومات مٹ جائیں گی۔",
    to_confirm_type: "قسم کی تصدیق کرنے کے لیے",
    name_not_matched: "نام مماثل نہیں",
    confirm_this_type: "اس کی تصدیق کرنے کے لیے، ٹائپ کریں۔",
    topic_title: "موضوع کا عنوان",
    select: "منتخب کریں۔",
    plz_enter_integers: "براہ کرم صرف عددی اقدار درج کریں۔",
    your_details: "آپ کی تفصیلات",
    order_summary: "حکم کا خلاصہ",
    licence_cost: "لائسنس کی لاگت",
    taxes: "ٹیکس",
    order_total: "ٹوٹل آرڈر",
    coupon_discount: "کوپن ڈسکاؤنٹ",
    estimated_total: "تخمینی کل",
    place_your_order_now: "ابھی اپنا آرڈر دیں!",
    we_email_message: "جب آپ آرڈر دیتے ہیں تو ہم آپ کو ایک ای میل پیغام بھیجیں گے جس میں آپ کے آرڈر کی وصولی کو تسلیم کیا جائے گا۔",
    issued_by: "جاری کردہ",
    account_del_succ: "اکاؤنٹ کامیابی کے ساتھ حذف ہو گیا۔",
    remove_account: "اکاؤنٹ کو ہٹا دیں۔",
    conf_remove_account_msg: "کیا آپ واقعی اپنا اکاؤنٹ ہٹانا چاہتے ہیں؟",
    courses: "کورسز",
    instavc_myprofile_fullName: "پورا نام",
    help_Center:"مدداور تعاون کا مرکز",
    please_enter_domain_name:"براہ کرم ڈومین کا نام درج کریں۔",
    domain_name_should :"ڈومین کا نام خالی حروف، بڑے حروف، نمبر یا خصوصی حروف کے بغیر چھوٹے حروف میں ہونا چاہیے",
    please_enter_confirm_password:"براہ کرم تصدیقی پاس ورڈ درج کریں۔",
    password_should_minimum_character_capital_letter :"پاس ورڈ آٹھ حروف لمبا ہونا چاہیے اور ایک بڑے، ایک چھوٹے، ایک ہندسہ اور ایک خاص حرف کا مجموعہ ہونا چاہیے۔",
    password_and_Confirm_password_must_be_same:"پاس ورڈ اور کنفرم پاس ورڈ ایک جیسا ہونا چاہیے۔",
    domain_already_exists:"ڈومین پہلے سے موجود ہے۔",
    check:'اگر آپ آگے بڑھنا چاہتے ہیں تو براہ کرم اس باکس پر نشان لگائیں۔',
    institute_created_successfully:"انسٹی ٹیوٹ کامیابی کے ساتھ بنایا گیا۔",
    institute_selection_error: "براہ کرم انسٹی ٹیوٹ کا مناسب نام منتخب کریں۔",
    assignment_teac_desc:"مندرجہ بالا تفویض کے لیے تفویض کردہ سوالات کی فہرست ذیل میں دی گئی ہے۔",
    update_question: "سوال کو اپ ڈیٹ کریں۔",
    no_sub_text: "کوئی مضامین نہیں ہیں۔",
    marks_error_msg:"نمبر 100 سے کم یا اس کے برابر ہونے چاہئیں",
    total_marks_obtained:"حاصل کردہ کل نمبر",
    question_text:"سوالات:",
    no_question_text:"کوئی سوال نہیں ہے۔",
    uploaded_media_files:"اپ لوڈ کردہ میڈیا",
    ans_verified_text:"تمام جوابات تصدیق شدہ ہیں!! براہ کرم اسائنمنٹ کی تصدیق کریں۔",
    confirm_verification:"تصدیق کی تصدیق کریں۔",
    dlt_cnfm_text:"کیا آپ واقعی ڈیلی کرنا چاہتے ہیں!!!",
    no_ans:"کوئی جواب نہیں",
    no_ans_cnfm_text:"طالب علم نے کچھ بھی جمع نہیں کیا",
    verify_assnmt:"اسائنمنٹ کی تصدیق کریں۔",
    verify_qtn:"سوال کی تصدیق کریں۔",
    privacy_policy_join_meeting :"By joining this meeting, you agree that you are above 10 years of age & agree to our",
    privacy_policy_join_meeting_text1:"Privacy Policy",
    privacy_policy_join_meeting_text2:"Terms of Use"
  },
};
